import { CodebookEnum } from '@src/components/codebook/view/SuperAdminCodebookListView';
import { CourseStatusEnum } from '@src/model/course/Course';
import { FileTypeEnum } from '@src/model/file/FileType';
import { ProgressTrackerStatusEnum } from '@src/model/progresstracker/ProgressTracker';
import { DataErrorEnum, TimunImportUserErrorEnum } from '@src/model/user/InvalidUsers';
import { ResidenceTypeEnum } from '@src/model/user/ResidenceAddress';

const hr: any = {
  // ---------- Template labels
  'MODULE.LABEL_NAME': 'Template for adding labels',

  // ---------- Application
  'APPLICATION.APP_DESCRIPTION_MADE_WITH': 'Made with',
  'APPLICATION.APP_DESCRIPTION_MADE_BY': 'by Lamaro digital',

  'APPLICATION.UNSUPPORTED_BROWSER.BROWSER_OUT_OF_DATE': 'Koristite staru verziju internet preglednika',
  'APPLICATION.UNSUPPORTED_BROWSER.BROWSER_UNSUPPORTED': 'Vaš internet preglednik nije podržan',
  'APPLICATION.UNSUPPORTED_BROWSER.PC_MESSAGE': 'Molimo nadogradite verziju Vašeg internet preglednika',
  'APPLICATION.UNSUPPORTED_BROWSER.ANDROID_STORE_MESSAGE': 'Molimo instalirajte noviji preglednik s trgovine Google Play',
  'APPLICATION.UNSUPPORTED_BROWSER.IOS_STORE_MESSAGE': 'Molimo ažurirajte iOS kroz korisničke postavke',
  'APPLICATION.UNSUPPORTED_BROWSER.UPDATE_ACTION_BUTTON': 'Nadogradi moj preglednik sada',

  // ---------- COMMON ACTIONS
  'COMMON.ACTION_SAVE': 'Spremi',
  'COMMON.ACTION_EDIT': 'Uredi',
  'COMMON.ACTION_OK': 'OK',
  'COMMON.ACTION_YES': 'Da',
  'COMMON.ACTION_NO': 'Ne',
  'COMMON.ACTION_CANCEL': 'Odustani',
  'COMMON.ACTION_PREVIEW': 'Pregledajte',
  'COMMON.ACTION_ADD': 'Dodajte',
  'COMMON.ACTION_ADD_FROM_PC': 'Dodaj s računala',
  'COMMON.ACTION_ADD_NEW': 'Dodaj novi',
  'COMMON.ACTION_ADD_FILE': 'Dodaj dokument',
  'COMMON.ACTION_SEARCH': 'Traži',
  'COMMON.ACTION_LOGOUT': 'Odjavite se',
  'COMMON.ACTION_LOAD_MORE_ITEMS': 'Prikaži više',
  'COMMON.ACTION_LOAD_ALL': 'Prikaži sve',
  'COMMON.ACTION_CLOSE': 'Zatvori',
  'COMMON.ACTION_SHOW': 'Prikaži',
  'COMMON.ACTION_SHOW_MORE_CONTENT': 'prikaži više',
  'COMMON.ACTION_SHOW_LESS_CONTENT': 'sakrij',
  'COMMON.ACTION_DEACTIVATE': 'Deaktiviraj',
  'COMMON.ACTION_ACTIVATE': 'Aktiviraj',
  'COMMON.ACTION_DELETE': 'Obriši',
  'COMMON.ACTION_DOWNLOAD': 'Preuzmi',
  'COMMON.ACTION_CLEAR': 'Očisti',
  'COMMON.ACTION_CONTINUE': 'Nastavi',
  'COMMON.ACTION_DONE': 'Gotovo',
  'COMMON.ACTION_SORT_LABEL': 'Poredak',
  'COMMON.ACTION_SORT_ASCEND': 'Abecedno silazno',
  'COMMON.ACTION_SORT_DESCEND': 'Abecedno uzlazno',
  'COMMON.ACTION_SORT_NEWEST': 'Od najnovijeg',
  'COMMON.ACTION_SORT_OLDEST': 'Od najstarijeg',
  'COMMON.ACTION_SORT_CREATED_NEWEST': 'Od najnovijeg kreiranog',
  'COMMON.ACTION_SORT_CREATED_OLDEST': 'Od najstarijeg kreiranog',
  'COMMON.ACTION_SORT_SUBMITTED_NEWEST': 'Od najnovijeg podnesenog',
  'COMMON.ACTION_SORT_SUBMITTED_OLDEST': 'Od najstarijeg podnesenog',
  'COMMON.ACTION_APPROVE': 'Odobri',
  'COMMON.ACTION_REJECT': 'Odbij',
  'COMMON.ACTION_ADD_VIDEO': 'Novi video',
  'COMMON.ACTION_BACK': 'Povratak',
  'COMMON.ACTION_FILTER': 'Filtriraj',
  'COMMON.ACTION_RESET_FILTER': 'Poništi sve filtere',
  'COMMON.ACTION_RESET': 'Poništi',
  'COMMON.ACTION_ENROLL': 'Upiši se',
  'COMMON.ACTION_SELECT': 'Odaberite',
  'COMMON.ACTION_DISCARD': 'Odbaci',
  'COMMON.ACTION_CREATE_NEW': 'Stvori novi - (%{input})',
  'COMMON.EDITED_MESSAGE': 'Promjene spremljene',
  'COMMON.ACTION_SEND_INQUIRY': 'Pošaljite upit',
  'COMMON.ACTION_SELECT_ALL': 'Označi sve',
  'COMMON.ACTION_DESELECT_ALL': 'Odznači sve',

  // ----- confirmation
  'COMMON.CONFIRMATION_TITLE': 'Jeste li sigurni?',
  'COMMON.CONFIRMATION_DELETE_TITLE': 'Jeste li sigurni da želite obrisati?',
  'COMMON.CONFIRMATION_ITEM_DELETE_TITLE': 'Jeste li sigurni da želite obrisati "%{title}"?',
  'COMMON.CONFIRMATION_ROUTE_NAVIGATION': 'Jeste li sigurni da želite napustiti stranicu? Promjene neće biti spremljene.',
  'COMMON.CONFIRMATION_CANCEL_ACTION_MESSAGE': 'Jeste li sigurni da želite odustati? Promjene neće biti spremljene.',

  // ----- validation
  'COMMON.CONFIRM_DELETE_MESSAGE': 'Jeste li sigurni da želite obrisati?',
  'COMMON.FILL_REQUIRED_FIELD': 'Popunite obavezan podatak',
  'COMMON.PICK_REQUIRED_FIELD': 'Odaberite obaveznu vrijednost',
  'COMMON.ENTERED_VALUE_NOT_VALID': 'Pogrešan unos',
  // --- (new) validation messages
  'COMMON.VALIDATION.REQUIRED': 'Polje je obavezno',
  'COMMON.VALIDATION.INVALID': 'Neispravan unos',
  'COMMON.VALIDATION.INVALID_DECIMAL': 'Decimalni broj nije ispravan',
  'COMMON.VALIDATION.INVALID_INTEGER': 'Broj nije ispravan',
  'COMMON.VALIDATION.INVALID_DATETIME': 'Datum i/ili vrijeme nije ispravan',
  'COMMON.VALIDATION.INVALID_EMAIL': 'Neispravna e-mail adresa',
  'COMMON.MESSAGE_NO_DATA': 'Nema podataka',
  'COMMON.MESSAGE_NO_MATCH': 'Nema podudaranja',
  'COMMON.VALIDATION.INVALID_OIB': 'OIB nije ispravan',
  'COMMON.VALIDATION.INVALID_IBAN': 'IBAN nije ispravan',
  'COMMON.VALIDATION.MAX_FIELDS_ADDED': 'Dodali ste maksimalan broj polja za unos',
  'COMMON.VALIDATION.MIN_FIELDS_REQUIRED': 'Molimo da dodate traženo polje. Minimalan broj potrebnih polja za unos %{minFieldNumber}',
  'COMMON.VALIDATION.INVALID_EXTERNAL_LINK': 'Poveznica bi trebala sadržavati https:// ili http://',
  'COMMON.VALIDATION.CHECKBOX_REQUREID': 'Obavezan potvrdni okvir',

  // ----- Common labels
  'COMMON.LABEL.NAME': 'Naziv',
  'COMMON.LABEL.STATUS': 'Status',
  'COMMON.LABEL.ACTIVE': 'Aktivno',
  'COMMON.LABEL.INACTIVE': 'Neaktivno',
  'COMMON.LABEL.EMAIL': 'E-mail',
  'COMMON.LABEL.PHONE': 'Telefon',
  'COMMON.PLACEHOLDER.EMAIL': 'Unesite e-mail adresu',
  'COMMON.PLACEHOLDER.PHONE': 'Unesite broj telefona ili mobitela',
  'COMMON.LABEL.YES': 'Da',
  'COMMON.LABEL.NO': 'Ne',
  'COMMON.LABEL.BOOLEAN_TRUE': 'Da',
  'COMMON.LABEL.BOOLEAN_FALSE': 'Ne',
  'COMMON.LABEL.FILES': 'Datoteke',
  'COMMON.LABEL.EDIT': 'Uredi',
  'COMMON.LABEL.FILTER': 'Filter',
  'COMMON.LABEL.MAXIMUM': 'Maksimum',
  'COMMON.LABEL.MINIMUM': 'Minimum',
  'COMMON.LABEL.MAX_LENGTH_REACHED': 'Prekoračili ste dopušten broj znakova',
  'COMMON.LABEL.MAX_LENGTH_CHARACTER_INFO_LABEL': 'Dopušten broj znakova je %{maxCharNum}',
  'COMMON.LABEL.PICK_ANSWER_PLACEHOLDER': 'Odaberite odgovor',
  'COMMON.LABEL.SELECT_PLACEHOLDER': 'Odaberite',
  'COMMON.LABEL.INPUT_SEARCH_PLACEHOLDER': 'Pretražite',
  'COMMON.SELECTED_LABEL': 'Odabrano',
  'COMMON.ADDRESS_MISSING_LABEL': 'Korisnik nema unesenu adresu',
  'COMMON.ENTER_TEXT_LABEL': 'Upišite tekst',
  'COMMON.LABEL.PERIOD.YEAR': 'Godina',
  'COMMON.LABEL.PERIOD.MONTH': 'Mjesec',
  'COMMON.LABEL.PERIOD.DAY': 'Dan',
  'COMMON.LABEL.PERIOD.YEARS': 'Godine',
  'COMMON.LABEL.PERIOD.MONTHS': 'Mjeseci',
  'COMMON.LABEL.PERIOD.DAYS': 'Dani',
  'COMMON.LABEL.FILE_UPLOAD': 'Dodavanje datoteke',
  'COMMON.LABEL.MISSING_DATA': 'Nema podatka',
  'COMMON.LABEL.NOT_ALLOWED_TO_ACCESS': 'Nemate pristup stranici',
  'COMMON.LABEL.MORE': 'Više',
  'COMMON.LABEL.SELECT': 'Odaberite',
  'COMMON.LABEL.ONLINE': 'Online',

  // ----- Common status labels
  'COMMON.STATUS_LABEL.IN_CREATION': 'U Izradi',
  'COMMON.STATUS_LABEL.CREATION_FINISHED': 'Završen',
  'COMMON.STATUS_LABEL.PUBLISHED': 'Objavljen',
  'COMMON.STATUS_LABEL.ARCHIVED': 'Arhiviran',

  // ---------- General Messages
  'GENERAL_MESSAGE.GENERAL_FETCH_ERROR': 'Greška pri dohvatu podataka!',
  'GENERAL_MESSAGE.GENERAL_SEND_ERROR': 'Greška pri slanju podataka!',
  'GENERAL_MESSAGE.GENERAL_UPDATE_ERROR': 'Greška pri spremanju podataka!',
  'GENERAL_MESSAGE.GENERAL_DELETE_ERROR': 'Greška pri brisanju podataka!',

  'GENERAL_MESSAGE.GENERAL_FETCH_SUCCESS': 'Podaci dohvaćeni',
  'GENERAL_MESSAGE.GENERAL_SEND_SUCCESS': 'Podaci poslani',
  'GENERAL_MESSAGE.GENERAL_UPDATE_SUCCESS': 'Podaci spremljeni',
  'GENERAL_MESSAGE.GENERAL_DELETE_SUCCESS': 'Podaci obrisani',

  // ---------- Timun user import error Messages
  'FILE_TIMUN_USER_IMPORT.ERROR.FAILED_ACCESSING_FILE': 'Neuspješno pristupanje datoteci.',
  'FILE_TIMUN_USER_IMPORT.ERROR.INVALID_FILE_TYPE': 'Neispravan vrsta datoteke.',
  'FILE_TIMUN_USER_IMPORT.ERROR.DUPLICATE_USERNAME': 'Duplicirano korisničko ime u datoteci.',
  'FILE_TIMUN_USER_IMPORT.ERROR.DUPLICATE_EMAIL': 'Dupliciran e-mail u datoteci.',

  // ---------- Course error Messages
  'COURSE_CREATE.ERROR.COURSE_ALREADY_EXISTS': 'Tečaj s istim nazivom već postoji. Odaberite drugi naziv.',
  'COURSE_UPDATE.ERROR.COURSE_ALREADY_EXISTS': 'Tečaj s istim nazivom već postoji. Odaberite drugi naziv.',

  // ---------- Tag error messages
  'TAG_ADD.ERROR.TAG_ITEM_ALREADY_EXISTS': 'Oznaka je već dodana',
  // ---------- File type upload
  'FILE_TYPE_UPLOAD.SELECT_TYPE_PLACEHOLDER': 'Odaberite tip dokumenta',
  'FILE_TYPE_UPLOAD.SELECT_TYPE_WARNING': 'Molim Vas da odaberete tip dokumenta',
  // ---------- Files
  // --- External education application files
  [`FILES.TYPE_ENUM.LABEL.${FileTypeEnum.CURRICULUM_VITAE}`]: 'Životopis',
  [`FILES.TYPE_ENUM.LABEL.${FileTypeEnum.ENROLLMENT_REQUIREMENT}`]: 'Dokaz o ispunjavanju uvjeta',
  [`FILES.TYPE_ENUM.LABEL.${FileTypeEnum.FINANCING_AGREEMENT}`]: 'Generirani ugovor',
  [`FILES.TYPE_ENUM.LABEL.${FileTypeEnum.OFFER}`]: 'Ponuda',
  [`FILES.TYPE_ENUM.LABEL.${FileTypeEnum.SIGNED_FINANCING_AGREEMENT}`]: 'Potpisani ugovor',
  [`FILES.TYPE_ENUM.LABEL.${FileTypeEnum.MUTUALLY_SIGNED_FINANCING_AGREEMENT}`]: 'Obostrano potpisani ugovor',
  [`FILES.TYPE_ENUM.LABEL.${FileTypeEnum.PROOF_OF_PAYMENT}`]: 'Potvrda o plaćanju',
  [`FILES.TYPE_ENUM.LABEL.${FileTypeEnum.ATTENDANCE_CERTIFICATE}`]: 'Potvrda o prisutnosti',
  [`FILES.TYPE_ENUM.LABEL.${FileTypeEnum.COMPETENCIES_CERTIFICATE}`]: 'Potvrda o stečenim kompetencijama',
  [`FILES.TYPE_ENUM.LABEL.${FileTypeEnum.APPLICATION_EXPORT}`]: 'Zahtjev za financiranje obrazovanja',
  [`FILES.TYPE_ENUM.LABEL.${FileTypeEnum.CONTRACT_ANNEX}`]: 'Aneks ugovora',
  [`FILES.TYPE_ENUM.LABEL.${FileTypeEnum.SIGNED_CONTRACT_ANNEX}`]: 'Potpisani aneks ugovora',
  [`FILES.TYPE_ENUM.LABEL.${FileTypeEnum.MUTUALLY_SIGNED_CONTRACT_ANNEX}`]: 'Obostrano potpisani aneks ugovora',
  [`FILES.TYPE_ENUM.LABEL.${FileTypeEnum.REFERRAL}`]: 'Uputnica za zdravstveni pregled',
  // --- User files
  [`FILES.TYPE_ENUM.LABEL.${FileTypeEnum.GENERAL}`]: 'Opći dokument',
  [`FILES.TYPE_ENUM.LABEL.${FileTypeEnum.COMPLETED_EDUCATION_CERTIFICATE}`]: 'Preslika potvrde o stečenoj kvalifikaciji',
  [`FILES.TYPE_ENUM.LABEL.${FileTypeEnum.ID_CARD}`]: 'Preslika osobne iskaznice',
  [`FILES.TYPE_ENUM.LABEL.${FileTypeEnum.ADDITIONAL_CERTIFICATE}`]: 'Obostrano potpisani aneks ugovora',
  // --- Education template
  [`FILES.TYPE_ENUM.LABEL.${FileTypeEnum.CURRICULUM}`]: 'Kurikulum programa',
  [`FILES.TYPE_ENUM.LABEL.${FileTypeEnum.EDUCATION_EXECUTION_APPROVAL}`]: 'Rješenje o odobrenju za izvođenje',
  'FILES.TYPE.FINANCING_AGREEMENT_TEMPLATE_LABEL': 'Predložak ugovora',
  'FILES.TYPE.CONTRACT_ANEX_TEMPLATE_LABEL': 'Predložak aneks ugovora',
  // ---------- App navigation
  'APP_NAVIGATION.DASHBOARD': 'Početna',
  'APP_NAVIGATION.MY_PROFILE': 'Moj profil',
  'APP_NAVIGATION.EDUCATION_GROUPS': 'Program obrazovanja',
  'APP_NAVIGATION.REPOSITORY': 'Baza znanja',
  'APP_NAVIGATION.COURSES_ADMINISTRATION': 'Upravljanje tečajevima',
  'APP_NAVIGATION.COURSES': 'Tečajevi',
  'APP_NAVIGATION.REPORTS': 'Izvještaji',
  'APP_NAVIGATION:ADMINISTRATION': 'Administracija',
  'APP_NAVIGATION.WEBINARS': 'Webinari',
  'APP_NAVIGATION.EXTERNAL_CONTENTS': 'Vanjske poveznice',
  'APP_NAVIGATION.MY_USER_GROUPS': 'Grupe',
  'APP_NAVIGATION.ORGANIZATION_GRAPH': 'Organizacija',
  'APP_NAVIGATION.EDUCATION_APPLICATION': 'Svi zahtjevi',
  'APP_NAVIGATION.EXTERNAL_EDUCATION_TEMPLATES': 'Svi programi obrazovanja',
  'APP_NAVIGATION.ADMINISTRATION_SKILLS': 'Administracija vještina',

  // ---------- Login Form
  'LOGIN.USERNAME_LABEL': 'Korisničko ime',
  'LOGIN.USERNAME_PLACEHOLDER': 'Unesite korisničko ime',
  'LOGIN.PASSWORD_LABEL': 'Lozinka',
  'LOGIN.PASSWORD_PLACEHOLDER': 'Unesite lozinku',
  'LOGIN.LOGIN_BUTTON_LABEL': 'Prijava',
  'LOGIN.FORGOT_PASSWORD_LABEL': 'Zaboravili ste lozinku?',
  'LOGIN.REGISTRATION_LABEL': 'Nemate korisnički račun?',
  'LOGIN.REGISTRATION_LINK': 'Registracija',
  // errors
  'LOGIN.ERROR.GENERAL_ERROR': 'Greška pri prijavi u sustav',
  // API errors
  'LOGIN.ERROR.BAD_CREDENTIALS': 'Neuspješna prijava. Molimo provjerite svoje pristupne podatke i pokušajte ponovo.',

  // ---------- Login Menu
  'LOGIN_MENU.LOGIN_LABEL': 'Prijava',
  'LOGIN_MENU.LANGUAGE_LABEL': 'Jezik',

  // ---------- User Menu
  'USER_MENU.MY_PROFILE': 'Moj profil',
  'USER_MENU.CHANGE_PASSWORD_LABEL': 'Promjena lozinke',
  'USER_MENU.LOGOUT_LABEL': 'Odjava',
  'USER_MENU.NOTIFICATIONS': 'Obavijesti',

  // ---------- Error page
  'ERROR_PAGE.DEFAULT_ERROR_TITLE': 'Došlo je do problema u prikazu stranice',
  'ERROR_PAGE.DEFAULT_ERROR_DESCRIPTION': 'Molimo pokušajte ponovno povratkom na početnu stranicu ili nas kontaktirajte da pokušamo zajedno riješiti problem. Hvala!',

  // ---------- Welcome page
  'WELCOME.WELCOME_TITLE': 'Dobrodošli na %{tenantName}!',
  'WELCOME.WELCOME_DESCRIPTION': 'Ako niste prijavljeni u sustav, odaberite poveznicu "Prijava" gore desno da bi ste se prijavili.',

  // ---------- Course page
  'COURSE.STATUS_TITLE.IN_CREATION': 'U Izradi',
  'COURSE.STATUS_TITLE.CREATION_FINISHED': 'Završen',
  'COURSE.STATUS_TITLE.PUBLISHED': 'Objavljen',
  'COURSE.STATUS_TITLE.ARCHIVED': 'Arhiviran',

  'COURSE_VIEW.LECTURE_LIST_MENU.COURSE_ABOUT_ITEM_LABEL': 'O tečaju',
  'COURSE_VIEW.LECTURE_LIST_MENU.EXAM_TEMPLATE_ITEM_LABEL': 'Provjera znanja',
  'COURSE_VIEW.CREATE.CREATE_COURSE_TITLE': 'Novi tečaj',
  'COURSE_VIEW.VIEW.COURSE_START_BUTTON': 'Započni',
  'COURSE_VIEW.VIEW.LECTURE_QUIZ_TITLE': 'Provjera znanja',
  'COURSE_VIEW.VIEW.ADDITIONAL_COURSES_TITLE': 'Slični tečajevi',
  'COURSE_VIEW.VIEW.COURSE_DURATION_LABEL': 'Očekivano trajanje tečaja',
  'COURSE_VIEW.VIEW.COURSE_DURATION_CONTENT_LABEL': '%{duration} sat/i',
  'COURSE_VIEW.UPDATE.ADMINISTRATION_BUTTON_LABEL': 'Administracija',
  'COURSE_VIEW.UPDATE.COPY_COURSE_BUTTON_LABEL': 'Kopiraj tečaj',
  'COURSE_VIEW.UPDATE.COURSE_COPY_MESSAGE': 'Uspješno kopiran tečaj',
  'COURSE_VIEW.UPDATE.LECTURE_NAME_INPUT_TITLE': 'Nova lekcija',
  'COURSE_VIEW.UPDATE.GROUP_NAME_INPUT_TITLE': 'Nova grupa lekcija',
  'COURSE_VIEW.UPDATE.NAME_INPUT_PLACEHOLDER': 'Unesi ime',
  'COURSE_VIEW.UPDATE.DELETE_CONFIRM_TITLE': 'Izbrisati?',
  'COURSE_VIEW.UPDATE.ABOUT_COURSE_TAB_TITLE': 'Detalji tečaja',
  'COURSE_VIEW.UPDATE.LECTURE_GROUP_TITLE': 'Grupe lekcija',
  'COURSE_VIEW.UPDATE.LECTURE_GROUP_SELECT_PLACEHOLDER': 'Odaberi grupu lekcija',
  'COURSE_VIEW.UPDATE.COURSE_TEXT_FORM_LABEL': 'O tečaju',
  'COURSE_VIEW.UPDATE.COURSE_DURATION_FORM_LABEL': 'Očekivano trajanje tečaja',
  'COURSE_VIEW.UPDATE.COURSE_DURATION_FORM_HOURS_LABEL': 'sati',
  'COURSE_VIEW.UPDATE.COURSE_TITLE_FORM_LABEL': 'Naziv tečaja',
  'COURSE_VIEW.UPDATE.COURSE_STATUS_FORM_LABEL': 'Status Tečaja',
  'COURSE_VIEW.UPDATE.COURSE_GROUP_SELECT_FORM_LABEL': 'Grupe tečajeva',
  'COURSE_VIEW.UPDATE.COURSE_GROUP_SELECT_PLACEHOLDER': 'Odaberi grupu tečajeva',
  'COURSE_VIEW.UPDATE.COURSE_LECTURE_GROUP_TITLE_FORM_LABEL': 'Naziv grupe',
  'COURSE_VIEW.UPDATE.COURSE_LECTURE_GROUP_ORDERING_FORM_LABEL': 'Redni broj',
  'COURSE_VIEW.UPDATE.LECTURE_TITLE_FORM_LABEL': 'Naziv lekcije',
  'COURSE_VIEW.UPDATE.LECTURE_ORDERING_FORM_LABEL': 'Redni broj lekcije u grupi',
  'COURSE_VIEW.UPDATE.LECTURE_VIDEO_FORM_LABEL': 'Video sadržaj',
  'COURSE_VIEW.UPDATE.LECTURE_CONTENT_FORM_LABEL': 'Sadržaj lekcije',
  'COURSE_VIEW.UPDATE.COURSE_CONTENT_EDIT_LABEL': 'Uređivanje',
  'COURSE_VIEW.UPDATE.COURSE_CONTENT_PREVIEW_LABEL': 'Pregled',
  'COURSE_VIEW.UPDATE.LECTURE_FILES_LABEL': 'Dodatni materijali',
  'COURSE_VIEW.UPDATE.KNOWLEDGE_BASE_BUTTON': 'Dodaj iz baze znanja',
  'COURSE_VIEW.UPDATE.LESSONS_LOCKED_LABEL': 'Sljedeće lekcije',
  'COURSE_VIEW.UPDATE.LESSONS_LOCKED_TITLE_LOCKED': 'Zaključane',
  'COURSE_VIEW.UPDATE.LESSONS_LOCKED_TITLE_UNLOCKED': 'Otključane',
  'COURSE_VIEW.UPDATE.LESSONS_LOCKED_REQUIRED_LABEL': 'Odaberite hoće li sljedeće lekcije biti zaključane',
  'COURSE_VIEW.UPDATE.VISIBILITY_LABEL': 'Vidljivost tečaja',
  'COURSE_VIEW.UPDATE.VISIBILITY_REQUIRED_LABEL': 'Odaberite vidljivost',
  'COURSE_VIEW.UPDATE.VISIBILITY_TITLE_PUBLIC': 'Javan',
  'COURSE_VIEW.UPDATE.VISIBILITY_TITLE_PRIVATE': 'Privatan',
  'COURSE_VIEW.UPDATE.VISIBILITY_TITLE_LIMITED': 'Ograničen',
  'COURSE_VIEW.UPDATE.LECTURE_DELETED_MESSAGE': 'Obrisana je lekcija: %{lecture}',
  'COURSE_VIEW.COURSE_DELETED_MESSAGE': 'Tečaj obrisan',
  'COURSE_VIEW.CREATE_NEW_NOTE': 'Nova bilješka',
  'COURSE_VIEW.NOTES': 'Bilješke',
  'COURSE_VIEW.COMMENTS': 'Komentari',
  'COURSE_VIEW.PUBLIC_LECTURE_TOOLTIP': 'Sadržaj lekcije možete gledati tek nakon što upišete tečaj.',
  'COURSE_VIEW_PUBLIC.TITLE': 'Katalog tečajeva',
  'COURSE_VIEW_PUBLIC.ALL_COURSEGROUPS_LABEL': 'Sve grupe tečajeva',
  'COURSE_VIEW_PUBLIC.ALL_STATUSES_LABEL': 'Svi statusi',
  'COURSE_VIEW.NO_DATA_LABEL': 'Popis tečajeva je prazan',
  'COURSE_VIEW.ENROLL_MESSAGE': 'Tečaj upisan',
  'COURSE_VIEW.COURSE_COMPLETED_MESSAGE': 'Čestitamo! Završili ste tečaj %{courseName}. Potvrdu o završetku možete preuzeti na svom profilu.',
  'COURSE_SUCCESS_MODAL.SUBMIT_SUCCESSFUL_TITLE': 'Čestitamo!',
  'COURSE_SUCCESS_MODAL.SUBMIT_SUCCESSFUL_MESSAGE': 'Uspješno ste položili %{courseName}.',
  'COURSE_SUCCESS_MODAL.SUBMIT_SUCCESSFUL_DESCRIPTION': 'Potvrdu o završetku možete preuzeti na svom profilu.',
  'COURSE_VIEW.COURSE_CERTIFICATE_ITEM_LABEL': 'Potvrda',
  // errors
  'COURSE_VIEW.MESSAGE.INVALID_QUIZ_CONTENT_ERROR': 'Neispravan sadržaj provjere znanja [%{error}]',
  'LECTURE_CREATE.ERROR.LECTURE_ALREADY_EXISTS': 'Lekcija s istim nazivom već postoji. Odaberite drugi naziv. ',
  'LECTURE_GROUP_CREATE.ERROR.LECTURE_GROUP_ALREADY_EXISTS': 'Grupa lekcija s istim nazivom već postoji. Odaberite drugi naziv. ',

  // ---------- Course administration
  'COURSE_ADMINISTRATION.SIDER.SUBMENU_ASSIGNMENT_MANAGMENT_LABEL': 'Upravljanje dodjeljivanjem',
  'COURSE_ADMINISTRATION.SIDER.MENU_ASSIGNMENT_MANAGMENT_WORKPOSITION_LABEL': 'Na temelju radnog mjesta',
  'COURSE_ADMINISTRATION.SIDER.MENU_ASSIGNMENT_MANAGMENT_ORGANIZATION_GROUP_LABEL': 'Na temelju organizacijske grupe',
  'COURSE_ADMINISTRATION.SIDER.MENU_ASSIGNMENT_MANAGMENT_INDIVIDUAL_LABEL': 'Pojedinačno dodjeljivanje',
  'COURSE_ADMINISTRATION.SIDER.MENU_TRAINEE_LIST_LABEL': 'Polaznici',
  'COURSE_ADMINISTRATION.SIDER.SUBMENU_STATISTICS_LABEL': 'Rezultati provjere znanja',
  'COURSE_ADMINISTRATION.SIDER.MENU_EXAM_STATISTIC_LABEL': 'Statistika provjere znanja',
  'COURSE_ADMINISTRATION.SIDER.MENU_TRAINEE_RESULTS_LABEL': 'Rezultati polaznika',
  'COURSE_ADMINISTRATION.VIEW.COURSE_TITLE_LABEL': 'Administracija tečaja: %{courseTitle}',
  'COURSE_ADMINISTRATION.VIEW.RETURN_TO_COURSE_LABEL': 'Povratak na tečaj',
  'COURSE_ADMINISTRATION.VIEW.EDIT_EXAM_TEMPLATE_HEADER_TITLE': 'Uređivanje predloška provjere znanja',
  'COURSE_ADMINISTRATION.SIDER.SUBMENU_SKILL_MANAGEMENT_LABEL': 'Upravljanje vještinama',
  'COURSE_ADMINISTRATION.SIDER.MENU_SKILL_MANAGMENT_INDIVIDUAL_LABEL': 'Pojedinačno dodjeljivanje',
  'COURSE_ADMINISTRATION.VIEW.SKILLS_LABEL': 'Vještine koje polaznik usvoji kroz tečaj',
  'COURSE_ADMINISTRATION.VIEW.ASSIGN_SKILL_LABEL': 'Dodijeli vještine',
  'COURSE_ADMINISTRATION.SIDER.SUBMENU_COURSE_REPORT_LABEL': 'Izvještaj tečaja',
  'COURSE_ADMINISTRATION.SIDER.MENU_COURSE_REPORT_INDIVIDUAL_LABEL': 'Izvještaj tečaja',

  // ---------- Course skill list
  'COURSE_SKILL_LIST.SKILL_DESCRIPTION_LABEL': 'Vještina',
  'COURSE_SKILL_LIST.SKILL_GROUP_DESCRIPTION_LABEL': 'Grupa vještina',
  'COURSE_SKILL_LIST.SKILL_EDIT_BUTTON_LABEL': 'Uredi vještine tečaja',

  // ---------- Course progress info
  'COURSE_PROGRESS_INFO.DEADLINE_DATE_TOOLTIP_LABEL': 'Rok',
  'COURSE_PROGRESS_INFO.EARNED_POINTS_TOOLTIP_LABEL': 'Ostvareni bodovi',

  // ---------- Comments view
  'COMMENTS_VIEW.NO_DATA': 'Nema komentara',
  'COMMENTS_VIEW.DELETE_COMMENT': 'Obrišite komentar',
  'COMMENTS_VIEW.EDIT_COMMENT': 'Uredite komentar',
  'COMMENTS_VIEW.CLOSE_EDIT_SECTION': 'Zatvorite uređivanje komentara',
  'COMMENTS_VIEW.ACTION_SORT_POPULAR': 'Najpopularniji',
  'COMMENTS_VIEW.ACTION_SORT_LABEL': 'Poredaj komentare po',
  'COMMENTS_VIEW.APPROVAL_INFO_MESSAGE': 'Čeka odobrenje',
  'COMMENTS_VIEW.APPROVED_INFO_MESSAGE': 'Komentar odobren',
  'COMMENTS_VIEW.COMMENT_ADDED_MESSAGE': 'Komentar spremljen',
  'COMMENTS_VIEW.COMMENT_DELETED_MESSAGE': 'Komentar obrisan',

  // ---------- Course data picker
  'COURSE.PICKER.COURSE_PLACEHOLDER': 'Pretražite postojeće tečajeve',
  'COURSE.PICKER.COURSE_EMPTY_MESSAGE': 'Nema pronađenih tečajeva',

  // ---------- Course report modal
  'COURSE_REPORT_MODAL.TITLE': 'Izvještaj',
  'COURSE_REPORT_MODAL.OK_TEXT': 'Zatraži izvještaj',
  'COURSE_REPORT_MODAL.FORM.REPORT_TYPE_LABEL': 'Tip izvještaja',
  'COURSE_REPORT_MODAL.FORM.USER_GROUPS_LABEL': 'Korisničke grupe',
  'COURSE_REPORT_MODAL.FORM.COURSES_LABEL': 'Tečajevi',
  'COURSE_REPORT_MODAL.FORM.EXTERNAL_EDUCATION_APPLICATION_LABEL': 'Filteri zahtjeva',

  // ---------- User View
  'USER_VIEW.WORK_POSITION_LABEL': 'Radno mjesto',
  'USER_VIEW.WORK_SATRT_DATE_LABEL': 'Početak rada',
  'USER_VIEW.DATE_OF_BIRTH_LABEL': 'Datum rođenja',
  'USER_VIEW.ADDRESS_LABEL': 'Adresa',
  'USER_VIEW.EDIT_USER': 'Uredi polaznika',
  'USER_VIEW.DELETE_USER': 'Obriši polaznika',
  'USER_VIEW.ENROLLED_COURSES_TAB_LABEL': 'Upisani tečajevi',
  'USER_VIEW.ACTIVITIES_TAB_LABEL': 'Aktivnosti',
  'USER_VIEW.COORDINATOR_EDUCATION_APPLICATION_TAB_LABEL': 'Zahtjevi koje obrađujem',
  'USER_VIEW.COORDINATOR_TRAINEE_EDUCATION_APPLICATION_TAB_LABEL': 'Zahtjevi koje je podnio korisnik',
  'USER_VIEW.TRAINEE_EDUCATION_APPLICATION_TAB_LABEL': 'Moji zahtjevi',
  'USER_VIEW.DOCUMENTS_TAB_LABEL': 'Dokumenti',
  'USER_VIEW.SKILLS_TAB_LABEL': 'Vještine',
  'USER_VIEW.BUSINESS_PROFILES_TAB_LABEL': 'Poslovni profili',
  'USER_VIEW.DOCUMENTS_TABLE_DOCUMENT_LABEL': 'Naziv dokumenta',
  'USER_VIEW.DOCUMENTS_TABLE_AUTHOR_LABEL': 'Autor',
  'USER_VIEW.DOCUMENTS_TABLE_TIME_LABEL': 'Vrijeme kreiranja',
  'USER_VIEW.USER_DELETED_LABEL': 'Korisnik obrisan',
  'USER_VIEW.EXTERNAL_EDUCATION_TEMPLATES_TAB_LABEL': 'Programi obrazovanja koje obrađujem',
  'USER_VIEW.DOCUMENTS_TAB.ADD_BUTTON': 'Novi dokument',
  'USER_VIEW.ADDITIONAL_USER_INFO_TAB_LABEL': 'Dodatne informacije',
  // errors
  'USER_VIEW.NOTZ.ERROR_MESSAGE.USER_WITHOUT_IDENTIFICATION_NUMBER': 'Korisnik nema unesen OIB',

  // ---------- User Container View
  'USER_VIEW_CONTAINER.CREATE_USER': 'Novi korisnik',
  'USER_VIEW_CONTAINER.IMPORT_USERS': 'Uvoz HRNET korisnika',
  'USER_VIEW_CONTAINER.IMPORT_USERS_SUCCESS': 'Uvoz je pokrenut te bi mogao potrajati više minuta, molimo osvježite listu kasnije.',
  'USER_VIEW_CONTAINER.ENROLL_USER': 'Dodijelite odabranim korisnicima',
  'USER_VIEW_CONTAINER.ENROLL_ALL_USERS': 'Dodijelite svim korisnicima u sustavu',
  'USER_VIEW_CONTAINER.LDAP_SYNC_SUCCESS': 'Sinkronizacija je pokrenuta te bi mogla potrajati više minuta, molimo osvježite listu kasnije.',

  // --------- User Notes
  'USER_NOTES.CREATE_NOTE': 'Stvorite bilješku',
  'USER_NOTES.VISIBILITY_REQUIRED_LABEL': 'Odaberite vidljivost',
  'USER_NOTES.VISIBILITY_TITLE_PUBLIC': 'Javna',
  'USER_NOTES.VISIBILITY_TITLE_VISIBLE_TO_USER': 'Vidljiva korisniku',
  'USER_NOTES.VISIBILITY_TITLE_PRIVATE': 'Privatna',

  // ---------- Notes List View
  'NOTE_LIST.MY_NOTES_LABEL': 'Moje bilješke',
  'NOTE_LIST.NOTE_TYPE.COURSE': 'Tečaj',
  'NOTE_LIST.NOTE_TYPE.WEBINAR': 'Webinar',
  'NOTE_LIST.NOTE_TYPE.EXAM_TEMPLATE': 'Predložak provjere znanja',
  'NOTE_LIST.NOTE_MODAL_LABEL': 'Uredi bilješku',
  'NOTE_CONTAINER.SUCCESS_CREATE_INFO_MESSAGE': 'Bilješka spremljena',
  'NOTE_CONTAINER.NOTE_DELETED_MESSAGE': 'Bilješka obrisana',
  'NOTE_LIST.NO_DATA': 'Nema bilješki',
  'NOTE_LIST.EXPORT_BUTTON_LABEL': 'Izvezi bilješke',
  'NOTE_LIST.CREATE_ERROR': 'Trenutno nema bilješki za preuzimanje',

  // ---------- Notes List Filter
  'NOTE_LIST_FILTER.SORT_BY_DATE_ADDED_LABEL': 'Poredaj po vremenu dodavanja',

  // ---------- User List Filter
  'USER_LIST_FILTER.ALL_USERS': 'Svi korisnici',
  'USER_LIST_FILTER.ONLY_ACTIVE_USERS': 'Aktivni korisnici',
  'USER_LIST_FILTER.INPUT_LENGTH': 'Minimalno 3 znaka',
  'USER_LIST.TRAINEE_REPORTS': 'Izvještaj polaznika',
  'USER_LIST_FILTER.NAME_LABEL': 'Ime',
  'USER_LIST_FILTER.ASSIGNED_DATE_FROM_LABEL': 'Dodjela tečaja (od)',
  'USER_LIST_FILTER.ASSIGNED_DATE_TO_LABEL': 'Dodjela tečaja (do)',
  'USER_LIST_FILTER.ORGANIZATION_GROUPS_LABEL': 'Organizacijske grupe',

  // ---------- Course group list
  'COURSE_GROUP_LIST.VIEW_TITLE': 'Grupe tečajeva',
  'COURSE_GROUP_LIST.CREATE_GROUP_TITLE': 'Nova grupa tečajeva',
  'COURSE_GROUP_LIST.EDIT_GROUP_TITLE': 'Grupa tečajeva',
  'COURSE_GROUP.DELETED_MESSAGE': 'Korisnička grupa je obrisana',

  // ---------- Course list
  'COURSE_LIST.ADMINISTRATION.COURSE_LIST_CREATOR_TAB': 'Kreiranje tečajeva',
  'COURSE_LIST.ADMINISTRATION.COURSE_LIST_MANAGEMENT_TAB': 'Administracija tečajeva',
  'COURSE_LIST.ADMINISTRATION.COURSE_LIST_OVERVIEW_TAB': 'Pregled tečajeva',
  'COURSE_LIST.ADMINISTRATION.COURSE_LIST_USER_PROGRESS_TAB': 'Pregled polaznika',

  'COURSE_LIST.VIEW_TITLE': 'Tečajevi',
  'COURSE_LIST.VIEW_TAB_CATALOG': 'Katalog tečajeva',
  'COURSE_LIST.VIEW_TAB_MY': 'Upisani tečajevi',
  'COURSE_LIST.NO_DATA': 'Nema dodijeljenih tečajeva',
  'COURSE_LIST.UNGROUPED_TITLE': 'Nedodijeljeni',
  'COURSE_LIST.ACTION_CREATE': 'Novi tečaj',
  'COURSE_LIST.ACTION_CREATE_SCORM': 'Novi SCORM tečaj',
  'COURSE_LIST.ACTION_GROUPS_EDIT': 'Uredi grupe',

  'COURSE_LIST_STARTED.VIEW_TITLE': 'Tečajevi u tijeku',
  'COURSE_CONTINUE.VIEW_TITLE': 'Nastavi gledati tečaj',
  'COURSE_LIST_STARTED.NO_DATA': 'Nema započetih tečajeva',

  'COURSE_LIST.COURSE_STATUS_TO_DO': 'Nezapočeto',
  'COURSE_LIST.COURSE_STATUS_IN_PROGRESS': 'U tijeku',
  'COURSE_LIST.COURSE_STATUS_COMPLETED': 'Položeno',
  'COURSE_LIST.COURSE_STATUS_FAILED': 'Nije položeno',
  'COURSE_LIST.ADD_COURSES_LABEL': 'Dodaj tečaj(eve) polazniku',
  'COURSE_LIST.EDIT_COURSES_LABEL': 'Uredi tečaj(eve) polaznika',

  'COURSE_LIST_EDIT_FORM.ADD_TITLE_LABEL': 'Dodavanje tečaj(eva) korisniku',
  'COURSE_LIST_EDIT_FORM.EDIT_TITLE_LABEL': 'Uređivanje tečaj(eva) korisnika',
  'COURSE_LIST_EDIT_FORM.UNASSIGNED_COURSES_LABEL': 'Nedodijeljeni',
  'COURSE_LIST_EDIT_FORM.ASSIGNED_COURSES_LABEL': 'Dodijeljeni',
  'COURSE_LIST_EDIT_FORM.DEADLINE_DATE_LABEL': 'Rok',
  'COURSE_LIST_EDIT_FORM.DEADLINE_DATE_PLACEHOLDER': 'Unesite rok do kojeg polaznik treba završiti tečaj',

  'COURSE_LIST_FILTER.TRAINEE_STATS_FROM_LABEL': 'Početni datum',
  'COURSE_LIST_FILTER.TRAINEE_STATS_TO_LABEL': 'Završni datum',
  'COURSE_LIST_FILTER.ORGANIZATION_GROUPS_LABEL': 'Organizacijske grupe',

  // ---------- File upload
  'FILE_UPLOAD.MODAL_TITLE': 'Učitavanje datoteke',
  'FILE_UPLOAD.SCORM_MODAL_TITLE': 'Učitavanje SCORM tečaja u .zip formatu',
  'FILE_UPLOAD.HRNET_USER_IMPORT_MODAL_TITLE': 'Učitavanje HRNET liste korisnika za uvoz u sustav',
  'FILE_UPLOAD.TIMUN_USER_IMPORT_MODAL_TITLE': 'Učitavanje liste korisnika za uvoz u sustav',
  'FILE_UPLOAD.MODAL_UPLOAD_BUTTON': 'Dohvati s računala',
  'FILE_UPLOAD.DROPZONE_TEXT': 'Kliknite ili dovucite datoteke ovdje za dodavanje',
  'FILE_UPLOAD.ERROR_FILE_SIZE': 'Najveća dopuštena veličina datoteke je %{maxFileSize}!',
  'FILE_UPLOAD.ERROR_FILE_TYPE': 'Datoteka nije ispravnog tipa!',
  'FILE_UPLOAD.IMAGE.ERROR_FILE_TYPE': 'Moguće je odabrati samo .jpg ili .png datoteke!',
  'FILE_UPLOAD.VIDEO.ERROR_FILE_TYPE': 'Moguće je odabrati samo video datoteke!',

  'FILE_UPLOAD.FILE_ADDED_MESSAGE': 'Datoteka %{filename} dodana',
  'FILE_UPLOAD.FILE_REMOVED_MESSAGE': 'Datoteka %{filename} obrisana',
  'FILE_UPLOAD.FILE_UPLOAD_ERROR_MESSAGE': 'Greška prilikom dodavanja datoteke %{filename}',
  'FILE_UPLOAD.TOOLTIP_MESSAGE': 'Za najbolje rezultate koristite slike širine 600-800 piksela koje su manje visine nego širine. Za profilnu sliku sliku jednakih dimenzija po širini i visini.',

  // ---------- Video upload
  'INTEGRATION_VIDEO.FORM.MODAL_TITLE': 'Učitavanje videa',
  'INTEGRATION_VIDEO.FORM.IMPORT_VIDEO_TITLE': 'Uvezi video ID',
  'INTEGRATION_VIDEO.FORM.UPLOAD_VIDEO_TITLE': 'Učitaj video iz datoteke',
  'INTEGRATION_VIDEO.FORM.ADD_VIDEO': 'Novi video',
  'INTEGRATION_VIDEO.UPLOAD.DROPZONE_TEXT': 'Kliknite ili dovucite ovdje datoteku za dodavanje',
  'INTEGRATION_VIDEO.UPLOAD.UPLOAD_BUTTON': 'Dohvati s računala',
  'INTEGRATION_VIDEO.IMPORT.IMPORT_BUTTON': 'Uvezi video',

  'INTEGRATION_VIDEO.MESSAGE.ERROR_FILE_SIZE': 'Najveća dopuštena veličina datoteke je %{maxFileSize}!',
  'INTEGRATION_VIDEO.MESSAGE.ERROR_FILE_TYPE': 'Moguće je odabrati samo video datoteke!',
  'INTEGRATION_VIDEO.MESSAGE.UPLOAD_SUCCESSFUL': 'Video učitan',
  'INTEGRATION_VIDEO.MESSAGE.UPLOAD_ERROR': 'Greška prilikom učitavanja videa',
  'INTEGRATION_VIDEO.MESSAGE.IMPORT_ERROR': 'Greška prilikom učitavanja videa',
  'INTEGRATION_VIDEO.MESSAGE.UPLOAD_IN_PROGRESS': 'Učitavanje videa je još uvijek u tijeku. Jeste li sigurni da želite prekinuti?',

  'INTEGRATION_VIDEO.ERROR.INTEGRATION_ERROR': 'Greška kod pripreme videa', // smthng broke while creating placeholder
  'INTEGRATION_VIDEO.ERROR.UNSUPPORTED_INTEGRATION': 'Učitavanje videa nije podržano',
  'INTEGRATION_VIDEO.ERROR.NON_EXISTING_INTEGRATION_OBJECT': 'Zatraženi video nije pronađen',

  // ---------- Users List
  'USER_LIST.USERS_TITLE': 'Korisnici',
  'USER_LIST.TRAINEES_TITLE': 'Polaznici',
  'USER_LIST.USER_LABEL': 'Korisnik',
  'USER_LIST.WORKPOSITION_LABEL': 'Radno mjesto',
  'USER_LIST.COMPLETED_COURSES_LABEL': 'Završeni tečajevi',
  'USER_LIST.COURSE_STATUS_LABEL': 'Status',
  'USER_LIST.COURSE_DEADLINE_LABEL': 'Rok',

  // ---------- Users management List

  'USER_MANAGEMENT_LIST_VIEW.USER_ROLE_TRAINEE': 'Korisnik',
  'USER_MANAGEMENT_LIST_VIEW.USER_ROLE_SUPERADMIN': 'Glavni admin',
  'USER_MANAGEMENT_LIST_VIEW.USER_ROLE_ORGANIZATION_ADMIN': 'Admin',
  'USER_MANAGEMENT_LIST_VIEW.USER_ROLE_COURSE_CREATOR': 'Kreator tečajeva',
  'USER_MANAGEMENT_LIST_VIEW.USER_ROLE_PUBLISHER': 'Izdavač',
  'USER_MANAGEMENT_LIST_VIEW.USER_ROLE_TRAINER': 'Trener',
  'USER_MANAGEMENT_LIST_VIEW.USER_ROLE_ORGANIZER': 'Organizator',
  'USER_MANAGEMENT_LIST_VIEW.USER_ROLE_ORGANIZATION_MEMBER': 'Član organizacije',
  'USER_MANAGEMENT_LIST_VIEW.USER_ROLE_COORDINATOR': 'Savjetnik',
  'USER_MANAGEMENT_LIST_VIEW.USER_IDENTIFICATION_NUMBER_TITLE': 'OIB',
  'USER_MANAGEMENT_LIST_VIEW.USER_EMAIL_TITLE': 'E-mail',
  'USER_MANAGEMENT_LIST_VIEW.USER_FIRST_NAME_TITLE': 'Ime',
  'USER_MANAGEMENT_LIST_VIEW.USER_LAST_NAME_TITLE': 'Prezime',
  'USER_MANAGEMENT_LIST_VIEW.USER_AVATAR_TITLE': 'Slika',
  'USER_MANAGEMENT_LIST_VIEW.USER_ROLES_TITLE': 'Uloge',
  'USER_MANAGEMENT_LIST_VIEW.SHOW_USER_PROFILE_ACTION_BUTTON_TITLE': 'Pogledaj profil',
  // ---------- Users management list filter
  'ADMIN_USER_MANAGEMENT_LIST_FILTER.OIB_RULE_MESSAGE': 'OIB se sastoji od 11 znamenki',
  'ADMIN_USER_MANAGEMENT_LIST_FILTER.NAME_LABEL': 'Prema imenu i/ili prezimenu',
  'ADMIN_USER_MANAGEMENT_LIST_FILTER.OIB_LABEL': 'Prema OIB-u',
  'ADMIN_USER_MANAGEMENT_LIST_FILTER.ROLE_LABEL': 'Prema ulozi',
  'ADMIN_USER:MANAGEMENT_LIST_FILTER.WORK_POSITION_LABEL': 'Prema radnom mjestu',
  'ADMIN_USER_MANAGEMENT_LIST_FILTER.SKILL_LABEL': 'Vještina',

  // ---------- User Form
  'USER_FORM.FORM_TITLE_CREATE': 'Novi korisnik',
  'USER_FORM.FORM_TITLE_EDIT': 'Uređivanje korisnika',
  'USER_FORM.STATUS_LABEL': 'Status',
  'USER_FORM.ACTIVE_LABEL': 'Aktivan',
  'USER_FORM.INACTIVE_LABEL': 'Neaktivan',
  'USER_FORM.FIRST_NAME_LABEL': 'Ime',
  'USER_FORM.FIRST_NAME_PLACEHOLDER': 'Unesite ime',
  'USER_FORM.LAST_NAME_LABEL': 'Prezime',
  'USER_FORM.LAST_NAME_PLACEHOLDER': 'Unesite prezime',
  'USER_FORM.SKILL_PLACEHOLDER': 'Vještina',
  'USER_FORM.GENDER_LABEL': 'Spol',
  'USER_FORM.GENDER_LABEL_M': 'Muško',
  'USER_FORM.GENDER_LABEL_F': 'Žensko',
  'USER_FORM.DATE_OF_BIRTH_LABEL': 'Datum rođenja',
  'USER_FORM.DATE_OF_BIRTH_PLACEHOLDER': 'Unesite datum rođenja',
  'USER_FORM.IDENTIFICATION_NUMBER_LABEL': 'OIB',
  'USER_FORM.IDENTIFICATION_NUMBER_PLACEHOLDER': 'Unesite OIB',
  'USER_FORM.ADDRESS_ZIP_LABEL': 'Poštanski broj',
  'USER_FORM.ADDRESS_ZIP_PLACEHOLDER': 'Unesite poštanski broj',
  'USER_FORM.ADDRESS_CITY_PLACEHOLDER': 'Unesite naziv mjesta',
  'USER_FORM.ADDRESS_COUNTRY_LABEL': 'Država',
  'USER_FORM.ADDRESS_COUNTRY_PLACEHOLDER': 'Unesite naziv države',
  'USER_FORM.CONTACT_DATA_LABEL': 'Kontakt podaci',
  'USER_FORM.ADD_CONTACT_DATA_LABEL': 'Novi kontakt',
  'USER_FORM.GDPR_LABEL': 'GDPR',
  'USER_FORM.GDPR_ACCEPTED': 'Potvrđujem da sam stariji/a od 16 godina i prihvaćam Uvjete korištenja i Pravila privatnosti',
  'USER_FORM.WORK_POSITION_NAME_LABEL': 'Radno mjesto',
  'USER_FORM.WORK_POSITION_NAME_PLACEHOLDER': 'Odaberite naziv radnog mjesta',
  'USER_FORM.WORK_POSITION_START_DATE_LABEL': 'Početak rada',
  'USER_FORM.WORK_POSITION_START_DATE_PLACEHOLDER': 'Unesite početak rada',
  'USER_FORM.EMAIL_LABEL': 'E-mail',
  'USER_FORM.PHONE_LABEL': 'Telefon',
  'USER_FORM.EMAIL_PLACEHOLDER': 'Unesite e-mail adresu',
  'USER_FORM.PHONE_PLACEHOLDER': 'Unesite broj telefona ili mobitela',
  'USER_FORM.EMAIL_VALIDATION_TEXT': 'Unesite ispravnu e-mail adresu',
  'USER_FORM.USERNAME_LABEL': 'Korisničko ime',
  'USER_FORM.USERNAME_PLACEHOLDER': 'Unesite korisničko ime',
  'USER_FORM.USERNAME_MINIMUM_LENGTH_VALIDATION_MESSAGE': 'Korisničko ime mora sadržavati minimalno 8 znakova',
  'USER_FORM.PASSWORD_LABEL': 'Lozinka',
  'USER_FORM.PASSWORD_PLACEHOLDER': 'Unesite lozinku',
  'USER_FORM.CONFIRM_PASSWORD_LABEL': 'Potvrda lozinke',
  'USER_FORM.CONFIRM_PASSWORD_PLACEHOLDER': 'Unesite potvrdu lozinke',
  'USER_FORM.PASSWORD_MINIMUM_LENGTH_VALIDATION_MESSAGE': 'Lozinka mora sadržavati minimalno 8 znakova',
  'USER_FORM.PASSWORDS_DIFFERENT_ERROR': 'Lozinke nisu identične',
  'USER_FORM.ROLES_LABEL': 'Vrsta profila',
  'USER_FORM.ROLES_PLACEHOLDER': 'Uloga korisnika',
  'USER_FORM.ROLE_SUPERADMIN_LABEL': 'Glavni administrator',
  'USER_FORM.ROLE_ORGANIZATION_ADMIN_LABEL': 'Administrator',
  'USER_FORM.ROLE_COURSE_CREATOR_LABEL': 'Kreator tečajeva',
  'USER_FORM.ROLE_PUBLISHER_LABEL': 'Izdavač',
  'USER_FORM.ROLE_TRAINEE_LABEL': 'Korisnik',
  'USER_FORM.ROLE_TRAINER_LABEL': 'Trener',
  'USER_FORM.ROLE_ORGANIZER_LABEL': 'Organizator',
  'USER_FORM.ROLE_ORGANIZATION_MEMBER_LABEL': 'Član organizacije',
  'USER_FORM.ROLE_COORDINATOR_LABEL': 'Savjetnik',
  'USER_FORM.ACTIVITY_PLACEHOLDER': 'Korisnički račun',
  'USER_FORM.STATUS_ALL_LABEL': 'Svi',
  'USER_FORM.STATUS_PLACEHOLDER': 'Status',
  'USER_FORM.STATUS_ACTIVE_LABEL': 'Aktivan',
  'USER_FORM.STATUS_INACTIVE_LABEL': 'Neaktivan',
  'USER_FORM.STATUS_PARTIAL_LABEL': 'Parcijalno aktivan',
  'USER_FORM.OIB_LABEL': 'OIB',
  'USER_FORM.MBG_LABEL': 'MBG',
  'USER_FORM.CITIZENSHIP_LABEL': 'Državljanstvo',
  'USER_FORM.RESIDENCE_TYPE_TEMPORARY_LABEL': 'Boravište',
  'USER_FORM.RESIDENCE_TYPE_PERMANENT_LABEL': 'Prebivalište',
  'USER_FORM.STREET_WITH_NUMBER_LABEL': 'Adresa stanovanja',
  'USER_FORM.CITY_LABEL': 'Mjesto',
  'USER_FORM.RESIDENCE_TYPE_LABEL': 'Mjesnost',
  'USER_FORM.EDUCATION_PROGRAM_LABEL': 'Obrazovni program',
  'USER_FORM.EDUCATION_INSTITUTION_LABEL': 'Obrazovna ustanova',
  'USER_FORM.INTERNATIONAL_QUALIFICATIONS_ACCEPTED_LABEL': 'Priznavanje inozemnih kvalifikacija',
  'USER_FORM.TOTAL_EMPLOYMENT_DURATION_LABEL': 'Ukupni radni staž',
  'USER_FORM.ABOUT_ME_PANEL_TITLE': 'Informacije o meni',
  'USER_FORM.RESIDENCE_PANEL_TITLE': 'Mjesnost',
  'USER_FORM.CONTACT_PANEL_TITLE': 'Kontakt',
  'USER_FORM.ACQUIRED_QUALIFICATION_PANEL_TITLE': 'Stečena kvalifikacija',
  'USER_FORM.ADMIN_PANEL_TITLE': 'Administracija korisnika',
  'USER_FORM.NOTZ_PANEL_TITLE': 'Notz podaci',
  'USER_FORM.NOTZ.NOTZ_SYNC_DATE_TIME_LABEL': 'Zadnje povlačenje statusa iz NOTZ-a',
  'USER_FORM.NOTZ.NOTZ_SYNC_BUTON_LABEL': 'Povuci podatke s NOTZ-a',
  'USER_FORM.NOTZ.NOTZ_LAST_CHECK_IN_DATE_LABEL': 'Datum zadnje prijave',
  'USER_FORM.NOTZ.NOTZ_LAST_CHECK_OUT_DATE_LABEL': 'Datum zadnje odjave',
  'USER_FORM.NOTZ.NOTZ_STATUS_LABEL': 'Trenutni status',
  'USER_FORM.WORK_SKILL_PLACEHOLDER': 'Odaberite vještinu',
  // error message
  'USER_FORM.ERROR_MESSAGE.USER_CREATE_OR_UPDATE': 'Greška pri spremanju podataka',
  'USER.CREATE_SUCCESS': 'Korisnik uspješno kreiran',

  // ---------- Course user list
  'COURSE_USER_LIST.ENROLL_USERS_SUCCESS': 'Uspješno dodijeljen tečaj',
  'COURSE_USER_LIST.ENROLL_ALL_USERS_SUCCESS': 'Uspješno dodijeljen tečaj svim korisnicima',
  'COURSE_USER_LIST.VIEW.INFO_TEXT_LABEL': 'Odaberite korisnike kojima želite dodijeliti tečaj. Prikazuju se samo korisnici koji trenutno nisu upisani na ovaj tečaj.',
  // error message
  'COURSE_USER_ENROLL.ERROR.TRAINEE_ENROLLMENT_IN_PROCESS': 'Upis korisnika nije uspio: upis korisnika je već u tijeku',

  // ---------- User registration modal
  'USER_REGISTRATION.MODAL.STEP_ONE_TITLE': 'Kreiranje računa',
  'USER_REGISTRATION.MODAL.STEP_TWO_TITLE': 'O meni',
  'USER_REGISTRATION.MODAL.STEP_THREE_TITLE': 'Datoteke',
  'USER_REGISTRATION.MODAL.NOTZ_USER_INFORMATION_TEXT': 'Molimo unesite e-mail adresu putem koje ćete dobivati informacije iz sustava Moj vaučer o obradi Vašeg zahtjeva.',
  'USER_REGISTRATION.MODAL.BASIC_USER_INFORMATION_TEXT': 'Molimo unesite e-mail adresu putem koje ćete dobivati informacije iz sustava Moj vaučer o obradi Vašeg zahtjeva.',
  'USER_REGISTRATION.MODAL.NOTZ_USER_FILES_INFORMATION_TEXT':
    'Ako ste mijenjali osobnu iskaznicu ili stekli novu kvalifikaciju od zadnjeg upisa u registar tražitelja zaposlenja, molimo Vas da priložite važeću presliku osobne iskaznice i/ili presliku potvrde o stečenoj kvalifikaciji. Nakon provjere podatka za potrebe upisa/ažuriranja evidencije tražitelja zaposlenja savjetnik HZZ-a će obrisati preslike osobne iskaznice i potvrde o stečenoj kvalifikaciji.',
  'USER_REGISTRATION.MODAL.BASIC_USER_FILES_INFORMATION_TEXT':
    'Molimo Vas da priložite sljedeće dokumente:  preslika osobne iskaznice, preslika potvrde o stečenoj kvalifikaciji. Nakon provjere podatka za potrebe upisa/ažuriranja evidencije tražitelja zaposlenja savjetnik HZZ-a će obrisati preslike osobne iskaznice i potvrde o stečenoj kvalifikaciji.',

  // ---------- User evaluation list
  'USER_SKILL_EVALUATION_LIST_CONTAINER.BUTTON_ADD_SKILL_LABEL': 'Pridruži vještinu',
  'SKILL_EVALUATION_LIST.ASSIGNED_SKILLS_LABEL': 'Pridružene vještine',
  'SKILL_EVALUATION_LIST.ASSIGNED_LEVEL_LABEL': 'Pridružena razina',
  'SKILL_EVALUATION_LIST.EVALUATOR_NAME_LABEL': 'Procjenivač',
  'SKILL_EVALUATION_LIST.EVALUATION_TYPE_LABEL': 'Vrsta procjene',
  'SKILL_EVALUATION_LIST.DATE_LABEL': 'Datum',
  'SKILL_EVALUATION.TYPE.PEER': 'Procjena kolega',
  'SKILL_EVALUATION.TYPE.HUMAN_RESOURCES': 'Ljudski resursi',
  'SKILL_EVALUATION.TYPE.MANAGER': 'Menadžer',
  'SKILL_EVALUATION.TYPE.SELF': 'Samoprocjena',
  'USER_SKILL_EVALUATION_LIST.NO_DATA': 'Nema pridruženih vještina',
  'USER_SKILL_EVALUATION.FORM.ASSIGN_SKILL_LABEL': 'Odaberi vještinu i razinu',
  'USER_SKILL_EVALUATION.MODAL.CREATE_SKILL_TITLE': 'Pridruživanje vještina korisniku',
  'USER_SKILL_EVALUATION.MODAL.EDIT_SKILL_TITLE': 'Uredi vještinu korisniku',
  'USER_SKILL_EVALUATION.NOTIFICATION.USER_SKILL_EVALUATION_CREATED': 'Vještina pridružena',
  'USER_SKILL_EVALUATION.NOTIFICATION.USER_SKILL_EVALUATION_DELETED': 'Vještina obrisana',
  'USER_SKILL_EVALUATION.RADAR_CHART_TITLE': 'Usporedba vještina zaposlenika s vještinama radnog mjesta',
  // --- error message
  'USER_SKILL_EVALUATION_CREATE.ERROR.USER_SKILL_EVALUATION_NOT_ALLOWED': 'Nije vam dozvoljeno priduživat vještine ovome korisniku',
  'USER_SKILL_EVALUATION_CREATE.ERROR.USER_SKILL_ALREADY_EVALUATED': 'Već ste dodijelili ovu vještinu',

  // ---------- Reset Password & Request
  'RESET_PASSWORD_REQUEST.INFO_TEXT_1': 'Zahtjev za novu lozinku poslan na e-mail adresu',
  'RESET_PASSWORD_REQUEST.INFO_TEXT_2': 'Provjerite Vaše e-mail poruke i slijedite upute',
  'RESET_PASSWORD_REQUEST.EMAIL_LABEL': 'E-mail',
  'RESET_PASSWORD_REQUEST.EMAIL_PLACEHOLDER': 'Unesite Vašu e-mail adresu',
  'RESET_PASSWORD_REQUEST.RESET_PASSWORD_BUTTON_LABEL': 'Pošalji zahtjev za novu lozinku',
  'RESET_PASSWORD_REQUEST.EMAIL_VALIDATION_TEXT': 'Unesite ispravnu e-mail adresu',

  'RESET_PASSWORD.MISSING_TOKEN': 'Neispravan poziv za novu lozinku',
  'RESET_PASSWORD.INVALID_TOKEN': 'Zahtjev za novu lozinku istekao',
  'RESET_PASSWORD.SEND_NEW_REQUEST': 'Pošaljite novi zahtjev',
  'RESET_PASSWORD.RESET_DONE': 'Nova lozinka uspješno aktivirana',

  // ---------- User registration & activation
  'REGISTRATION.CHECK_BOX_TERMS_OF_USE': 'Uvjeti korištenja',
  'REGISTRATION.CHECK_BOX_GDPR_DESCRIPTION': 'Klikom na gumb "Kreirajte račun" potvrđujete da ste stariji od 16 godina, poslovno sposobni i ovlašteni raspolagati danim podacima.',
  'REGISTRATION.INFO_TEXT_1': 'Zahtjev za korisnički račun poslan na e-mail adresu',
  'REGISTRATION.INFO_TEXT_2': 'Provjerite Vaše e-mail poruke i slijedite upute',
  'REGISTRATION.EMAIL_LABEL': 'E-mail adresa kojom ćete potvrditi korisnički račun i prijavljivati se',
  'REGISTRATION.NEW_PASSWORD_LABEL': 'Lozinka',
  'REGISTRATION.CONFIRM_PASSWORD_LABEL': 'Potvrda lozinke',
  'REGISTRATION.NEW_PASSWORD_PLACEHOLDER': 'Unesite lozinku',
  'REGISTRATION.CONFIRM_PASSWORD_PLACEHOLDER': 'Unesite ponovno lozinku',
  'REGISTRATION.USERNAME_ALREADY_IN_USE': 'E-mail adresa se već koristi. Unesite neku drugu e-mail adresu.',
  'ACTIVATION.MISSING_TOKEN': 'Neispravan poziv za aktiviranje korisničkog računa',
  'ACTIVATION.INVALID_TOKEN': 'Zahtjev za aktiviranje korisničkog računa istekao',
  'ACTIVATION.SEND_NEW_REQUEST': 'Kreirajte novi aktivacijski zahtjev',
  'ACTIVATION.ACTIVATION_DONE': 'Korisnički račun uspješno aktiviran',
  'ACTIVATION.USER_LINK': 'Dopunite svoj profil kako bi mogli zatražiti vaučer',
  'REGISTRATION.BUTTON_SUBMIT_LABEL': 'Kreirajte račun',

  // ---------- Change Password
  'CHANGE_PASSWORD.VIEW_TITLE': 'Promjena lozinke',
  'CHANGE_PASSWORD.OLD_PASSWORD_LABEL': 'Stara lozinka',
  'CHANGE_PASSWORD.OLD_PASSWORD_PLACEHOLDER': 'Unesite staru lozinku',
  'CHANGE_PASSWORD.NEW_PASSWORD_LABEL': 'Nova lozinka',
  'CHANGE_PASSWORD.NEW_PASSWORD_PLACEHOLDER': 'Unesite novu lozinku',
  'CHANGE_PASSWORD.CONFIRM_PASSWORD_LABEL': 'Potvrda nove lozinke',
  'CHANGE_PASSWORD.CONFIRM_PASSWORD_PLACEHOLDER': 'Unesite ponovno novu lozinku',
  'CHANGE_PASSWORD.CHANGE_PASSWORD_BUTTON_LABEL': 'Promijeni lozinku',
  'CHANGE_PASSWORD.MINIMUM_LENGTH_VALIDATION_MESSAGE': 'Lozinka mora sadržavati minimalno 8 znakova',
  'CHANGE_PASSWORD.PASSWORD_NOT_NEW_ERROR': 'Nova lozinka se mora razlikovati od stare',
  'CHANGE_PASSWORD.PASSWORDS_DIFFERENT_ERROR': 'Nove lozinke nisu identične',
  'CHANGE_PASSWORD.CHANGE_DONE': 'Lozinka uspješno promijenjena',
  'CHANGE_PASSWORD.ERROR_MESSAGE.BAD_CREDENTIALS': 'Pogrešna stara lozinka',
  'CHANGE_PASSWORD.ERROR_MESSAGE.CHANGE_PASSWORD': 'Greška prilikom promjene lozinke',

  // ---------- Reports
  'REPORTS_NAVIGATION.REPORTS_MENU_LABEL': 'Preuzimanje izvještaja',
  'REPORTS_NAVIGATION.EDUCATION_APPLICATION_MENU_LABEL': 'Zahtjevi',
  'REPORTS_COURSES.NO_ATTENDEES_MESSAGE': 'Ovom tečaju nisu pridijeljeni polaznici',

  'COURSES_REPORT.TODO_LABEL': 'Nezapočeto',
  'COURSES_REPORT.INPROGRESS_LABEL': 'U tijeku',
  'COURSES_REPORT.COMLETED_LABEL': 'Položeno',

  'REPORTS_LIST.TABLE_EMPTY': 'Nema raspoloživih izvještaja, zatražite novi',
  'REPORTS_LIST.TABLE_UNFINISHED_REPORT': 'Izvještaj u izradi...',
  'REPORTS_LIST.TABLE_FAILED_REPORT': 'Izrada izvještaja nije uspjela',
  'REPORTS_LIST.TABLE_FILENAME_LABEL': 'Naziv datoteke',
  'REPORTS_LIST.TABLE_TYPE_LABEL': 'Tip izvještaja',
  'REPORTS_LIST.TABLE_REQUESTED_LABEL': 'Korisnik koji je zatražio',
  'REPORTS_LIST.TABLE_DATETIME_LABEL': 'Datum i vrijeme zahtjeva',
  'REPORTS_LIST.DOWNLOAD': 'Preuzmi',
  'REPORTS_LIST.DELETE': 'Ukloni',
  'REPORTS_LIST.TYPE_COURSE': 'Izvještaj pojedinog tečaja',
  'REPORTS_LIST.TYPE_GENERAL_COURSE': 'Izvještaj svih tečajeva',
  'REPORTS_LIST.TYPE_COURSE_TRAINEE': 'Izvještaj svih polaznika',
  'REPORTS_LIST.TYPE_EXTERNAL_EDUCATION_APPLICATION': 'Izvještaj zahtjeva',
  'REPORTS_LIST.CREATE_REPORT_BUTTON_LABEL': 'Zatraži izvještaj',
  'REPORTS_LIST.COURSES_MODAL_PICKER': 'Odaberite tečaj',
  'REPORTS_LIST.EDUCATION_APPLICATION_MODAL_PICKER': 'Odaberite zahtjev',
  'REPORTS_LIST.RELOAD_BUTTON_TOOLTIP': 'Osvježavanje popisa izvještaja',
  // info message
  'REPORTS.CREATE_INFO_TITLE': 'Izvještaj zatražen',
  'REPORTS.CREATE_INFO_MESSAGE': 'Kreiranje može potrajati. Za provjeru pritisnite gumb za osvježavanje popisa izvještaja u zaglavlju tablice.',
  'REPORTS.DELETED_MESSAGE': 'Izvještaj obrisan',
  // error message
  'REPORTS_LIST.ERROR_MESSAGE.REPORT_NOT_CREATED': 'Greška pri brisanju, izvještaj nije kreiran',

  // ---------- Administration
  'ADMINISTRATION_NAVIGATION.USERS_MENU_LABEL': 'Korisnici',
  'ADMINISTRATION_NAVIGATION.USERS_MANAGEMENT_MENU_LABEL': 'Upravljanje korisnicima',
  'ADMINISTRATION_NAVIGATION.USERS_IMPORT_MENU_LABEL': 'Uvoz HRNET korisnika',
  'ADMINISTRATION_NAVIGATION.TIMUN_USER_IMPORT_MENU_LABEL': 'Uvoz korisnika',
  'ADMINISTRATION_NAVIGATION.WORKPOSITION_MENU_LABEL': 'Upravljanje radnim mjestima',
  'ADMINISTRATION_NAVIGATION.APPROVAL_COMMENT_MENU_LABEL': 'Odobravanje komentara',
  'ADMINISTRATION_NAVIGATION.RESULTS_MENU_LABEL': 'Rezultati provjere znanja',
  'ADMINISTRATION_NAVIGATION.NOTIFICATIONS_MENU_LABEL': 'Obavijesti',
  'ADMINISTRATION_NAVIGATION.USER_ACTIVITIES_MENU_LABEL': 'Aktivnosti korisnika',
  'ADMINISTRATION_NAVIGATION.EMAIL_TEMPLATES_MENU_LABEL': 'E-mail predlošci',
  'ADMINISTRATION_NAVIGATION.USER_GROUPS_MENU_LABEL': 'Korisničke grupe',
  'ADMINISTRATION_NAVIGATION.SKILL_GROUPS_MENU_LABEL': 'Vještine',
  'ADMINISTRATION_NAVIGATION.USER_GROUPS': 'Korisničke grupe',
  'ADMINISTRATION_NAVIGATION.SURVEY_TEMPLATE_MENU_LABEL': 'Predlošci upitnika',
  'ADMINISTRATION_NAVIGATION.CODEBOOKS_MENU_LABEL': 'Šifrarnici',
  'ADMINISTRATION_NAVIGATION.TENANT_MENU_LABEL': 'Tenant',
  'ADMINISTRATION_NAVIGATION.TENANT_ORGANIZATION_MENU_LABEL': 'Postavke sustava',
  'ADMINISTRATION_NAVIGATION.ORGANIZATION_GROUPS_MENU_LABEL': 'Organizacijske grupe',
  'ADMINISTRATION_NAVIGATION.BUSINESS_PROFILES_MENU_LABEL': 'Poslovni profili',
  'ADMINISTRATION.WORKPOSITION_UPDATE_COURSES_BUTTON_LABEL': 'Pridruži tečajeve',
  'ADMINISTRATION.WORKPOSITION_UPDATE_NAME_LABEL': 'Naziv',
  'ADMINISTRATION.WORKPOSITION_UPDATE_MODAL_TITLE': 'Uredi radno mjesto',
  'ADMINISTRATION.WORKPOSITION_UPDATE_SKILLS_PANEL_LABEL': 'Vještine',
  'ADMINISTRATION.WORKPOSITION_UPDATE_ADD_SKILL_BUTTON_LABEL': 'Pridruži vještinu',
  'ADMINISTRATION.CONTAINER_CREATE_WORKPOSITION': 'Novo radno mjesto',
  'ADMINISTRATION.UPDATE_WORKPOSITION': 'Radno mjesto',
  'ADMINISTRATION.WORKPOSITION_CRREATED_MESSAGE': 'Radno mjesto je uspješno kreirano',
  'ADMINISTRATION_NAVIGATION.SKILLS_GAP_MENU_LABEL': 'Skills gap',
  'ADMINISTRATION_NAVIGATION.CACHE_MENU_LABEL': 'Cache evict',
  'ADMINISTRATION_NAVIGATION.LDAP_SYNC_LABEL': 'LDAP sinkronizacija',

  // ----------- Admin cache
  'ADMIN_CACHE_LIST.CACHE_EVICT_ALL': 'Obrišite cijeli cache',
  'ADMIN_CACHE_LIST.CACHE_EVICT': 'Obriši cache',
  'ADMIN_CACHE_LIST.CACHE_TITLE.COUNTIES': 'Županije',
  'ADMIN_CACHE_LIST.CACHE_TITLE.EDUCATIONCATEGORIES': 'Kategorije programa',
  'ADMIN_CACHE_LIST.CACHE_TITLE.EXTERNALEDUCATIONTEMPLATES': 'Programi obrazovanja',
  'ADMIN_CACHE_LIST.CACHE_TITLE.LOCATIONS': 'Lokacije',
  'ADMIN_CACHE_LIST.CACHE_TITLE.SKILLGROUPSACTIVE': 'Aktivni grupe vještina',
  'ADMIN_CACHE_LIST.CACHE_TITLE.SKILLGROUPSALL': 'Grupe vještina',
  'ADMIN_CACHE_LIST.CACHE_TITLE.SKILLSBYSKILLGROUPALL': 'Vještine prema grupi vještina',
  'ADMIN_CACHE_LIST.CACHE_TITLE.EDUCATIONSECTORS': 'Obrazovni sektor',
  'ADMIN_CACHE_LIST.CACHE_TITLE.ENROLLMENTREQUIREMENTS': 'Uvjeti za upis programa',
  'ADMIN_CACHE_LIST.CACHE_TITLE.EXTERNALEDUCATIONINSTANCES': 'Lokacije izvođenja programa',
  'ADMIN_CACHE_LIST.CACHE_TITLE.BUSINESSPROFILES': 'Poslovni profili',
  'ADMIN_CACHE_LIST.CACHE_TITLE.SKILLS': 'Vještine',
  'ADMIN_CACHE_LIST.CACHE_TITLE.SKILLSBYSKILLGROUPACTIVE': 'Vještine po grupama vještina koje su aktivne',
  'ADMIN_CACHE_LIST.CACHE_EVICT_SUCCESS': 'Uspješno obrisan cache',

  // ---------- User Activities
  'USER_ACTIVITY.TYPE.LEFT_COMMENT': 'Komentari',
  'USER_ACTIVITY.TYPE.COMPLETED_COURSE': 'Tečaj završen',
  'USER_ACTIVITY.TYPE.ADDED_VOTE': 'Glasovi',
  'USER_ACTIVITY.TYPE.CHANGED_VOTE': 'Promijenjeni glasovi',
  'USER_ACTIVITY.TYPE.REMOVED_VOTE': 'Uklonjeni glasovi',
  'USER_ACTIVITY.TYPE.CREATED_REMINDER': 'Podsjetnici',
  'USER_ACTIVITY.LIST_LABEL': 'Aktivnosti korisnika',
  'USER_ACTIVITY.LIST_EMPTY': 'Nema aktivnosti',

  // ---------- User Activities List
  'USER_ACTIVITY_LIST.TIME_COLUMN_TITLE': 'Datum',
  'USER_ACTIVITY_LIST.TIME_TARGET_USER_COLUMN_TITLE': 'Primatelj',
  'USER_ACTIVITY_LIST.ACTIVITY_COLUMN_TITLE': 'Aktivnost',
  'USER_ACTIVITY_LIST.TIMELINE_ACTION.LEFT_COMMENT': 'je ostavio/la komentar na',
  'USER_ACTIVITY_LIST.TIMELINE_ACTION.COMPLETED_COURSE': 'je završio/la tečaj',
  'USER_ACTIVITY_LIST.TIMELINE_ACTION.CREATED_REMINDER': 'je napravio podsjetnik.',
  'USER_ACTIVITY_LIST.TIMELINE_ACTION.ADDED_VOTE': 'je dodao/la glas na',
  'USER_ACTIVITY_LIST.TIMELINE_ACTION.CHANGED_VOTE': 'je promijenio/la glas na',
  'USER_ACTIVITY_LIST.TIMELINE_ACTION.REMOVED_VOTE': 'je uklonio/la glas na',
  'USER_ACTIVITY_LIST.USER': 'Korisnik',

  // ---------- Activity filter
  'USER_ACTIVITY_LIST_FILTER.USER_LABEL': 'Korisnik',
  'USER_ACTIVITY.TYPE.ALL_TYPES': 'Sve aktivnosti',
  'USER_ACTIVITY_LIST_FILTER.START_DATE_LABEL': 'Datum od',
  'USER_ACTIVITY_LIST_FILTER.END_DATE_LABEL': 'Datum do',
  'USER_ACTIVITY_LIST_FILTER.ACTIVITY_TYPE_LABEL': 'Vrsta',
  'USER_ACTIVITY_LIST_FILTER.USER_NAME_PLACEHOLDER': 'Upišite dio imena/prezimena',

  // ---------- Diagrams
  'DIAGRAMS.ACTION_EDIT': 'Uredi dijagram',
  'DIAGRAMS.ACTION_CREATE': 'Novi dijagram',

  // ---------- Education group list
  'EDUCATION_GROUP_LIST.VIEW_TITLE': 'Program obrazovanja',
  'EDUCATION_GROUP_LIST.CREATE_GROUP_TITLE': 'Dodaj novi predmet',
  'EDUCATION_GROUP_LIST.GROUP_TITLE': 'Predmet',
  'EDUCATION_GROUP.CREATED_MESSAGE': 'Program obrazovanja spremljen',

  // ---------- Education group
  'EDUCATION_GROUP.CURRICULUM': 'Kurikulum',
  'EDUCATION_GROUP.CHECK': 'Pregledaj',
  'EDUCATION_GROUP.ADD_EXAM_TEMPLATE': 'Provjera znanja',
  'EDUCATION_GROUP.ADD_COURSE': 'Dodaj tečaj',
  'EDUCATION_GROUP.ITEM.TYPE': 'Tip',
  'EDUCATION_GROUP.ITEM.TYPE.EXAM_TEMPLATE': 'Predložak provjere znanja',
  'EDUCATION_GROUP.ITEM.TYPE.COURSE': 'Tečaj',
  'EDUCATION_GROUP.ITEM.TYPE.EXAM_INSTANCE': 'Provjera znanja',
  'EDUCATION_GROUP.ITEM.TITLE': 'Naziv',

  // ---------- Exam template
  'EXAM_TEMPLATE.EXAM_TEMPLATE_HEADER_LABEL': 'Tečaj',
  'EXAM_TEMPLATE.CREATE_TITLE': 'Provjera znanja: %{examTemplateTitle}',
  'EXAM_TEMPLATE.TITLE': 'Naslov predloška provjere znanja',
  'EXAM_TEMPLATE.VIEW_QUESTION_LIST': 'Pregledaj listu pitanja',
  'EXAM_TEMPLATE.VIEW_ASSIGNED_EXAMS': 'Pregled dodijeljenih provjera znanja',
  'EXAM_TEMPLATE.GENERATE_EXAMS': 'Generiraj provjeru znanja',
  'EXAM_TEMPLATE.GENERATE_EXAMS_INFO_MESSAGE': 'Za generiranje provjere znanja potrebno je dodati korisnike',
  'EXAM_TEMPLATE.OUTCOME': 'Ishod',
  'EXAM_TEMPLATE.EDIT_BUTTON_LABEL': 'Uredite predložak provjere znanja',
  'EXAM_TEMPLATE.FORM_TITLE': 'Predložak provjere znanja %{examTemplateTitle}',
  'EXAM_TEMPLATE.FORM_INSTRUCTION_TITLE': 'Unesite postupak',
  'EXAM_TEMPLATE.FORM_SETTINGS_NUMBER_OF_QUESTIONS_TITLE': 'Broj pitanja za riješavanje (Max broj dostupnih pitanja: %{numberOfQuestions})',
  'EXAM_TEMPLATE.FORM_SETTINGS_GRADE_THRESHOLD_TITLE': 'Postotak riješenosti provjere znanja da bi se tečaj smatrao položenim',
  'EXAM_TEMPLATE.FORM_SETTINGS_ANSWERS_VISIBLE_TITLE': 'Vidljivost odgovora',
  'EXAM_TEMPLATE.FORM_SETTINGS_SKIP_EVALUATION_TITLE': 'Preskoči ocjenjivanje',
  'EXAM_TEMPLATE.FORM_SETTINGS_ALLOW_EXAM_REVISION_TITLE': 'Omogućite višestruko riješavanje provjere znanja',
  'EXAM_TEMPLATE.FORM_SETTINGS_RANDOM_QUESTION_ORDER_TITLE': 'Omogućite nasumičan redoslijed pitanja',
  'EXAM_TEMPLATE.FORM_SETTINGS_SHOW_OUTCOMES_TITLE': 'Prikaži ishode',
  'EXAM_TEMPLATE.FORM_SETTINGS_ATTEMPTS_NUMBER_TITLE': 'Broj pokušaja riješavanja provjere znanja',
  'EXAM_TEMPLATE.FORM.OUTCOME': 'Ishod',
  'EXAM_TEMPLATE.FORM.MAXIMUM_NUMBER_OF_QUESTIONS': 'Maksimalan broj pitanja',
  'EXAM_TEMPLATE.FORM.NUMBER_OF_QUESTIONS_IN_EXAM': 'Broj pitanja',
  'EXAM_TEMPLATE.FORM.CREATE_QUESTION_LIST': 'Kreiraj listu pitanja',
  'EXAM_TEMPLATE.FORM.ALLOWED_NUMBER_MESSAGE': 'Dozvoljeni broj pitanja je od %{min} do %{max}',
  'EXAM_TEMPLATE.EXAM_STATUS_FINISHED_INFO_LABEL': 'Tečaj je objavljen',
  // --- validation message
  'EXAM_TEMPLATE.FORM_SETTINGS.NUMBER_OF_QUESTIONS_LOW_VALIDATION': 'Kreirajte pitanje u editoru ili smanjite broj pitanja na max broj dostupnih pitanja',
  'EXAM_TEMPLATE.FORM_SETTINGS.NUMBER_OF_QUESTIONS_NONE_VALIDATION': 'Kreirajte pitanje u editoru',

  'EXAM_TEMPLATE.STATISTICS.CORRECTNESS_PERCENTAGE_CORRECT': 'Točno',
  'EXAM_TEMPLATE.STATISTICS.CORRECTNESS_PERCENTAGE_INCORRECT': 'Netočno',
  'EXAM_TEMPLATE.STATISTICS.STATISTICS_TITLE': 'Statistike provjere znanja',
  'EXAM_TEMPLATE.STATISTICS.SUBMITED_COUNT_TITLE': 'Broj riješenih provjera znanja',
  'EXAM_TEMPLATE.STATISTICS.AVERAGE_COMPLETION_TIME_TITLE': 'Prosječno vrijeme rješavanja',
  'EXAM_TEMPLATE.STATISTICS.QUESTION_CORRECTNESS_PERCENTAGE_TITLE': 'Postotak točnih odgovora',
  'EXAM_TEMPLATE.STATISTICS.QUESTION_LIST_CORRECTNESS_PERCENTAGE_TITLE': 'Točnost odgovora po pitanjima',

  'EXAM_TEMPLATE.STATISTICS.QUIZ_CORRECTNESS_PERCENTAGE_TITLE': 'Točnost rješavanja provjere znanja',
  'EXAM_TEMPLATE.STATISTICS.QUESTION_ORDERING_TITLE': 'Redni broj',
  'EXAM_TEMPLATE.STATISTICS.QUESTION_TEXT_TITLE': 'Tekst pitanja',
  'EXAM_TEMPLATE.STATISTICS.QUESTION_CORRECTNESS_TITLE': 'Točnost',

  'EXAM_TEMPLATE.SIDER.SUBMENU_EXAM_TEMPLATE_EDIT_LABEL': 'Upravljanje provjerom znanja',
  'EXAM_TEMPLATE.SIDER.MENU_QUIZ_CREATOR_LABEL': 'Uređivanje pitanja',
  'EXAM_TEMPLATE.SIDER.MENU_EXAM_TEMPLATE_SETTINGS_LABEL': 'Postavke predloška provjere znanja',
  'EXAM_TEMPLATE.SIDER.MENU_QUIZ_DISPLAY_LABEL': 'Pregled provjere znanja',
  'EXAM_TEMPLATE.SIDER.SUBMENU_STATISTICS_LABEL': 'Rezultati provjere znanja',
  'EXAM_TEMPLATE.SIDER.MENU_EXAM_STATISTIC_LABEL': 'Statistika provjere znanja',
  'EXAM_TEMPLATE.SIDER.MENU_TRAINEE_RESULTS_LABEL': 'Rezultati polaznika',

  'EXAM_TEMPLATE.QUIZ_DISPLAY.INFO_TEXT_LABEL': 'Primjer izgleda provjere znanja koji je sastavljen od svih kreiranih pitanja.',
  'EXAM_TEMPLATE.QUIZ_DISPLAY.NO_QUESTION_EMPTY_MESSAGE_LABEL': 'Trenutno nema kreiranih pitanja',
  'EXAM_TEMPLATE.SETTINGS.INFO_TEXT_LABEL': 'Ako je predložak provjere znanja završen nije moguće mijenjati postavke.',
  'EXAM_TEMPLATE.QUIZ_CREATOR.INFO_TEXT_LABEL': 'Ako je predložak provjere znanja završen nije moguće kreirati ni mijenjati pitanja.',
  // ---------- Exam instance
  'EXAM_INSTANCE.LIST.TRAINEE_LABEL': 'Korisnik/ca',
  'EXAM_INSTANCE.LIST.STATUS_LABEL': 'Status',
  'EXAM_INSTANCE.LIST_ITEM.STATUS.READY': 'Dodijeljen',
  'EXAM_INSTANCE.LIST_ITEM.STATUS.ANSWERS_SUBMITTED': 'Predan',
  'EXAM_INSTANCE.LIST_ITEM.STATUS.NEVER_STARTED': 'Nije riješen, a dostupnost je prošla',
  'EXAM_INSTANCE.LIST_ITEM.STATUS.EXTERNAL_EDUCATION_APPLICATION_CREATION': 'Izrada u tijeku',
  'EXAM_INSTANCE.LIST_ITEM.STATUS.FINISHED': 'Završeno kreiranje',
  'EXAM_INSTANCE.LIST_ITEM.STATUS.ARCHIVED': 'Arhivirano',
  'EXAM_INSTANCE.LIST_ITEM.STATUS.NOT_STARTED': 'Izrađen, nije još dostupan za rješavanje',
  'EXAM_INSTANCE.LIST_ITEM.STATUS.ANSWERING_STARTED': 'Riješavanje započeto',
  'EXAM_INSTANCE.LIST_ITEM.STATUS.IN_EVALUATION': 'Ocjenjivanje u tijeku',
  'EXAM_INSTANCE.LIST_ITEM.STATUS.EVALUATED': 'Ocijenjen',
  'EXAM_INSTANCE.LIST_ITEM.STATUS.CANCELLED': 'Otkazan',
  'EXAM_INSTANCE.LIST.EARNED_POINTS_LABEL': 'Bodovi',
  'EXAM_INSTANCE.LIST.GRADE_THRESHOLD_LABEL': 'Prolazni prag',
  'EXAM_INSTANCE.LIST.TIME_LABEL': 'Vrijeme',
  'EXAM_INSTANCE.LIST.ACTION_LABEL': 'Akcija',
  'EXAM_INSTANCE.LIST_ITEM.BUTTON.GRADE_EXAM_LABEL': 'Ocijeni provjeru znanja',
  'EXAM_INSTANCE.LIST_ITEM.BUTTON.VIEW_EVALUATION_LABEL': 'Pregledaj',
  'EXAM_INSTANCE.LIST_ITEM.BUTTON.START_THE_EXAM_LABEL': 'Započni provjeru znanja',
  'EXAM_INSTANCE.LIST_ITEM.BUTTON.CONTINUE_SOLVING_EXAM_LABEL': 'Nastavi rješavati',
  'EXAM_INSTANCE.LIST.SUBMITTED_AT_LABEL': 'Provjera znanja predana',
  'EXAM_INSTANCE.LIST.EXAM_PASSED_LABEL': 'Položena provjera znanja',
  'EXAM_INSTANCE_FORM.TOTAL_EARNED_POINTS_LABEL': 'Broj ostvarenih bodova: %{totalEarnedPoints}/%{totalPoints}',
  'EXAM_INSTANCE_FORM.ASSIGNEE': 'Polaznik:',
  'EXAM_INSTANCE.BUTTON_SUBMIT_LABEL': 'Predaj provjeru znanja',
  'EXAM_INSTANCE.CONFIRM_DIALOG_MESSAGE': 'Započni provjeru znanja',
  'EXAM_INSTANCE.EVALUATION_MESSAGE_INFO': 'Provjera znanja je u procesu ocijenjivanja',
  'EXAM_INSTANCE_LIST.TRAINEE.EXAM_ATTEMPT_NUMBER_ALLOWED_LABEL': 'Provjeri znanja moguće je pristupiti %{attemptNumber} puta.',
  'EXAM_INSTANCE_LIST.TRAINEE.REMAINING_EXAM_ATTEMPT_NUMBER_LABEL': 'Preostao broj pokušaja: %{remainingAttemptNumber}',
  'EXAM_INSTANCE_LIST.TRAINEE.EXAM_PASSED_LABEL': 'Čestitamo, položili ste provjeru znanja!',
  'EXAM_INSTANCE_LIST.TRAINEE.EXAM_FAILED_LABEL': 'Nažalost, niste uspješno položili provjeru znanja. Kontaktirajte nadređenu osobu za daljnji dogovor oko ovog tečaja.',
  'EXAM_INSTANCE_LIST.FILTER.FORM_ASSIGNEE_LABEL': 'Korisnik',

  // ----------- Notification
  'NOTIFICATION.TITLE': 'Naziv obavijesti',
  'NOTIFICATION.TEXT': 'Tekst obavijesti',
  'NOTIFICATION.NEW_NOTIFICATION': 'Nova obavijest',
  'NOTIFICATION_FORM.MESSAGE_LABEL': 'Tekst',
  'NOTIFICATION_FORM.TITLE_LABEL': 'Naziv',
  'NOTIFICATION.CREATED_MESSAGE': 'Obavijest objavljena',
  'NOTIFICATION.DELETED_MESSAGE': 'Obavijest obrisana',

  // ---------- Reminders
  'REMINDER.CREATE_BUTTON_LABEL': 'Novi podsjetnik',
  'REMINDER_FORM.LABEL': 'Podsjetnik',
  'REMINDER_FORM.DATE': 'Datum',
  'REMINDER_FORM.TIME': 'Vrijeme',
  'REMINDER_FORM.DESCRIPTION': 'Tekst podsjetnika',
  'REMINDER_FORM.DATE_VALIDATION_MESSAGE': 'Molimo odaberite datum',
  'REMINDER_FORM.TIME_VALIDATION_MESSAGE': 'Molimo odaberite vrijeme',
  'REMINDER_FORM.DESCRIPTION_VALIDATION_MESSAGE': 'Molimo unesite opis',

  'REMINDER_CALENDAR.TITLE_LABEL': 'Vaš kalendar',
  'REMINDER_CALENDAR.NEXT_MONTH': 'Sljedeći mjesec (%{month})',
  'REMINDER_CALENDAR.PREVIOUS_MONTH': 'Prethodni mjesec (%{month})',
  'REMINDER_CALENDAR.UPCOMING_EVENTS': 'Podsjetnici: %{month}',
  'REMINDER_CALENDAR.EMPTY_MESSAGE': 'Nema podsjetnika',
  'REMINDER_CALENDAR.SELECTED_DAY': 'Odabrani dan',
  'REMINDER_TYPE.USER_DEFINED': 'Podsjetnik',
  'REMINDER_TYPE.WEBINAR': 'Webinar',
  'REMINDER_TYPE.CONSULTATION': 'Konzultacije',
  'REMINDER.SET_REMINDER_TOOLTIP': 'Postavite podsjetnik',
  'REMINDER.DELETED_MESSAGE': 'Podsjetnik obrisan',
  'REMINDER.CREATED_MESSAGE': 'Podsjetnik spremljen',

  // ---------- User registration modal
  'USER_REGISTRATION.MODAL.TITLE': 'Registracija',
  'USER_REGISTRATION.MODAL.WELCOME': 'Dobrodošli %{firstName} %{lastName}! Molimo Vas provjerite i nadopunite Vaše podatke.',
  'USER_REGISTRATION.FORM.GDPR_BUTTON_LABEL': 'Pročitajte "Uvjete korištenja i pravila privatnosti"',
  // error message
  'USER_REGISGTRATION.FORM.ERROR_MESSAGE.GDPR_REQUIRED': 'Molimo Vas da pročitate i prihvatite "Uvjete korištenja i pravila privatnosti"',

  // ---------- Gdpr
  'GDPR_MODAL.TITLE': 'Uvjeti korištenja i pravila privatnosti',

  // ---------- Webinar list
  'WEBINAR_LIST_VIEW.TABS.ANOUNCED': 'U najavi',
  'WEBINAR_LIST_VIEW.TABS.FINISHED': 'Održani/Završeni',

  'WEBINAR_LIST.VIEW_TITLE': 'Webinari',
  'WEBINAR_LIST_VIEW.NO_DATA': 'Nema webinara',
  'WEBINAR_LIST_VIEW.CREATE_WEBINAR': 'Novi webinar',
  'WEBINAR_LIST_VIEW.EDIT_WEBINAR': 'Uredi',
  'WEBINAR_LIST_VIEW.ALL_WEBINARS': 'Svi webinari',
  'WEBINAR_LIST_VIEW.SORT_START_DATE_ASCEND': 'Vrijeme početka uzlazno',
  'WEBINAR_LIST_VIEW.SORT_START_DATE_DESCEND': 'Vrijeme početka silazno',

  // ---------- Webinar view
  'WEBINAR_VIEW.DATE': 'Datum',
  'WEBINAR_VIEW.STATUS': 'Status',
  'WEBINAR_VIEW.HOST': 'Gost',
  'WEBINAR_VIEW.DESCRIPTION': 'O webinaru',
  'WEBINAR_VIEW.SET_REMINDER': 'Postavite podsjetnik',
  'WEBINAR_VIEW.CREATE.CREATE_WEBINAR_TITLE': 'Novi webinar',
  'WEBINAR_VIEW.CREATE.WEBINAR_TITLE': 'Naziv',
  'WEBINAR_VIEW.CREATE.WEBINAR_LINK': 'Poveznica na webinar',
  'WEBINAR_VIEW.CREATE.WEBINAR_DATE': 'Datum',
  'WEBINAR_VIEW.CREATE.WEBINAR_TIME': 'Vrijeme',
  'WEBINAR_VIEW.CREATE.WEBINAR_GUEST': 'Gost',
  'WEBINAR_VIEW.CREATE.WEBINAR_DESCRIPTION': 'Opis/tema',
  'WEBINAR_VIEW.CREATE.WEBINAR_PHOTO': 'Fotografija',
  'WEBINAR_VIEW.CREATE.WEBINAR_DATE_PLACEHOLDER': 'Unesite datum početka',
  'WEBINAR_VIEW.CREATE.WEBINAR_TIME_PLACEHOLDER': 'Unesite vrijeme početka',
  'WEBINAR_VIEW.CREATE.WEBINAR_STATUS': 'Status',
  'WEBINAR_VIEW.COMMENTS': 'Komentari',
  'WEBINAR_VIEW.NOTES': 'Bilješke',
  'WEBINAR.STATUS_TITLE.IN_CREATION': 'U izradi',
  'WEBINAR.STATUS_TITLE.CREATION_FINISHED': 'Izrada završena',
  'WEBINAR.STATUS_TITLE.IN_PROGRESS': 'U tijeku',
  'WEBINAR.STATUS_TITLE.FINISHED': 'Završen',
  'WEBINAR.STATUS_TITLE.CANCELLED': 'Otkazan',
  'WEBINAR.STATUS_TITLE.PUBLISHED': 'Objavljen',
  'WEBINAR.STATUS_TITLE.ARCHIVED': 'Arhiviran',

  // ---------- Notifications
  'NOTIFICATIONS.NOTIFICATIONS': 'Obavijesti',
  'NOTIFICATIONS.SHOW_ALL': 'Prikaži sve',
  'NOTIFICATIONS.CREATE_NOTIFICATION': 'Nova obavijest',
  'NOTIFICATION_LIST.DATE_TIME': 'Datum i vrijeme',
  'NOTIFICATION_LIST.NOTIFICATION_TITLE': 'Naziv',
  'NOTIFICATION_LIST.NOTIFICATION_MESSAGE': 'Tekst',
  'NOTIFICATION_LIST.NO_DATA': 'Nema obavijesti',
  'NOTIFICATION_LIST.SEARCH_NOTIFICATIONS': 'Pretraži',
  'NOTIFICATION_LIST_FILTER.SORT_BY_TYPE': 'Obavijesti po tipu',
  'NOTIFICATION_LIST_FILTER.SELECTOR_OPTION.ALL_NOTIFICATIONS': 'Sve obavijesti',
  'NOTIFICATION_FORM.PERSONAL_TYPE': 'Personalizirane',
  'NOTIFICATION_FORM.GENERIC_TYPE': 'Opće',
  'NOTIFICATION_LIST.NOTIFICATION_TYPE': 'Tip',

  // ------------ Quiz
  'QUIZ_CREATOR.MODAL_TITLE': 'Uređivač pitanja',
  'QUIZ_CREATOR.QUESTION_SUCCESS_INFO_MESSAGE': 'Pitanje spremljeno',
  'QUIZ_CREATOR.QUESTION_DELETED_MESSAGE': 'Pitanje obrisano',
  'QUIZ_CREATOR.QUESTION_ERROR_INFO_MESSAGE': 'Pitanje nije spremljeno, unesite moguće odgovore na kreirano pitanje',

  // ---------- Repository
  'REPOSITORY.TITLE': 'Baza znanja',
  'REPOSITORY.DOCUMENTS_LABEL': 'Dokumenti',
  'REPOSITORY.DOCUMENTS_EMPTY_LABEL': 'Nema dokumenata',
  'REPOSITORY.COURSES_LABEL': 'Tečajevi',
  'REPOSITORY.WEBINARS_LABEL': 'Webinari',
  'REPOSITORY.USERS_LABEL': 'Korisnici',
  'REPOSITORY.USERS_EMPTY_LABEL': 'Nema korisnika',
  'REPOSITORY.TAG_FILTER_LABEL': 'Oznake',
  'REPOSITORY.SELECTED_TAGS_LABEL': 'Odabrane oznake',
  'REPOSITORY.TAG_FILTER_SEARCH_LABEL': 'Pretražite oznake',
  'REPOSITORY.TAG_HEADER_LABEL': 'Oznake',
  'REPOSITORY.FILE_ADD_LABEL': 'Nova datoteka',
  'REPOSITORY.FILE_REMOVED_MESSAGE': 'Datoteka obrisana',

  // ---------- Tags
  'TAG_CONTAINER.ADD_TAG': 'Nova oznaka',
  // error messages
  'TAG_ERROR_MESSAGE.TITLE_ALREADY_IN_USE': 'Vanjska poveznica s istim nazivom već postoji. Odaberite drugi naziv. ',

  // ---------- Tenant Configuration
  'TENANT_CONFIGURATION_VIEW.DISPLAY_NAME_LABEL': 'Naziv',
  'TENANT_CONFIGURATION_VIEW.LOGO_IMAGE_LABEL': 'Logo',
  'TENANT_CONFIGURATION_VIEW.SECONDARY_LOGO_IMAGE_LABEL': 'Sekundarni logo',
  'TENANT_CONFIGURATION_VIEW.ENABLE_WEBINARS_LABEL': 'Korištenje webinara',
  'TENANT_CONFIGURATION_VIEW.ENABLE_LOCALES_LABEL': 'Omogući višejezičnost',
  'TENANT_CONFIGURATION_VIEW.ENABLE_COURSES_LABEL': 'Korištenje tečajeva',
  'TENANT_CONFIGURATION_VIEW.ENABLE_SCORM_COURSES_LABEL': 'Korištenje SCORM tečajeva',
  'TENANT_CONFIGURATION_VIEW.ENABLE_DASHBOARD_LABEL': 'Korištenje dashboarda',
  'TENANT_CONFIGURATION_VIEW.ENABLE_EXTERNAL_CONTENTS_LABEL': 'Korištenje vanjskih poveznica',
  'TENANT_CONFIGURATION_VIEW.ENABLE_REPOSITORY_LABEL': 'Korištenje baze znanja',
  'TENANT_CONFIGURATION_VIEW.ENABLE_USER_GROUPS_LABEL': 'Korištenje korisničkih grupa',
  'TENANT_CONFIGURATION_VIEW.ENABLE_ORGANIZATION_GROUP_COURSES_LABEL': 'Dodavanje tečajeva organizacijskim grupama',
  'TENANT_CONFIGURATION_VIEW.ENABLE_ORGANIZATION_GROUP_LABEL': 'Organizacijske grupe',
  'TENANT_CONFIGURATION_VIEW.ENABLE_ORGANIZATION_GRAPH_LABEL': 'Korištenje organizacijskog grafa',
  'TENANT_CONFIGURATION_VIEW.STYLE_THEME_LABEL': 'Tema',
  'TENANT_CONFIGURATION_VIEW.BACKGROUND_IMAGE_LABEL': 'Pozadinska slika',
  'TENANT_CONFIGURATION_VIEW.ENABLE_EXTERNAL_EDUCATION_APPLICATIONS_LABEL': 'Korištenje zahtjeva',
  'TENANT_CONFIGURATION_VIEW.ENABLE_EXTERNAL_EDUCATIONS_TEMPLATE_LABEL': 'Korištenje programa obrazovanja',
  'TENANT_CONFIGURATION_VIEW.DISPLAY_TERMS_LABEL': 'Uvjeti ugovora',
  'TENANT_CONFIGURATION_VIEW.FOOTER_LABEL': 'Podnožje',
  'TENANT_CONFIGURATION_VIEW.JAVASCRIPT_LABEL': 'Javascript',
  'TENANT_CONFIGURATION_VIEW.JAVASCRIPT_TOOLTIP': 'Upišite čisti JavaScript kod bez <script> taga',
  'TENANT_CONFIGURATION_VIEW.ENABLE_INTEGRATION_VIDEO': 'Video integracija (Vimeo)',
  'TENANT_CONFIGURATION_VIEW.EXAM_QUESTION_LIST': 'Vrste pitanja u kreatoru provjere znanja',
  'TENANT_CONFIGURATION_VIEW.SURVEY_QUESTION_LIST': 'Vrste pitanja u kreatoru upitnika',
  'TENANT_CONFIGURATION_VIEW.ENABLE_NOTZ': 'Korištenje Notz-a',
  'TENANT_CONFIGURATION_VIEW.ENABLE_HRNET_USER_IMPORT': 'Uvoz HRNET korisnika',
  'TENANT_CONFIGURATION_VIEW.ENABLE_TIMUN_USER_IMPORT': 'Uvoz korisnika',
  'TENANT_CONFIGURATION_VIEW.ENABLE_ORGANIZATION_GRAPH_EDIT': 'Uređivanje organizacijskog grafa',
  'TENANT_CONFIGURATION_VIEW.ENABLE_SKILL_LABEL': 'Korištenje vještina',
  'TENANT_CONFIGURATION_VIEW.ENABLE_RECOMMEDITION_LABEL': 'Korištenje skill gap',
  'TENANT_CONFIGURATION_VIEW.ENABLE_USER_PROFILE_EDIT_LABEL': 'Uređivanje korisničkog profila',
  'TENANT_CONFIGURATION_VIEW.ENABLE_USER_IDENTIFICATION_DETAILS_EDIT_LABEL': 'Uređivanje osobnih podataka (ime, prezime, oib)',
  'TENANT_CONFIGURATION_VIEW.ENABLE_LDAP_SYNC': 'LDAP sinkronizacija',
  'TENANT_CONFIGURATION_VIEW.HZZ_TITLE': 'HZZ',
  'TENANT_CONFIGURATION_VIEW.USER_IMPORT_TITLE': 'Uvoz korisnika',
  'TENANT_CONFIGURATION_VIEW.COURSES_TITLE': 'Tečajevi',
  'TENANT_CONFIGURATION_VIEW.SKILLS_TITLE': 'Vještine',
  'TENANT_CONFIGURATION_VIEW.CODEBOOKS_TITLE': 'Šifrarnici',
  'TENANT_CONFIGURATION_VIEW.GROUPS_TITLE': 'Grupe',
  'TENANT_CONFIGURATION_VIEW.QUIZZLER_TITLE': 'Kreator ispita/upitnika',
  'TENANT_CONFIGURATION_VIEW.BASIC_SYSTEM_SETTINGS_TITLE': 'Općenite postavke sustava',
  // --- admin tabs
  'TENANT_CONFIGURATION_VIEW.ENABLE_ADMIN_WORKPOSITIONS': 'Administracija radnih mjesta',
  'TENANT_CONFIGURATION_VIEW.ENABLE_ADMIN_SURVEYS': 'Administracija upitnika',
  'TENANT_CONFIGURATION_VIEW.ENABLE_ADMIN_SKILLS': 'Administracija vještina',
  'TENANT_CONFIGURATION_VIEW.ENABLE_ADMIN_SKILL_LEVELS': 'Administracija razina vještina',
  'TENANT_CONFIGURATION_VIEW.ENABLE_ADMIN_EMAILS': 'Administracija e-mail predložaka',
  'TENANT_CONFIGURATION_VIEW.ENABLE_ADMIN_ACTIVITIES': 'Administracija aktivnosti',
  'TENANT_CONFIGURATION_VIEW.ENABLE_ADMIN_NOTIFICATIONS': 'Administracija obavijesti',
  'TENANT_CONFIGURATION_VIEW.ENABLE_ADMIN_BUSINESS_PROFILE': 'Administracija poslovnih profila',
  'TENANT_CONFIGURATION_VIEW.ENABLE_ADMIN_COMMENTS': 'Administracija komentara',
  'TENANT_CONFIGURATION_VIEW.ENABLE_ADMIN_CODEBOOKS': 'Administracija šifrarnika',
  'TENANT_CONFIGURATION_VIEW.ADMIN_CODEBOOK_LIST': 'Dostupni admin šifrarnici',
  'TENANT_CONFIGURATION_VIEW.ENABLE_ADMIN_RECOMMEDITION': 'Administracija skill gap',

  // ---------- External content
  'EXTERNAL_CONTENT.LIST.TITLE': 'Vanjske poveznice',
  'EXTERNAL_CONTENT.LIST.FILTER_PLACEHOLDER': 'Pretraži poveznice',
  'EXTERNAL_CONTENT.LIST.EMPTY_MESSAGE': 'Nema vanjskih poveznica',
  'EXTERNAL_CONTENT.LIST.ADD': 'Nova poveznica',
  'EXTERNAL_CONTENT.CREATE.TITLE': 'Popis vanjskih sadržaja',
  'EXTERNAL_CONTENT.FORM.TITLE_LABEL': 'Naziv',
  'EXTERNAL_CONTENT.FORM.URL_LABEL': 'Poveznica',
  'EXTERNAL_CONTENT.FORM.DESCRIPTION_LABEL': 'Opis',
  'EXTERNAL_CONTENT.FORM.COVER_LABEL': 'Slika',
  'EXTERNAL_CONTENT.FORM.TITLE_WHITESPACE_MESSAGE': 'Unesite ispravan naslov',
  'EXTERNAL_CONTENT.FORM.TITLE_REQUIRED_MESSAGE': 'Unesite naslov',
  'EXTERNAL_CONTENT.FORM.URL_REGEX_MESSAGE': 'Unesite ispravnu poveznicu',
  'EXTERNAL_CONTENT.FORM.URL_REQUIRED_MESSAGE': 'Unesite poveznicu',
  'EXTERNAL_CONTENT.FORM.DESCRIPTION_WHITESPACE_MESSAGE': 'Unesite ispravan opis',
  'EXTERNAL_CONTENT.DELETED_MESSAGE': 'Vanjska poveznica je obrisana',

  // ---------- E-mail template
  'EMAIL_TEMPLATE_LIST.EMAIL_TEMPLATE_TITLE': 'Naziv',
  'EMAIL_TEMPLATE_LIST.EMAIL_TEMPLATE_CONTENT': 'Tekst',
  'EMAIL_TEMPLATE_LIST.EMAIL_TEMPLATE_TYPE': ' Vrsta',
  'EMAIL_TEMPLATE_LIST.NO_DATA': 'Nema e-mail predložaka',
  'EMAIL_TEMPLATE_FORM.INACTIVE_USER_TYPE': 'Neaktivnost korisnika',
  'EMAIL_TEMPLATE_FORM.TITLE_LABEL': 'Naziv e-mail predloška:',
  'EMAIL_TEMPLATE_FORM.CONTENT_LABEL': 'Tekst e-mail predloška:',
  'EMAIL_TEMPLATE_FORM.TYPE_LABEL': 'Odaberite tip e-mail predloška:',
  'EMAIL_TEMPLATE_FORM.CODE_GENERATION_TYPE': 'Generiranje kodova',
  'EMAIL_TEMPLATE_FILTER.ALL_TYPES_LABEL': 'Svi tipovi',
  'EMAIL_TEMPLATE.ADD_EMAIL_TEMPLATE_LABEL': 'Novi e-mail predložak',
  'EMAIL_TEMPLATE.CREATE_EMAIL_TEMPLATE_TITLE': 'Kreiraj e-mail predložak',
  'EMAIL_TEMPLATE.EDIT_EMAIL_TEMPLATE_TITLE': 'Uredi e-mail predložak',
  'EMAIL_TEMPLATE.DELETED_MESSAGE': 'Predložak je obrisan',
  'EMAIL_TEMPLATE_LIST.EMAIL_TEMPLATE_CONTENT_LINK_LABEL': 'Prikaži sadržaj',
  'EMAIL_TEMPLATE.TEMPLATE_CREATED_MESSAGE': 'E-mail predložak spremljen',
  'EMAIL_TEMPLATE.TEMPLATE_DELETED_MESSAGE': 'Predložak obrisan',

  // ---------- Member list
  'MEMBER_LIST.ROLE_LABEL': 'Uloga',
  'MEMBER_LIST.USER_LABEL': 'Korisnik',
  'MEMBER_LIST.ROLE_PICKER_PLACEHOLDER_LABEL': 'Odaberite ulogu',
  'MEMBER_LIST.USER_PICKER_PLACEHOLDER_LABEL': 'Odaberite korisnika',

  // ---------- Type picker
  'TYPE_PICKER.LIST_TYPE_LABEL': 'Prikaz',
  'TYPE_PICKER.LIST_TYPE_CARD_LABEL': 'Kartice',
  'TYPE_PICKER.LIST_TYPE_TABLE_LABEL': 'Lista',

  // ---------- User group
  'USER_GROUP.NO_DATA': 'Nema korisničkih grupa',
  'USER_GROUP.AVAILABLE.NO_DATA': 'Nema dostupnih grupa',
  'USER_GROUP.LEAVE_CONFIRM_TITLE': 'Sigurno želite napustiti grupu?',
  'USER_GROUP.COMMON_ACTION_LEAVE': 'Napusti grupu',
  'USER_GROUP.COMMON_ACTION_JOIN': 'Pristupi grupi',
  'USER_GROUP.NEW_GROUP_TITLE': 'Nova korisnička grupa',
  'USER_GROUP.EDIT_GROUP_TITLE': 'Uredi korisničku grupu',
  'USER_GROUP_VIEW.LABEL': 'Korisničke grupe',
  'USER_GROUP_VIEW.DESCRIPTION_LABEL': 'Opis grupe:',
  'USER_GROUP_VIEW.ACCESS_CODE_LABEL': 'Kod za pozivanje u grupu:',
  'USER_GROUP_VIEW.NAVIGATION_MENU_MEMEBERS_LABEL': 'Članovi',
  'USER_GROUP_VIEW.NAVIGATION_MENU_MATERIALS_LABEL': 'Materijali',
  'USER_GROUP_VIEW.NAVIGATION_MENU_COURSES_LABEL': 'Tečajevi',
  'USER_GROUP_VIEW.PENDING_MEMBER_INFO_TEXT': 'Administrator grupe mora potvrditi vaše članstvo da biste vidjeli sve podatke grupe',
  'USER_GROUP_MEMBER_LIST.ROLE_LABEL': 'Uloga:',
  'USER_GROUP_MEMBER_LIST.ROLE_TYPE.OWNER': 'Vlasnik',
  'USER_GROUP_MEMBER_LIST.ROLE_TYPE.ADMIN': 'Administrator grupe',
  'USER_GROUP_MEMBER_LIST.ROLE_TYPE.MEMBER': 'Član',
  'USER_GROUP_MEMBER_LIST.ROLE_TYPE.PENDING_MEMBER': 'Čeka odobrenje',
  'USER_GROUP_LIST_VIEW.MY_GROUPS_TITLE': 'Moje grupe',
  'USER_GROUP_LIST_VIEW.TABS.MY_USER_GROUPS_LABEL': 'Korisničke grupe',
  'USER_GROUP_LIST_VIEW.TABS.MY_ORGANIZATION_GROUPS_LABEL': 'Organizacijske grupe',
  'USER_GROUP_LIST_VIEW.TABS.AVAILABLE_GROUP_LIST_LABEL': 'Dostupne grupe',
  'USER_GROUP_LIST_VIEW.FILE_ADD_LABEL': 'Nova datoteka',
  'USER_GROUP.LIST_VIEW.HIERARCHY_TREE_TITLE': 'Organizacijski graf',
  'USER_GROUP.LIST_VIEW.HIERARCHY_NODE_ADMIN_LABEL': 'Administrator grupe',
  'USER_GROUP.JOIN_BUTTON_LABEL': 'Pridruži se grupi',
  'USER_GROUP.LEAVE_BUTTON_LABEL': 'Napusti grupu',
  'USER_GROUP.LEFT_GROUP_MESSAGE': 'Napustili ste grupu',
  'USER_GROUP.JOINED_GROUP_MESSAGE': 'Pridružili ste se grupi',
  'USER_GROUP.CREATED_GROUP_MESSAGE': 'Korisnička grupa spremljena',
  'USER_GROUP.LDAP_SYNC_LABEL': 'LDAP sinkronizacija',

  // error messages
  'USER_GROUP_ERROR_MESSAGE.ERROR.NON_EXISTING_USER_GROUP': 'Kod ne odgovara ni jednoj grupi u sustavu',
  'USER_GROUP_ERROR_MESSAGE.ERROR.USER_ALREADY_MEMBER_OF_ORGANIZATION_GROUP': 'Korisnik je već član druge grupe',

  // ---------- User group form
  'USER_GROUP_FORM.NAME_LABEL': 'Naziv grupe',
  'USER_GROUP_FORM.DESCRIPTION_LABEL': 'Opis',
  'USER_GROUP_FORM.VISIBILITY_LABEL': 'Vidljivost grupe',
  'USER_GROUP_FORM.VISIBILITY_TITLE_PUBLIC': 'Javno',
  'USER_GROUP_FORM.VISIBILITY_TITLE_LIMITED': 'Ograničeno',
  'USER_GROUP_FORM.VISIBILITY_TITLE_CLOSED': 'Privatno',
  'USER_GROUP_FORM.TYPE_LABEL': 'Vrsta korisničke grupe',
  'USER_GROUP_FORM.TYPE_BASIC': 'Osnovna',
  'USER_GROUP_FORM.TYPE_ORGANIZATION': 'Organizacijska',
  'USER_GROUP_FORM.PARENT_PICKER_LABEL': 'Nadređena grupa',

  'USER_GROUP_ACCESS_FORM.ACCESS_CODE_LABEL': 'Pristupni kod',
  'USER_GROUP_ACCESS_FORM.TITLE': 'Unesite pristupni kod za grupu',
  'USER_GROUP_EDIT_FORM.EDIT_LABEL': 'Uredi korisničku grupu',

  // ---------- User group form hierarchy picker
  'USER_GROUP_HIERARCHY_DATA_PICKER.PLACEHOLDER': 'Odaberite nadređenu grupu',

  // ---------- User group workposition
  'USER_GROUP_WORKPOSITION.TREE.INFO_TEXT_LABEL': 'Odaberite organizacijske grupe kojima želite pridružiti tečaj. Korisnicima koji pripadaju toj organizacijskoj grupi tečaj će automatski biti dodijeljen.',
  'USER_GROUP_WORKPOSITION.TREE.DISCLAIMER_INFO_TEXT_LABEL': 'Ako uklonite pridodijeljivanje tečaja organizacijskoj grupi svi njeni članovi će također biti maknuti s tečaja.',
  'USER_GROUP_WORKPOSITION.TREE.APPLIED_FILTER_LABEL': 'Prikaži samo radna mjesta članova odabrane organizacijske grupe',
  'USER_GROUP_WORKPOSITION.TREE.USER_GROUP_HIERARCHY_LABEL': 'Organizacijske grupe',
  'USER_GROUP_WORKPOSITION.TREE.USER_GROUP_HIERARCHY_PLACEHOLDER': 'Odaberite organizacijsku grupe',
  'USER_GROUP_WORKPOSITION.TREE.WORKPOSITION_LABEL': 'Radna mjesta',
  'USER_GROUP_WORKPOSITION.TREE.UNSELECTED_GROUP_EMPTY_LABEL': 'Odaberite organizacijsku grupu s lijeve strane',

  // ---------- Access code form
  'ACCESS_CODE_FORM.JOIN_BUTTON_LABEL': 'Pridruži se',
  'ACCESS_CODE_FORM.LEAVE_BUTTON_LABEL': 'Napusti',
  'ACCESS_CODE_FORM.GENERATE_LABEL': 'Generiranje novog pristupnog koda',
  'ACCESS_CODE_FORM.GENERATE_BUTTON_LABEL': 'Generiraj kod',
  'ACCESS_CODE_FORM.ACCESS_CODE_LABEL': 'Pristupni kod',
  'ACCESS_CODE_FORM.CODE_EXPIRATION_LABEL': 'Datum isteka koda',
  'ACCESS_CODE_FORM.TITLE': 'Unesite pristupni kod',
  'ACCESS_CODE_FORM.URL_LABEL': 'Poveznica',

  // ---------- Skill groups
  'SKILL_GROUP_LIST.SKILL_GROUP_DESCRIPTION_LABEL': 'Područje vještina:',
  'SKILL_GROUP_LIST.SKILL_DESCRIPTION_LABEL': 'Vještina',
  'SKILL_GROUP_LIST.SKILL_ADD_BUTTON_LABEL': 'Novi program stjecanja vještine',
  'SKILL_GROUP_LIST.SKILL_GROUP_ADD_BUTTON_LABEL': 'Novo područje vještina',
  'SKILL_GROUP_LIST.SKILL_ADD_MESSAGE': 'Vještina pridružena',
  'SKILL_GROUP_LIST.SKILL_GROUP_ADD_MESSAGE': 'Nova grupa vještina spremljena',
  // ---------- error message
  'SKILL_GROUP_LIST.ERROR.SKILL_GROUP_ALREADY_EXISTS': 'Područje vještine s istim nazivom već postoji. Odaberite drugi naziv.',
  'SKILL_LIST.ERROR.SKILL_ALREADY_EXISTS': 'Vještina s istim nazivom već postoji. Odaberite drugi naziv.',
  'SKILL_LEVEL.ERROR.SKILL_LEVEL_ALREADY_EXISTS': 'Već postoji razina vještine s istom razinom, odaberite drugu razinu.',

  // ---------- Skill list
  'SKILL_LIST.VIEW.SKILL_LEVEL_CLASSIFICATION_BUTTON_LABEL': 'Uredi razine programa vještina',

  // ---------- Skill group modals
  'SKILL_MODAL.SKILL_CREATE_TITLE': 'Novi program stjecanja vještine',
  'SKILL_MODAL.SKILL_UPDATE_TITLE': 'Uredi program stjecanja vještine',
  'SKILL_FORM.SKILL_LEVEL_CLASSIFICATION_LABEL': 'Razine vještine',
  'SKILL_GROUP_MODAL.SKILL_GROUP_CREATE_TITLE': 'Novo područje vještina',
  'SKILL_GROUP_MODAL.SKILL_GROUP_UPDATE_TITLE': 'Uredi područje vještina',

  // ---------- Request
  // ---------- User view section
  'REQUEST.USER_VIEW_SECTION.TITLE': 'O korisniku',
  'REQUEST.USER_VIEW_SECTION.LINK_LABEL': 'Pogledajte profil',
  'REQUEST.USER_VIEW_SECTION.EMPLOYED_LABEL': 'zaposlena osoba',
  'REQUEST.USER_VIEW_SECTION.UNEMPLOYED_LABEL': 'nezaposlena osoba',
  'REQUEST.USER_VIEW_SECTION.EMAIL_LABEL': 'e-mail korisnika',
  'REQUEST.USER_VIEW_SECTION.IDENTIFICATION_NUMBER_LABEL': 'OIB korisnika',
  'REQUEST.USER_VIEW_SECTION.CONSULTATION_LABEL': 'potrebna stručna podrška HZZ savjetnika',
  'REQUEST.USER_VIEW_SECTION.FOOTER_TITLE': 'Datoteke',
  'REQUEST.USER_VIEW_SECTION.CURRICULUM_VITAE_LABEL': 'životopis',
  'REQUEST.USER_VIEW_SECTION.IDENTIFICATION_NUMBER_MISSING_LABEL': 'Nema unesen OIB',
  'REQUEST.USER_VIEW_SECTION.EMAIL_MISSING_LABEL': 'Nema unesen e-mail',
  [`REQUEST.USER_VIEW_SECTION.RESIDENCE_TYPE.${ResidenceTypeEnum.TEMPORARY}_LABEL`]: 'Boravište korisnika',
  [`REQUEST.USER_VIEW_SECTION.RESIDENCE_TYPE.${ResidenceTypeEnum.PERMANENT}_LABEL`]: 'Prebivalište korisnika',
  'REQUEST.USER_VIEW_SECTION.BANK_NAME_LABEL': 'Naziv banke',
  'REQUEST.USER_VIEW_SECTION.IBAN_LABEL': 'IBAN korisnika',
  'REQUEST.USER_VIEW_SECTION.EMPLOYER_NAME_LABEL': 'poslodavac',
  'REQUEST.USER_VIEW_SECTION.EMPLOYER_OIB_LABEL': 'OIB poslodavca',
  'REQUEST.USER_VIEW_SECTION.EMPLOYER_EMAIL_LABEL': 'e-mail poslodavca',
  'REQUEST.USER_VIEW_SECTION.EMPLOYER_ADDRESS_LABEL': 'adresa poslodavca',
  'REQUEST.USER_VIEW_SECTION.EMPLOYER_NO_NAME_LABEL': 'Nije unesen naziv poslodavca',
  'REQUEST.USER_VIEW_SECTION.EMPLOYER_NO_OIB_LABEL': 'Nije unesen OIB poslodavca',
  'REQUEST.USER_VIEW_SECTION.EMPLOYER_NO_IBAN_LABEL': 'Nije unesen IBAN poslodavca',
  'REQUEST.USER_VIEW_SECTION.EDUCATION_LABEL': 'Obrazovni program i ustanova',
  'REQUEST.USER_VIEW_SECTION.NOTZ_SYNC_DATE_TIME_LABEL': 'Zadnje povlačenje statusa iz NOTZ-a',
  'REQUEST.USER_VIEW_SECTION.NOTZ_LAST_CHECK_IN_DATE_LABEL': 'Datum zadnje prijave',
  'REQUEST.USER_VIEW_SECTION.NOTZ_LAST_CHECK_OUT_DATE_LABEL': 'Datum zadnje odjave',
  'REQUEST.USER_VIEW_SECTION.NOTZ_STATUS_LABEL': 'Trenutni status',

  // ---------- Survey template
  'SURVEY_TEMPLATE.TITLE.USER_EDUCATION_COMPLETED': 'Upitnik za polaznika programa obrazovanja (odmah nakon završetka)',
  'SURVEY_TEMPLATE.TITLE.USER_EDUCATION_COMPLETED_CHECK_IN': 'Upitnik za polaznika programa obrazovanja (6 mjeseci nakon završetka)',
  'SURVEY_TEMPLATE.TITLE.EDUCATION_PROVIDER': 'Upitnik za pružatelja programa obrazovanja',
  'SURVEY_TEMPLATE.TITLE.EMPLOYER': 'Upitnik za poslodavca',

  // ---------- Survey instance
  'SURVEY_INSTANCE.SURVEY_TYPE_TITLE.USER_EDUCATION_COMPLETED': 'Upitnik za polaznika programa obrazovanja (odmah nakon završetka)',
  'SURVEY_INSTANCE.SURVEY_TYPE_TITLE.USER_EDUCATION_COMPLETED_CHECK_IN': 'Upitnik za polaznika programa obrazovanja (6 mjeseci nakon završetka)',
  'SURVEY_INSTANCE.SURVEY_TYPE_TITLE.EDUCATION_PROVIDER': 'Upitnik za pružatelja programa obrazovanja',
  'SURVEY_INSTANCE.SURVEY_TYPE_TITLE.EMPLOYER': 'Upitnik za poslodavca',
  'SURVEY_INSTANCE.BUTTON_SUBMIT_LABEL': 'Predajte upitnik',
  // error message
  'SURVEY_INSTANCE.ERROR_MESSAGE.REQUIRED_QUESTION_MISSING_ANSWER': 'Upitnik nije predan, molimo Vas da odgovorite na obavezna pitanja',
  'SURVEY_INSTANCE.ERROR_MESSAGE.SURVEY_MULTIPLE_SUBMISSIONS_NOT_ALLOWED': 'Upitnik je već predan, nije dopušteno više puta odgovarati',
  'SURVEY_INSTANCE.ERROR_MESSAGE.PARTIAL_ANSWER_NOT_ALLOWED': 'Upitnik nije predan, molimo Vas da odgovorite na već započeto pitanje',
  'SURVEY_INSTANCE.ERROR_MESSAGE.TOKEN_INVALID': 'Token je istekao ili je neispravan',

  // ---------- Survey instance feedback
  'SURVEY_INSTANCE_FEEDBACK.SURVEY_TYPE_TITLE.USER_EDUCATION_COMPLETED': 'Predano - Upitnik za polaznika programa obrazovanja (odmah nakon završetka)',
  'SURVEY_INSTANCE_FEEDBACK.SURVEY_TYPE_TITLE.USER_EDUCATION_COMPLETED_CHECK_IN': 'Predano - Upitnik za polaznika programa obrazovanja (6 mjeseci nakon završetka)',
  'SURVEY_INSTANCE_FEEDBACK.SURVEY_TYPE_TITLE.EDUCATION_PROVIDER': 'Predano - Upitnik za pružatelja usluge',
  'SURVEY_INSTANCE_FEEDBACK.SURVEY_TYPE_TITLE.EMPLOYER': 'Predano - Upitnik za poslodavca',

  // ---------- Survey instance notification
  'SURVEY_INSTANCE_NOTIFICATION_VIEW.SUCCESSFUL_SUBMIT': 'Uspješno predano!',
  'SURVEY_INSTANCE_NOTIFICATION_VIEW.GRATITUDE_TEXT': 'Zahvaljujemo na ispunjenom upitniku',
  'SURVEY_INSTANCE_NOTIFICATION_VIEW.BACK_TO_MY_PROFILE_TEXT': 'Povratak na moj profil',

  // ----------- External education application details
  'EXTERNAL_EDUCATION_APPLICATION.DETAILS.EDUCATION_START_DATE_TITLE': 'Početak programa obrazovanja',
  'EXTERNAL_EDUCATION_APPLICATION.DETAILS.USER_CATEGORY_TITLE': 'Kategorija korisnika',
  'EXTERNAL_EDUCATION_APPLICATION.DETAILS.USER_CATEGORY_BUTTON_LABEL': 'Promjenite kategoriju korisnika',
  'EXTERNAL_EDUCATION_APPLICATION.DETAILS.TITLE': 'Detalji zahtjeva',
  'EXTERNAL_EDUCATION_APPLICATION.DETAILS.JOB_RELATED_TITLE': 'Je li zahtjev vezan uz Vaše trenutno radno mjesto ili prethodno radno iskustvo? ',
  'EXTERNAL_EDUCATION_APPLICATION.DETAILS.EDUCATION_RELATED_TITLE': 'Je li zahtjev vezan uz Vaše dosadašnje obrazovanje?',
  'EXTERNAL_EDUCATION_APPLICATION.DETAILS.SKILL_ACQUISITION_TITLE': 'Vještina',
  'EXTERNAL_EDUCATION_APPLICATION.DETAILS.APPLICATION_DESCRIPTION_TITLE': 'Obrazložite na koji će način završetak predloženog programa utjecati na Vaš razvoj karijere ili mogućnosti zapošljavanja',
  'EXTERNAL_EDUCATION_APPLICATION.DETAILS.USER_WILLING_TO_COFINANCE_TITLE': 'Jeste li spremni sufinancirati pohađanje programa obrazovanja (ako cijena programa premašuje mogući iznos sufinanciranja od strane HZZ-a)?',
  'EXTERNAL_EDUCATION_APPLICATION.DETAILS.EMPLOYER_WILLING_TO_COFINANCE_TITLE': 'Je li Vaš poslodavac spreman sufinancirati pohađanje programa obrazovanja (ako cijena programa premašuje mogući iznos sufinanciranja od strane HZZ-a)?',
  'EXTERNAL_EDUCATION_APPLICATION.DETAILS.INTEREST_RELATED_TITLE': 'Je li zahtjev vezan uz Vaše dodatne profesionalne interese i planirani daljnji razvoj karijere?',
  'EXTERNAL_EDUCATION_APPLICATION.DETAILS.ABOUT_EDUCATION_PROGRAM_TITLE': 'Izvedba programa obrazovanja',
  'EXTERNAL_EDUCATION_APPLICATION.DETAILS.ABOUT_EDUCATION_PROGRAM_TEXT':
    'Program obrazovanja je započeo %{educationProgramStartDateTime} Pružatelj je označio završetak programa %{eudcationProgramEndDateTime} Datum potraživanja uplate je %{paymentRequestedDateTime} Lokacija izvođenja programa: %{educationProgramLocation}',
  // ---------- Data table
  'DATA_TABLE.SELECTED_ROWS_COUNT_LABEL': 'Označenih zapisa',
  'DATA_TABLE.SELECTED_ROWS_MORE_ACTIONS_LABEL': 'Više opcija',
  'DATA_TABLE.PAGINATION_SHOW_TOTAL_LABEL': 'Prikazuje se %{rangeOne} - %{rangeTwo} od %{total}',

  // ---------- Company Form
  'COMPANY.FORM.LABEL': 'Informacije o pružatelju usluga',
  'COMPANY.FORM.SELECTOR_NAME_LABEL': 'Pronađi po nazivu',
  'COMPANY.FORM.SELECTOR_ID_LABEL': 'Pronađi po OIB-u',
  'COMPANY.FORM.NAME_LABEL': 'Naziv',
  'COMPANY.FORM.ID_LABEL': 'OIB',
  'COMPANY.FORM.NAME_PLACEHOLDERLABEL': 'Upišite naziv',
  'COMPANY.FORM.ID_PLACEHOLDERLABEL': 'Upišite OIB',
  'COMPANY.FORM.CITY_LABEL': 'Mjesto sjedišta',
  'COMPANY.FORM.ZIP_LABEL': 'Poštanski broj sjedišta',
  'COMPANY.FORM.CITY_PLACEHOLDER_LABEL': 'Odaberite mjesto',
  'COMPANY.FORM.ZIP_PLACEHOLDER_LABEL': 'Upišite poštanski broj',
  'COMPANY.FORM.STREET_LABEL': 'Ulica i kućni broj sjedišta',
  'COMPANY.FORM.CONTACT_LABEL': 'E-mail adresa',
  'COMPANY.FORM.STREET_PLACEHOLDER_LABEL': 'Upišite ulica i kućni broj',
  'COMPANY.FORM.CONTACT_PLACEHOLDER_LABEL': 'Upišite e-mail adresu',
  'COMPANY.FORM.NAME_VALIDATION_MESSAGE': 'Unesite naziv',
  'COMPANY.FORM.ID_VALIDATION_MESSAGE': 'Unesite OIB',
  'COMPANY.FORM.CITY_VALIDATION_MESSAGE': 'Unesite mjesto',
  'COMPANY.FORM.ZIP_VALIDATION_MESSAGE': 'Unesite poštanski broj',
  'COMPANY.FORM.ADDRESS_VALIDATION_MESSAGE': 'Unesite adresu',
  'COMPANY.FORM.CONTACT_VALIDATION_MESSAGE': 'Unesite e-mail',
  'COMPANY.FORM.VALID_EMAIL_MESSAGE': 'Unesite ispravan e-mail',

  // ---------- External education application API errors
  'EXTERNAL_EDUCATION_APPLICATION.ERROR.USER_HAS_ACTIVE_EXTERNAL_EDUCATION_APPLICATION': 'Nije moguće kreirati novi zahtjev jer aktivan zahtjev već postoji',

  // ---------- External education application list
  'EXTERNAL_EDUCATION_APPLICATION.LIST_VIEW.SKILL_HEADER_TITLE': 'Vještina',
  'EXTERNAL_EDUCATION_APPLICATION.LIST_VIEW.EDUCATION_TEMPLATE_HEADER_TITLE': 'Program obrazovanja',
  'EXTERNAL_EDUCATION_APPLICATION.LIST_VIEW.ASSIGNEE_RESIDENCE_HEADER_TITLE': 'Mjesto korisnika',
  'EXTERNAL_EDUCATION_APPLICATION.LIST_VIEW.ASSIGNEE_HEADER_TITLE': 'Korisnik',
  'EXTERNAL_EDUCATION_APPLICATION.LIST_VIEW.APPLICATION_STATUS_HEADER_TITLE': 'Status',
  'EXTERNAL_EDUCATION_APPLICATION.LIST_VIEW.APPLICATION_SUBMISSION_DATE_HEADER_TITLE': 'Vrijeme podnošenja',
  'EXTERNAL_EDUCATION_APPLICATION.LIST_VIEW.EVALUATOR_HEADER_TITLE': 'Savjetnik',
  'EXTERNAL_EDUCATION_APPLICATION.LIST_VIEW.NEW_APPLICATION_BUTTON_LABEL': 'Novi zahtjev',
  'EXTERNAL_EDUCATION_APPLICATION.LIST_VIEW.NEW_APPLICATION_TEXT': ' Znate koju vještinu želite steći ili usavršiti i imate ponudu pružatelja? Klikom na gumb "+ Novi zahtjev" podnosite zahtjev za vaučerom.',
  'EXTERNAL_EDUCATION_APPLICATION.LIST_VIEW.CONSULTATION_BUTTON_LABEL': 'Zatražite usmjeravanje',
  'EXTERNAL_EDUCATION_APPLICATION.LIST_VIEW.CONSULTATION_TEXT': 'Je li Vam potreban savjet i podrška savjetnika za profesionalno usmjeravanje HZZ-a prilikom donošenja odluke o odabiru vještine koju bi ste htjeli razviti ili dodatno usavršiti? Savjet i podršku zatražite klikom na gumb "Zatražite usmjeravanje".',
  'EXTERNAL_EDUCATION_APPLICATION.LIST_VIEW.ASSIGNEE_EMPLOYMENT_STATUS_BEFORE_EDUCATION_HEADER_TITLE': 'Status zaposlenosti korisnika prilikom podnošenja zahtjeva',
  'EXTERNAL_EDUCATION_APPLICATION.LIST_VIEW.HZZ_COORDINATOR_HELP_WANTED_HEADER_TITLE': 'Zatražena podrška i savjet HZZ savjetnika',
  'EXTERNAL_EDUCATION_APPLICATION.LIST_VIEW.EDUCATION_RELEATED_HEADER_TITLE': 'Je li zahtjev vezan uz obrazovanje',
  'EXTERNAL_EDUCATION_APPLICATION.LIST_VIEW.JOB_RELATED_HEADER_TITLE': 'Je li zahtjev vezan uz radno mjesto',
  'EXTERNAL_EDUCATION_APPLICATION.LIST_VIEW.EDUCATION_DURATION_HEADER_TITLE': 'Trajanje programa',
  'EXTERNAL_EDUCATION_APPLICATION.LIST_VIEW.ASSIGNEE_GRADE_HEADER_TITLE': 'Ocjena korisnika',
  'EXTERNAL_EDUCATION_APPLICATION.LIST_VIEW.PROVIDER_GRADE_HEADER_TITLE': 'Ocjena pružatelja usluga',
  'EXTERNAL_EDUCATION_APPLICATION.LIST_VIEW.EMPLOYER_GRADE_HEADER_TITLE': 'Ocjena poslodavca',
  'EXTERNAL_EDUCATION_APPLICATION.LIST_VIEW.EDUCATION_EXPENSE_HEADER_TITLE': 'Trošak programa obrazovanja',
  'EXTERNAL_EDUCATION_APPLICATION.LIST_VIEW.TRAVEL_EXPENSE_HEADER_TITLE': 'Putni troškovi',
  'EXTERNAL_EDUCATION_APPLICATION.LIST_VIEW.CO_FINANCED_EDUCATION_PRICE_HEADER_TITLE': 'Iznos vaučera',
  'EXTERNAL_EDUCATION_APPLICATION.LIST_VIEW.EMPLOYMENT_STATUS.EMPLOYED': 'Zaposlen',
  'EXTERNAL_EDUCATION_APPLICATION.LIST_VIEW.EMPLOYMENT_STATUS.UNEMPLOYED': 'Nezaposlen',
  'EXTERNAL_EDUCATION_APPLICATION.LIST_VIEW.TRAVEL_EXPENSE_FORM_LABEL': 'Unos putnog troška',
  'EXTERNAL_EDUCATION_APPLICATION.LIST_VIEW.EUR_TO_HR_EXCHANGE_RATE_LABEL': 'Fiksni tečaj eura prema kuni',

  // --- tooltip message
  'EXTERNAL_EDUCATION_APPLICATION.LIST_VIEW.ACTIVE_CONSULTATION_NEW_APPLICATION_BUTTON_TOOLTIP': 'Nije moguće kreirati novi zahtjev za vaučerom jer postoji aktivan zahtjev za usmjeravanjem.',
  'EXTERNAL_EDUCATION_APPLICATION.LIST_VIEW.ACTIVE_APPLICATION_NEW_APPLICATION_BUTTON_TOOLTIP': 'Nije moguće kreirati novi zahtjev za vaučerom jer već postoji aktivan zahtjev za vaučerom.',
  'EXTERNAL_EDUCATION_APPLICATION.LIST_VIEW.ACTIVE_CONSULTATION_NEW_CONSULTATION_BUTTON_TOOLTIP': 'Nije moguće kreirati novi zahtjev za usmjeravanjem jer postoji aktivan zahtjev za usmjeravanjem.',
  'EXTERNAL_EDUCATION_APPLICATION.LIST_VIEW.ACTIVE_APPLICATION_NEW_CONSULTATION_BUTTON_TOOLTIP': 'Nije moguće kreirati novi zahtjev za usmjeravanjem jer već postoji aktivan zahtjev za vaučerom.',
  // ---------- External education application consultation
  'EXTERNAL_EDUCATION_APPLICATION.CONSULTATION_MODAL.TITLE': 'Profesionalno usmjeravanje',
  'EXTERNAL_EDUCATION_APPLICATION.CONSULTATION_FORM.CONSULTATION_DESCRIPTION_LABEL': 'U vezi čega Vam je potreban savjet ili podrška HZZ savjetnika',
  'EXTERNAL_EDUCATION_APPLICATION.CONSULTATION_FORM.CONSULTATION_DESCRIPTION_PLACEHOLDER': 'Upišite dodatne informacije',
  'EXTERNAL_EDUCATION_APPLICATION.CONSULTATION_MODAL.OK_BUTTON_LABEL': 'Zatražite usmjeravanje',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE_CONSULTATION.CANCEL_CONSULTATION_BUTTON_LABEL': 'Otkažite usmjeravanje',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE_CONSULTATION.CANCEL_CONSULTATION_TEXT': 'Ipak Vam nije potrebno profesionalno usmjeravanje?',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR_CONSULTATION.TAKE_CONSULTATION_BUTTON_LABEL': 'Preuzmite usmjeravanje',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR_CONSULTATION.MARK_AS_DONE_CONSULTATION': 'Označi kao obavljeno',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR_CONSULTATION.NOTE_MODAL_TITLE': 'Profesionalno usmjeravanje',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR_CONSULTATION.MARK_AS_DONE_CONSULTATION_PLACEHOLDER': 'Zaključak profesionalnog usmjeravanja (npr. dogovorena vještina)',

  // ---------- External education application
  'EXTERNAL_EDUCATION_APPLICATION.EMPLOYED_LABEL': 'Zaposlena osoba',
  'EXTERNAL_EDUCATION_APPLICATION.UNEMPLOYED_LABEL': 'Nezaposlena osoba',

  'EXTERNAL_EDUCATION_APPLICATION.OWNERSHIP.MY_APPLICATIONS_LABEL': 'Moji zahtjevi',
  'EXTERNAL_EDUCATION_APPLICATION.OWNERSHIP.OTHER_COORDINATORS_APPLICATIONS_LABEL': 'Tuđi zahtjevi',
  'EXTERNAL_EDUCATION_APPLICATION.OWNERSHIP.WITHOUT_COORDINATOR_LABEL': 'Nisu preuzeti',

  'EXTERNAL_EDUCATION_APPLICATION.PHASE.EXTERNAL_EDUCATION_APPLICATION_CREATION_LABEL': 'U izradi',
  'EXTERNAL_EDUCATION_APPLICATION.PHASE.SUBMITTED_LABEL': 'Podnesen',
  'EXTERNAL_EDUCATION_APPLICATION.PHASE.AWAITING_APPROVAL_LABEL': 'Pregled zahtjeva',
  'EXTERNAL_EDUCATION_APPLICATION.PHASE.CONTRACT_GENERATION_LABEL': 'Korisnik potpisuje ugovor',
  'EXTERNAL_EDUCATION_APPLICATION.PHASE.CONTRACT_DATA_PROCESSING_LABEL': 'U obradi',
  'EXTERNAL_EDUCATION_APPLICATION.PHASE.AWAITING_SIGNED_CONTRACT_LABEL': 'Potpis ugovora',
  'EXTERNAL_EDUCATION_APPLICATION.PHASE.AWAITING_PAYMENT_LABEL': 'Uplata u tijeku',
  'EXTERNAL_EDUCATION_APPLICATION.PHASE.EDUCATION_IN_PROGRESS_LABEL': 'Obrazovanje u tijeku',
  'EXTERNAL_EDUCATION_APPLICATION.PHASE.EDUCATION_COMPLETED_LABEL': 'Zaključen',
  'EXTERNAL_EDUCATION_APPLICATION.PHASE.CONSULTATION_TERMINATED_LABEL': 'Otkazano usmjeravanje',
  'EXTERNAL_EDUCATION_APPLICATION.PHASE.CONSULTATION_REQUESTED_LABEL': 'Zatraženo usmjeravanje',
  'EXTERNAL_EDUCATION_APPLICATION.PHASE.CONSULTATION_STARTED_LABEL': 'Usmjeravanje u tijeku',
  'EXTERNAL_EDUCATION_APPLICATION.PHASE.RETURNED_TO_USER_LABEL': 'Vraćen korisniku',
  'EXTERNAL_EDUCATION_APPLICATION.PHASE.USER_CANCELED_LABEL': 'Korisnik odustao',
  'EXTERNAL_EDUCATION_APPLICATION.PHASE.EXTERNAL_EDUCATION_APPLICATION_DENIED_LABEL': 'Neodobren',
  'EXTERNAL_EDUCATION_APPLICATION.PHASE.CONTRACT_TERMINATED_LABEL': 'Poništen',
  'EXTERNAL_EDUCATION_APPLICATION.PHASE.CONTRACT_ANNEX_REQUESTED_LABEL': 'Zatražen aneks ugovora',
  'EXTERNAL_EDUCATION_APPLICATION.PHASE.CONTRACT_ANNEX_SUBMITTED_LABEL': 'Potpis aneksa ugovora',
  'EXTERNAL_EDUCATION_APPLICATION.PHASE.EXTERNAL_EDUCATION_TEMPLATE_SELECTION_LABEL': 'Odabir programa',

  'EXTERNAL_EDUCATION_APPLICATION.FORM.STEP_ONE_TITLE': 'Program obrazovanja',
  'EXTERNAL_EDUCATION_APPLICATION.FORM.STEP_TWO_TITLE': 'O meni',
  'EXTERNAL_EDUCATION_APPLICATION.FORM.STEP_THREE_TITLE': 'Pregled zahtjeva',

  'EXTERNAL_EDUCATION_APPLICATION.BUTTON_PREV_LABEL': 'Prethodni korak',
  'EXTERNAL_EDUCATION_APPLICATION.BUTTON_SAVE_LABEL': 'Spremite za kasnije',
  'EXTERNAL_EDUCATION_APPLICATION.BUTTON_NEXT_LABEL': 'Nastavite ispunjavati zahtjev',
  'EXTERNAL_EDUCATION_APPLICATION.BUTTON_SUBMIT_LABEL': 'Podnesite zahtjev',

  'EXTERNAL_EDUCATION_APPLICATION.USER_ALLOWED_EMPLOYER_SURVEY_LABEL': 'Može li HZZ, po završetku programa obrazovanja, poslati upitnik Vašem poslodavcu?',
  'EXTERNAL_EDUCATION_APPLICATION.SKILL_PANEL_TITLE': 'Vještina koju želite steći',
  'EXTERNAL_EDUCATION_APPLICATION.STATEMENT_ACCEPTED_PANEL_TITLE': 'Izjava',
  'EXTERNAL_EDUCATION_APPLICATION.STATEMENT_ACCEPTED_LABEL': 'Pod materijalnom i kaznenom odgovornošću izjavljujem da: se ne nalazim u sustavu redovnog odgoja i obrazovanja (učenik), se ne nalazim u sustavu visokog obrazovanja i znanosti (student) te nisam korisnik mirovine.',
  'EXTERNAL_EDUCATION_APPLICATION.EDUCATION_PANEL_TITLE': 'Dostupni programi',
  'EXTERNAL_EDUCATION_APPLICATION.ADDITIONAL_INFO_PANEL_TITLE': 'Dodatne informacije',
  'EXTERNAL_EDUCATION_APPLICATION.ABOUT_ME_PANEL_TITLE': 'Informacije o meni',
  'EXTERNAL_EDUCATION_APPLICATION.EMPLOYER_FORM_PANEL_TITLE': 'Podaci o mom poslodavcu',
  'EXTERNAL_EDUCATION_APPLICATION.EMPLOYER_INFO_PANEL_TITLE': 'Informacije o mojem poslodavcu',
  'EXTERNAL_EDUCATION_APPLICATION.COFINANCE_PANEL_TITLE': 'SUFINANCIRANJE VAUČERA (samo za programe čiji je trošak veći od iznosa vaučera)',
  'EXTERNAL_EDUCATION_APPLICATION.ENROLLMENT_REQUIREMENT_LABEL': 'Uvjeti za odabrani program obrazovanja su:',
  'EXTERNAL_EDUCATION_APPLICATION.EDUCATION_PROVIDER_PANEL_TITLE': 'Informacije o pružatelju usluge',
  'EXTERNAL_EDUCATION_APPLICATION.ABOUT_EDUCATION_PANEL_TITLE': 'Program obrazovanja',
  'EXTERNAL_EDUCATION_APPLICATION.EDUCATION_APPLICATION_AGREEMENT_PANEL_TITLE': 'Informacije za ugovor',
  'EXTERNAL_EDUCATION_APPLICATION.OFFER_PANEL_TITLE': 'Ponuda',
  'EXTERNAL_EDUCATION_APPLICATION.AGREEMENTS_AND_CERTIFICATES_PANEL_TITLE': 'Dokumenti',
  'EXTERNAL_EDUCATION_APPLICATION.FILES_VIEW_SECTION.FILE_REMOVE_CONFIRMATION_TITLE': 'Jeste li sigurni da želite obrisati "%{fileName}" ?',
  'EXTERNAL_EDUCATION_APPLICATION.SKILL_LABEL': 'Vještina za čije usvajanje ćete steći vaučer',
  'EXTERNAL_EDUCATION_APPLICATION.EDUCATION_LABEL': 'Niže su navedeni programi obrazovanja vezani za odabranu vještinu. Ako dobijete odobrenje zahtjeva, moći ćete naknadno promijeniti program obrazovanja (ali ne i vještinu).',
  'EXTERNAL_EDUCATION_APPLICATION.EDUCATION_CONDITION_INFO_MESSAGE': 'Odaberite vještinu kako bi ste vidjeli dostupne programe',
  'EXTERNAL_EDUCATION_APPLICATION.EMPLOYMENT_STATUS_LABEL': 'Moj status zaposlenosti',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR_HELP_WANTED_TOOLTIP_TEXT': 'Savjetnik će odgovor vidjeti tek kad podnesete zahtjev',
  'EXTERNAL_EDUCATION_APPLICATION.EDUCATION_RELATED_LABEL': 'Je li zahtjev vezan uz Vaše dosadašnje obrazovanje?',
  'EXTERNAL_EDUCATION_APPLICATION.JOB_RELATED_LABEL': 'Je li zahtjev vezan uz Vaše trenutno radno mjesto ili prethodno radno iskustvo?',
  'EXTERNAL_EDUCATION_APPLICATION.INTEREST_RELATED_LABEL': 'Je li zahtjev vezan uz Vaše dodatne profesionalne interese i planirani daljnji razvoj karijere?',
  'EXTERNAL_EDUCATION_APPLICATION.USER_COFINANCE_LABEL': 'Jeste li spremni sufinancirati pohađanje programa obrazovanja (ako cijena programa premašuje mogući iznos sufinanciranja od strane HZZ-a)?',
  'EXTERNAL_EDUCATION_APPLICATION.EMPLOYER_COFINANCE_LABEL': 'Je li vaš poslodavac spreman sufinancirati pohađanje programa obrazovanja (ako cijena programa premašuje mogući iznos sufinanciranja od strane HZZ-a)?',
  'EXTERNAL_EDUCATION_APPLICATION.APPLICATION_DESCRIPTION_LABEL': 'Obrazložite na koji će način završetak predložene vještine utjecati na Vaš razvoj karijere ili mogućnost zapošljavanja.',
  'EXTERNAL_EDUCATION_APPLICATION.APPLICATION_DESCRIPTION_PLACEHOLDER': 'Obrazložite na koji način je zahtjev vezan uz odabrani program stjecanja vještine',
  'EXTERNAL_EDUCATION_APPLICATION.TOOLTIP.CURRENT_COORDINATOR_NOT_EVALUATOR_LABEL': 'Drugi savjetnik obrađuje ovaj zahtjev.',

  // ---------- External education e-mail template
  'EXTERNAL_EDUCATION_APPLICATION.EMAIL_TEMPLATE.SUBJECT_LABEL': 'Upit za termin programa "%{educationTemplateTitle}"',
  'EXTERNAL_EDUCATION_APPLICATION.EMAIL_TEMPLATE.BODY_LABEL': 'Poštovani, \n možete li mi poslati ponudu za navedeni program obrazovanja. \n Podaci za ponudu su; Ime: %{firstName}, Prezime: %{lastName}, OIB: %{oib}, Adresa: %{address}. Srdačan pozdrav',

  // ---------- External education application expenses
  'EXTERNAL_EDUCATION_APPLICATION.EXPENSE.TYPE_LABEL': 'Tip troška',
  'EXTERNAL_EDUCATION_APPLICATION.EXPENSE.TYPE_PLACEHOLDER': 'Odaberite tip',
  'EXTERNAL_EDUCATION_APPLICATION.EXPENSE.EDUCATION_OFFER_PRICE': 'Troškovi programa obrazovanja',
  'EXTERNAL_EDUCATION_APPLICATION.EXPENSE.CO_FINANCED_EDUCATION_PRICE': 'Iznos vaučera',
  'EXTERNAL_EDUCATION_APPLICATION.EXPENSE.TRAVEL_EXPENSE': 'Putni troškovi',
  'EXTERNAL_EDUCATION_APPLICATION.EXPENSE.PANEL_TITLE': 'Troškovi',
  'EXTERNAL_EDUCATION_APPLICATION.EXPENSE.VALUE_LABEL': 'Iznos',
  'EXTERNAL_EDUCATION_APPLICATION.EXPENSE.VALUE_PLACEHOLDER': 'Unesite iznos',
  'EXTERNAL_EDUCATION_APPLICATION.EXPENSE.DATE_LABEL': 'Datum plaćanja',
  'EXTERNAL_EDUCATION_APPLICATION.EXPENSE.PANEL_LABEL': 'Upišite trošak',
  'EXTERNAL_EDUCATION_APPLICATION.EXPENSE.CO_FINANCED_EDUCATION_PRICE_LABEL': 'Iznos vaučera',
  'EXTERNAL_EDUCATION_APPLICATION.EXPENSE.CREATE_SUCCESS': 'Trošak spremljen',
  'EXTERNAL_EDUCATION_APPLICATION.EXPENSE.TRAVEL_EXPENSE_LABEL': 'Putni trošak',
  'EXTERNAL_EDUCATION_APPLICATION.FORM.SUBMIT_SUCCESSFUL_TITLE': 'Vaš zahtjev je uspješno podnesen',
  'EXTERNAL_EDUCATION_APPLICATION.FORM.SUBMIT_SUCCESSFUL_MESSAGE': 'HZZ savjetnik će u roku od 10 dana pregledati Vaš zahtjev',
  'EXTERNAL_EDUCATION_APPLICATION.FORM.SUBMIT_SUCCESSFUL_DESCRIPTION': 'Napomena: Sve dok ne potpišete ugovor o međusobnim pravima i obvezama za vrijeme programa obrazovanja putem vaučera moguće je odustati od zahtjeva.',
  'EXTERNAL_EDUCATION_APPLICATION.FORM.CONSULTATION_REQUESTED_SUCCESSFUL_TITLE': 'Uspješno ste zatražili profesionalno usmjeravanje!',
  'EXTERNAL_EDUCATION_APPLICATION.FORM.CONSULTATION_REQUESTED_SUCCESSFUL_MESSAGE': 'HZZ savjetnik će Vas kontaktirati u najkraćem mogućem roku.',
  'EXTERNAL_EDUCATION_APPLICATION.EXPENSE.MODAL_TITLE': 'Promjena iznosa vaučera',
  'EXTERNAL_EDUCATION_APPLICATION.EXPENSE.MODAL_INFO_TEXT': 'Ako promjenite iznos vaučera, ugovor je potrebno aneksirati proizvoljnim tipom aneksa.',
  'EXTERNAL_EDUCATION_APPLICATION.EXPENSE.CO_FINANCED_EDUCATION_PRICE_BUTTON_LABEL': 'Promjena iznosa vaučera',

  // ----- Education application report list filter
  'EDUCATION_APPLICATION_REPORT_LIST_FILTER.SKILL_LABEL': 'Vještina',
  'EDUCATION_APPLICATION_REPORT_LIST_FILTER.SKILL_PLACEHOLDER': 'Pronađite vještinu',
  'EDUCATION_APPLICATION_REPORT_LIST_FILTER.EDUCATION_LABEL': 'Program obrazovanja',
  'EDUCATION_APPLICATION_REPORT_LIST_FILTER.EDUCATION_PROVIDER_LABEL': 'Pružatelj usluge obrazovanja',
  'EDUCATION_APPLICATION_REPORT_LIST_FILTER.ASSIGNEE_LABEL': 'Korisnik/ca',
  'EDUCATION_APPLICATION_REPORT_LIST_FILTER.EVALUATOR_LABEL': 'Hzz savjetnik',
  'EDUCATION_APPLICATION_REPORT_LIST_FILTER.EMPLOYMENT_STATUS_LABEL': 'Status zaposlenosti korisnika/ce prilikom podnošenja zahtjeva',
  'EDUCATION_APPLICATION_REPORT_LIST_FILTER.PENDING_CONSULTATION_LABEL': 'Zatražena podrška i savjet HZZ savjetnika',
  'EDUCATION_APPLICATION_REPORT_LIST_FILTER.EDUCATION_RELATED_LABEL': 'Je li zahtjev vezan uz Vaše dosadašnje obrazovanje?',
  'EDUCATION_APPLICATION_REPORT_LIST_FILTER.JOB_RELATED_LABEL': 'Je li zahtjev vezan uz Vaše trenutno radno mjesto ili prethodno radno iskustvo?',
  'EDUCATION_APPLICATION_REPORT_LIST_FILTER.INTEREST_RELATED_LABEL': 'Je li zahtjev vezan uz dodatne profesionalne interese i planirani daljnji razvoj karijere?',
  'EDUCATION_APPLICATION_REPORT_LIST_FILTER.EDUCATION_APPLICATION_STATUS_LABEL': 'Status zahtjeva',
  'EDUCATION_APPLICATION_REPORT_LIST_FILTER.EDUCATION_DURATION_LABEL': 'Trajanje programa obrazovanja',
  'EDUCATION_APPLICATION_REPORT_LIST_FILTER.EDUCATION_APPLICATION_SUBMISSION_DATE_LABEL': 'Vrijeme podnošenja zahtjeva',
  'EDUCATION_APPLICATION_REPORT_LIST_FILTER.EDUCATION_EXPENSES_LABEL': 'Trošak programa obrazovanja',
  'EDUCATION_APPLICATION_REPORT_LIST_FILTER.TRAVEL_EXPENSES_LABEL': 'Putni troškovi',
  'EDUCATION_APPLICATION_REPORT_LIST_FILTER.COFINANCED_EDUCATION_PRICE_LABEL': 'Sufinancirani iznos',
  'EDUCATION_APPLICATION_REPORT_LIST_FILTER.ASSIGNEE_PLACEHOLDER': 'Upišite prezime korisnika/ce',
  'EDUCATION_APPLICATION_REPORT_LIST_FILTER.EVALUATOR_PLACEHOLDER': 'Upišite prezime savjetnika/ce',
  'EDUCATION_APPLICATION_REPORT_LIST_FILTER.PICK_STATUS_PLACEHOLDER': 'Odaberite status',
  'EDUCATION_APPLICATION_REPORT_LIST_FILTER.EDUCATION_DURATION_SUFFIX': 'sati',
  'EDUCATION_APPLICATION_REPORT_LIST_FILTER.EDUCATION_CATEGORY_LABEL': 'Kategorija programa',
  'EDUCATION_APPLICATION_REPORT_LIST_FILTER.USER_CATEGORY_LABEL': 'Kategorija korisnika',

  // ----- Education application report list filter info panel
  'EDUCATION_APPLICATION_REPORT_LIST_FILTER_INFO_PANEL.DESCRIPTION': 'Odabrani filteri (%{numberOfSelectedParameters}):',
  'EDUCATION_APPLICATION_REPORT_LIST_FILTER_INFO_PANEL.PARAMETER_EMPLOYMENTSTATUS': 'Status zaposlenosti',
  'EDUCATION_APPLICATION_REPORT_LIST_FILTER_INFO_PANEL.PARAMETER_ASSIGNEE': 'Korisnik/ca',
  'EDUCATION_APPLICATION_REPORT_LIST_FILTER_INFO_PANEL.PARAMETER_PHASES': 'Status zahtjeva',
  'EDUCATION_APPLICATION_REPORT_LIST_FILTER_INFO_PANEL.PARAMETER_EDUCATIONPROVIDER': 'Pružatelj usluge obrazovanja',
  'EDUCATION_APPLICATION_REPORT_LIST_FILTER_INFO_PANEL.PARAMETER_SKILL': 'Vještina',
  'EDUCATION_APPLICATION_REPORT_LIST_FILTER_INFO_PANEL.PARAMETER_EDUCATION': 'Program obrazovanja',
  'EDUCATION_APPLICATION_REPORT_LIST_FILTER_INFO_PANEL.PARAMETER_EVALUATOR': 'Hzz savjetnik',
  'EDUCATION_APPLICATION_REPORT_LIST_FILTER_INFO_PANEL.PARAMETER_PENDINGCONSULTATION': 'Zatražena pomoć savjetnika',
  'EDUCATION_APPLICATION_REPORT_LIST_FILTER_INFO_PANEL.PARAMETER_EDUCATIONRELATED': 'Zahtjev vezan uz obrazovanje',
  'EDUCATION_APPLICATION_REPORT_LIST_FILTER_INFO_PANEL.PARAMETER_JOBRELATED': 'Zahtjev vezan uz posao',
  'EDUCATION_APPLICATION_REPORT_LIST_FILTER_INFO_PANEL.PARAMETER_INTERESTRELATED': 'Zahtjev vezan uz dodatne profesionalne interese i planirani daljnji razvoj karijere',
  'EDUCATION_APPLICATION_REPORT_LIST_FILTER_INFO_PANEL.PARAMETER_EDUCATIONMINDURATION': 'Trajanje programa obrazovanja',
  'EDUCATION_APPLICATION_REPORT_LIST_FILTER_INFO_PANEL.PARAMETER_EDUCATIONMAXDURATION': 'Trajanje programa obrazovanja',
  'EDUCATION_APPLICATION_REPORT_LIST_FILTER_INFO_PANEL.PARAMETER_EDUCATIONMINEXPENSES': 'Minimalni trošak programa obrazovanja',
  'EDUCATION_APPLICATION_REPORT_LIST_FILTER_INFO_PANEL.PARAMETER_EDUCATIONMAXEXPENSES': 'Maksimalni trošak programa obrazovanja',
  'EDUCATION_APPLICATION_REPORT_LIST_FILTER_INFO_PANEL.PARAMETER_TRAVELMINEXPENSES': 'Minimalni putni troškovi',
  'EDUCATION_APPLICATION_REPORT_LIST_FILTER_INFO_PANEL.PARAMETER_TRAVELMAXEXPENSES': 'Maksimalni putni troškovi',
  'EDUCATION_APPLICATION_REPORT_LIST_FILTER_INFO_PANEL.PARAMETER_SUBMITTEDFROM': 'Vrijeme podnošenja zahtjeva od',
  'EDUCATION_APPLICATION_REPORT_LIST_FILTER_INFO_PANEL.PARAMETER_SUBMITTEDTO': 'Vrijeme podnošenja zahtjeva do',
  'EDUCATION_APPLICATION_REPORT_LIST_FILTER_INFO_PANEL.PARAMETER_CITY': 'Mjesto korisnika',
  'EDUCATION_APPLICATION_REPORT_LIST_FILTER_INFO_PANEL.PARAMETER_EDUCATIONCATEGORY': 'Kategorija programa',
  'EDUCATION_APPLICATION_REPORT_LIST_FILTER_INFO_PANEL.PARAMETER_USERCATEGORY': 'Kategorija korisnika',

  // ----- Education application coordinator list filter
  'EDUCATION_APPLICATION_COORDINATOR_LIST_FILTER.APPLICATION_OWNERSHIP_LABEL': 'Preuzetost zahtjeva',
  'EDUCATION_APPLICATION_COORDINATOR_LIST_FILTER.ASSIGNEE_LABEL': 'Korisnik/ca',
  'EDUCATION_APPLICATION_COORDINATOR_LIST_FILTER.ASSIGNEE_CITY_LABEL': 'Mjesto korisnika',
  'EDUCATION_APPLICATION_COORDINATOR_LIST_FILTER.DISTRICT_OFFICE_ADDRESS_LABEL': 'Sjedište PS/PU',
  'EDUCATION_APPLICATION_COORDINATOR_LIST_FILTER.EDUCATION_APPLICATION_STATUS_LABEL': 'Status zahtjeva',
  'EDUCATION_APPLICATION_COORDINATOR_LIST_FILTER.ASSIGNEE_PLACEHOLDER': 'Prezime korisnika/ce',
  'EDUCATION_APPLICATION_COORDINATOR_LIST_FILTER.ASSIGNEE_CITY_PLACEHOLDER': 'Upišite grad',
  'EDUCATION_APPLICATION_COORDINATOR_LIST_FILTER.PICK_STATUS_PLACEHOLDER': 'Odaberite status',
  'EDUCATION_APPLICATION_COORDINATOR_LIST_FILTER.PENDING_CONSULTATION_LABEL': 'HZZ savjet i podrška',
  'EDUCATION_APPLICATION_COORDINATOR_LIST_FILTER.PENDING_CONSULTATION_PLACEHOLDER': 'Odaberite odgovor',
  'EDUCATION_APPLICATION_COORDINATOR_LIST_FILTER.ASSIGNEE_COUNTY_LABEL': 'Županija',
  'EDUCATION_APPLICATION_COORDINATOR_LIST_FILTER.ASSIGNEE_COUNTY_PLACEHOLDER': 'Odaberite županiju',
  'EDUCATION_APPLICATION_COORDINATOR_LIST_FILTER.EDUCATION_CATEGORY_LABEL': 'Kategorija obrazovanja',
  'EDUCATION_APPLICATION_COORDINATOR_LIST_FILTER.EDUCATION_SECTOR_LABEL': 'Obrazovni sektor',
  // ----- Education application coordinator list info filter
  'EDUCATION_APPLICATION_COORDINATOR_LIST_INFO_FILTER.SEARCH_URGENT_APPLICATIONS': 'Pretražite zahtjeve',
  'EDUCATION_APPLICATION_COORDINATOR_LIST_INFO_FILTER.DESCRIPTION_SUFIX': 'sa zatraženom podrškom i savjetom',
  'EDUCATION_APPLICATION_COORDINATOR_LIST_INFO_FILTER.DESCRIPTION': 'Na zahtjev na koje je korisnik zatražio podršku i savjet potrebno je žurno reagirati.',

  // ---------- External education template list
  'EXTERNAL_EDUCATION_TEMPLATE_LIST_VIEW.ADD_EXTERNAL_EDUCATION_BUTTON_LABEL': 'Novi program',
  'EXTERNAL_EDUCATION_TEMPLATE_LIST_VIEW.PAGE_TITLE': 'Programi obrazovanja',
  'EXTERNAL_EDUCATION_TEMPLATE_LIST_VIEW.NO_DATA': 'Nema programa obrazovanja',
  'EXTERNAL_EDUCATION_TEMPLATE_LIST_VIEW.SKILLS_LABEL': 'Vještine',

  // ---------- External education template table
  'EXTERNAL_EDUCATION_TEMPLATE.TABLE.EDUCATION_PROVIDER_HEADER_LABEL': 'Pružatelj',
  'EXTERNAL_EDUCATION_TEMPLATE.TABLE.EXTERNAL_EDUCATION_TEMPLATE_TITLE_HEADER_LABEL': 'Naziv programa',
  'EXTERNAL_EDUCATION_TEMPLATE.TABLE.CREATION_STATUS_HEADER_LABEL': 'Status kreiranja',
  'EXTERNAL_EDUCATION_TEMPLATE.TABLE.ACTIVITY_PHASE_HEADER_LABEL': 'Faza programa',
  'EXTERNAL_EDUCATION_TEMPLATE.TABLE.COORDINATOR_HEADER_LABEL': 'Savjetnik',
  'EXTERNAL_EDUCATION_TEMPLATE.TABLE.COORDINATOR_NOT_ASSIGNED_LABEL': 'Nije preuzeto',
  'EXTERNAL_EDUCATION_TEMPLATE.TABLE.NOT_SUBMITTED_LABEL': 'Program nije podnesen',
  'EXTERNAL_EDUCATION_TEMPLATE.TABLE.SUMBITTED_AT_HEADER_LABEL': 'Vrijeme podnošenja',
  // --- steps
  'EXTERNAL_EDUCATION_TEMPLATE.FORM.STEP_ONE_TITLE': 'Program obrazovanja',
  'EXTERNAL_EDUCATION_TEMPLATE.FORM.STEP_TWO_TITLE': 'Dokumenti',

  // ---------- External education template data table picker
  'EXTERNAL_EDUCATION_TEMPLATE.TABLE_DATA_PICKER.EDUCATION_PROVIDER_HEADER_LABEL': 'Pružatelj',
  'EXTERNAL_EDUCATION_TEMPLATE.TABLE_DATA_PICKER.EXTERNAL_EDUCATION_TEMPLATE_TITLE_HEADER_LABEL': 'Naziv programa',
  'EXTERNAL_EDUCATION_TEMPLATE.TABLE_DATA_PICKER.CITY_HEADER_LABEL': 'Dostupne lokacije',
  'EXTERNAL_EDUCATION_TEMPLATE.TABLE_DATA_PICKER.CITY_ONLINE_LABEL': 'Online',
  'EXTERNAL_EDUCATION_TEMPLATE.MODAL_DATA_PICKER.TITLE': 'Promijenite program obrazovanja',
  'EXTERNAL_EDUCATION_TEMPLATE.TABLE_DATA_PICKER.SEE_INSTANCE_LIST_LABEL': 'prikaži termine',
  'EXTERNAL_EDUCATION_TEMPLATE.MODAL_DATA_PICKER.AVAILABLE_EDUCATION_TEMPLATE_LABEL': 'Dostupni programi',
  'EXTERNAL_EDUCATION_TEMPLATE.MODAL_DATA_PICKER.AVAILABLE_EDUCATION_TEMPLATE_TEXT': 'Niže su navedeni programi obrazovanja za odabranu vještinu. Ako dobijete odobrenje zahtjeva, moći ćete naknadno promijeniti program obrazovanja (ali ne vještinu).',
  // ---------- External education template filter
  'EXTERNAL_EDUCATION_TEMPLATE_DATA.FILTER.CITY_LABEL': 'Mjesto',

  // ---------- External education template activity status
  'EXTERNAL_EDUCATION_TEMPLATE.ACTIVITY.APPROVAL_REQUESTED': 'Zatraženo odobravanje',
  'EXTERNAL_EDUCATION_TEMPLATE.ACTIVITY.APPROVAL_IN_PROCESS': 'Odobravanje u tijeku',
  'EXTERNAL_EDUCATION_TEMPLATE.ACTIVITY.CHANGE_REQUESTED': 'Zatražene promjene',
  'EXTERNAL_EDUCATION_TEMPLATE.ACTIVITY.CHANGE_SUBMITTED': 'Promjene predane',
  'EXTERNAL_EDUCATION_TEMPLATE.ACTIVITY.APPROVED': 'Odobreno',
  'EXTERNAL_EDUCATION_TEMPLATE.ACTIVITY.EXTERNAL_EDUCATION_TEMPLATE_DENIED': 'Nije odobreno',
  'EXTERNAL_EDUCATION_TEMPLATE.ACTIVITY.CANCELED': 'Otkazano',

  // ---------- External education template timeline activity
  'EXTERNAL_EDUCATION_TEMPLATE.TIMELINE_ACTIVITY.APPROVAL_REQUESTED': '%{name} je zatražio/la odobravanje.',
  'EXTERNAL_EDUCATION_TEMPLATE.TIMELINE_ACTIVITY.APPROVAL_IN_PROCESS': 'Odobravanje u tijeku.',
  'EXTERNAL_EDUCATION_TEMPLATE.TIMELINE_ACTIVITY.CHANGE_REQUESTED': '%{name} je zatražio/la promjene.',
  'EXTERNAL_EDUCATION_TEMPLATE.TIMELINE_ACTIVITY.CHANGE_SUBMITTED': '%{name} je predao/la promjene.',
  'EXTERNAL_EDUCATION_TEMPLATE.TIMELINE_ACTIVITY.APPROVED': '%{name} je odobrio/la.',
  'EXTERNAL_EDUCATION_TEMPLATE.TIMELINE_ACTIVITY.EXTERNAL_EDUCATION_TEMPLATE_DENIED': '%{name} nije odobrio/la.',
  'EXTERNAL_EDUCATION_TEMPLATE.TIMELINE_ACTIVITY.CANCELED': '%{name} je otkazao/la.',
  'EXTERNAL_EDUCATION_TEMPLATE.TIMELINE_ACTIVITY.DENIED': '%{name} je odbio/la.',
  'EXTERNAL_EDUCATION_TEMPLATE.TIMELINE_ACTIVITY.NOTE.TITLE': 'HZZ savjetnik je napisao bilješku.',

  // ---------- External education template status
  'EXTERNAL_EDUCATION_TEMPLATE.STATUS.IN_CREATION': 'U izradi',
  'EXTERNAL_EDUCATION_TEMPLATE.STATUS.CREATION_FINISHED': 'Čeka odobrenje',
  'EXTERNAL_EDUCATION_TEMPLATE.STATUS.PUBLISHED': 'Objavljen',
  'EXTERNAL_EDUCATION_TEMPLATE.STATUS.ARCHIVED': 'Arhiviran',

  // ---------- External education template form
  'EXTERNAL_EDUCATION_TEMPLATE.FORM.TITLE_LABEL': 'Naziv programa',
  'EXTERNAL_EDUCATION_TEMPLATE.FORM.SKILLS_LABEL': 'Vještina/e koju polaznik usvaja programom',
  'EXTERNAL_EDUCATION_TEMPLATE.FORM.DESCRIPTION_LABEL': 'Opis programa',
  'EXTERNAL_EDUCATION_TEMPLATE.FORM.EDUCATION_DURATION_SUFFIX': 'sati',
  'EXTERNAL_EDUCATION_TEMPLATE.FORM.EDUCATION_CATEGORY_LABEL': 'Označite pripada li program nekoj od navedenih kategorija programa',
  'EXTERNAL_EDUCATION_TEMPLATE.FORM.EDUCATION_SECTOR_LABEL': 'Obrazovni sektor',
  'EXTERNAL_EDUCATION_TEMPLATE.FORM.DURATION_LABEL': 'Trajanje programa',
  'EXTERNAL_EDUCATION_TEMPLATE.FORM.AVERAGE_PRICE_LABEL': 'Prosječna cijena',
  'EXTERNAL_EDUCATION_TEMPLATE.FORM.MAX_VOUCHER_PRICE_LABEL': 'Maksimalni iznos vaučera',
  'EXTERNAL_EDUCATION_TEMPLATE.FORM.EDUCATION_OUTCOMES_LABEL': 'Očekivani ishodi',
  'EXTERNAL_EDUCATION_TEMPLATE.FORM.ENROLLMENT_REQUIREMENTS_LABEL': 'Uvjeti upisa',
  'EXTERNAL_EDUCATION_TEMPLATE.FORM.CERTIFICATE_NAME_LABEL': 'Naziv potvrde o završenom programu obrazovanja',
  'EXTERNAL_EDUCATION_TEMPLATE.FORM.CONTRACTOR_QUALIFICATION_LABEL': 'Kvalifikacije izvoditelja',
  'EXTERNAL_EDUCATION_TEMPLATE.MODAL.TITLE': 'Novi program obrazovanja',
  'EXTERNAL_EDUCATION_TEMPLATE.MODAL.DETAILS_TITLE': 'Detalji programa obrazovanja',
  'EXTERNAL_EDUCATION_TEMPLATE.FORM.EDUCATION_DURATION_PLACEHOLDER': 'Upišite trajanje',
  'EXTERNAL_EDUCATION_TEMPLATE.FORM.TITLE_PLACEHOLDER': 'Upišite naziv programa obrazovanja',
  'EXTERNAL_EDUCATION_TEMPLATE.FORM.SKILLS_PLACEHOLDER': 'Odaberite vještinu/e',
  'EXTERNAL_EDUCATION_TEMPLATE.FORM.DESCRIPTION_PLACEHOLDER': 'Upišite kratak opis programa',
  'EXTERNAL_EDUCATION_TEMPLATE.FORM.EDUCATION_SECTOR_PLACEHOLDER': 'Odaberite obrazovni sektor',
  'EXTERNAL_EDUCATION_TEMPLATE.FORM.ENROLLMENT_REQUIREMENTS_PLACEHOLDER': 'Pretražite postojeće uvjete',
  'EXTERNAL_EDUCATION_TEMPLATE.FORM.CERTIFICATE_NAME_PLACEHOLDER': 'Upišite naziv potvrde',
  'EXTERNAL_EDUCATION_TEMPLATE.FORM.CONTRACTOR_QUALIFICATION_PLACEHOLDER': 'Upišite potrebne kvalifikacije koje će posjedovati svi izvoditelji',
  'EXTERNAL_EDUCATION_TEMPLATE.FORM.STATUS_LABEL': 'Status',
  'EXTERNAL_EDUCATION_TEMPLATE.FORM.AVERAGE_PRICE_PLACEHOLDER': 'Upišite prosječnu cijenu',
  // info message
  'EXTERNAL_EDUCATION_TEMPLATE.CREATE_INFO_MESSAGE': 'Program obrazovanja spremljen',
  'EXTERNAL_EDUCATION_TEMPLATE.UPDATE_INFO_MESSAGE': 'Promjene spremljene',
  'EXTERNAL_EDUCATION_TEMPLATE.DELETE_INFO_MESSAGE': 'Program obrazovanja obrisan',

  // ---------- External education instance list
  'EXTERNAL_EDUCATION_INSTANCE_LIST_VIEW.ADD_EXTERNAL_EDUCATION_INSTANCE_BUTTON_LABEL': 'Novi način izvođenja',
  'EXTERNAL_EDUCATION_INSTANCE_LIST.START_DATE_TIME_LABEL': 'Datum početka',
  'EXTERNAL_EDUCATION_INSTANCE_LIST.ADDRESS_LABEL': 'Lokacija izvođenja',
  'EXTERNAL_EDUCATION_INSTANCE_LIST.ADDRESS_ONLINE_LABEL': 'Online',
  'EXTERNAL_EDUCATION_INSTANCE_LIST.EXECUTION_METHOD_LABEL': 'Način izvođenja',
  'EXTERNAL_EDUCATION_INSTANCE_LIST.PRICE_LABEL': 'Jedinična cijena',
  'EXTERNAL_EDUCATION_INSTANCE_LIST.CONTRACTORS_LABEL': 'Izvoditelj/i',
  'EXTERNAL_EDUCATION_INSTANCE_LIST.MODAL.TITLE': 'Način izvođenja',
  'EXTERNAL_EDUCATION_INSTANCE_LIST.MODAL.INFO_TEXT': 'Navedeni načini izvođenja su informativnog karaktera. Ako još nemate ponudu, ovdje možete otvoriti obrazac e-maila za pružatelja sa svim potrebnim podacima za ponudu ponudu: OTVORI OBRAZAC E-MAILA',
  'EXTERNAL_EDUCATION_INSTANCE.MODAL.CREATE_TITLE': 'Novi načini izvođenja',
  'EXTERNAL_EDUCATION_INSTANCE.MODAL.TITLE': 'Način izvođenja',
  'EXTERNAL_EDUCATION_INSTANCE_LIST.EXPANDED_ROW_TITLE': 'Dodatne informacije o izvođenju',

  // ---------- External education instance form
  'EXTERNAL_EDUCATION_INSTANCE.FORM.EXECUTION_METHOD_LABEL': 'Način izvođenja',
  'EXTERNAL_EDUCATION_INSTANCE.FORM.EXECUTION_METHOD_PLACEHOLDER_LABEL': 'Odaberite način izvođenja',
  'EXTERNAL_EDUCATION_INSTANCE.FORM.ADDRESS_LABEL': 'Mjesto izvođenja nastave',
  'EXTERNAL_EDUCATION_INSTANCE.FORM.DESCRIPTION_LABEL': 'Dodatne informacije o izvođenju (npr. raspored, održavanje prijepodne ili poslijepodne)',
  'EXTERNAL_EDUCATION_INSTANCE.FORM.STATUS_LABEL': 'Status',

  // ---------- Execution method options
  'EXECUTION_METHOD.SELECT_OPTION.ONLINE_LABEL': 'Online',
  'EXECUTION_METHOD.SELECT_OPTION.EDUCATION_PROVIDER_LABEL': 'U obrazovnoj ustanovi',
  'EXECUTION_METHOD.SELECT_OPTION.EMPLOYER_LABEL': 'Kod poslodavca',
  'EXECUTION_METHOD.SELECT_OPTION.COMBINED_LABEL': 'Kombinirano',

  // ---------- External education template coordinator
  'EXTERNAL_EDUCATION_TEMPLATE.COORDINATOR.APPROVAL_REQUESTED_TEXT': 'Preuzimanjem programa obrazovanja započet ćete proces verifikacije.',
  'EXTERNAL_EDUCATION_TEMPLATE.COORDINATOR.APPROVAL_IN_PROCCESS_TEXT': 'Pregledajte program. Ako program odgovara kriterijima odaberite "Verificirajte", ako ne odgovara odaberite "Nemojte verificirati". U slučaju da nedostaju potrebne informacije, zatražite informacije odabirom "Vratite pružatelju".',
  'EXTERNAL_EDUCATION_TEMPLATE.COORDINATOR.VERIFICATION_HEADER_TITLE': 'Verifikacija programa obrazovanja',
  'EXTERNAL_EDUCATION_TEMPLATE.COORDINATOR.TAKE_EDUCATION_TEMPLATE_BUTTON_TEXT': 'Preuzmite program obrazovanja',
  'EXTERNAL_EDUCATION_TEMPLATE.COORDINATOR.VERIFY_EDUCATION_TEMPLATE_BUTTON_TEXT': 'Verificirajte',
  'EXTERNAL_EDUCATION_TEMPLATE.COORDINATOR.RETURN_EDUCATION_TEMPLATE_BUTTON_TEXT': 'Vratite pružatelju',
  'EXTERNAL_EDUCATION_TEMPLATE.COORDINATOR.RETURN_EDUCATION_TEMPLATE_MODAL_TITLE': 'Vraćanje programa obrazovanja?',
  'EXTERNAL_EDUCATION_TEMPLATE.COORDINATOR.RETURN_EDUCATION_TEMPLATE_PLACEHOLDER': 'Razlog vraćanja',
  'EXTERNAL_EDUCATION_TEMPLATE.COORDINATOR.REJECT_VERIFICATION_EDUCATION_TEMPLATE_BUTTON_TEXT': 'Odbij',
  'EXTERNAL_EDUCATION_TEMPLATE.COORDINATOR.REJECT_VERIFICATION_EDUCATION_TEMPLATE_MODAL_TITLE': 'Odbijanje programa obrazovanja?',
  'EXTERNAL_EDUCATION_TEMPLATE.COORDINATOR.REJECT_VERIFICATION_EDUCATION_TEMPLATE_PLACEHOLDER': 'Razlog odbijanja verifikacije',

  // ---------- External education
  'EXTERNAL_EDUCATION_APPLICATION.APPLICATION_DENIED_TEXT': 'Zahtjev nije odobren',
  'EXTERNAL_EDUCATION_APPLICATION.TOOLTIP.SKILL_INFO': 'Upišite prva tri slova naziva programa obrazovanja ili odaberite odgovarajući program iz padajućeg izbornika.',
  'EXTERNAL_EDUCATION_APPLICATION.TOOLTIP.CURRICULUM_VITAE_INFO': 'Životopis treba sadržavati podatke o završenom obrazovanju, dodatnom usavršavanju, tečajevima, seminarima, dosadašnjem radnom iskustvu i stečenim vještinama, interesima i hobijima itd. Podržani formati su .pdf, .jpg, .jpeg, .png i .doc.',
  'EXTERNAL_EDUCATION_APPLICATION.TOOLTIP.ENROLLMENT_REQUIREMENT_INFO': 'Podržani formati su .pdf, .jpg, .jpeg, .png i .doc.',
  'EXTERNAL_EDUCATION_APPLICATION.TOOLTIP.CURRICULUM_INFO':
    'Kurikulum (nastavni plan i program) zatražite od pružatelja usluga obrazovanja. Datoteka treba sadržavati informacije o nazivu programa, području/obrazovnom sektoru kojemu pripada, uvjetima upisa, trajanju, načinu izvođenja (online, u učionici, kombinirano u učionici i kod poslodavca itd.), sadržaju programa obrazovanja (predmeti, teme, moduli i sl.), izvoditeljima (kvalifikacije predavača/nastavnika/mentora), očekivane ishode učenja koji će se steći završetkom programa obrazovanja, naziv potvrde o završenom programu obrazovanja, te okviran raspored nastave po danima/tjednima/mjesecima. Podržani formati su .pdf, .jpg, .jpeg, .png i .doc.',
  'EXTERNAL_EDUCATION_APPLICATION.TOOLTIP.SIGNED_FINANCING_AGREEMENT_INFO': ' Podržani formati su .pdf, .jpg, .jpeg, .png i .doc.',
  'EXTERNAL_EDUCATION_APPLICATION.TOOLTIP.START_DATE_INFO': 'Unesite datum početka programa obrazovanja dobiven od pružatelja usluga obrazovanja.',
  'EXTERNAL_EDUCATION_APPLICATION.TOOLTIP.CONTRACT_GENERATION_INFO': 'Na osnovi informacija iz priloženih datoteka ponude i kurikuluma te unesenog datuma početka programa generiran je Ugovor o međusobnim pravima i obvezama za vrijeme programa obrazovanja putem vaučera. Ugovor je potrebno preuzeti i potpisati.',
  'EXTERNAL_EDUCATION_APPLICATION.TOOLTIP.PROOF_OF_PAYMENT_INFO': 'Potrebno je priložiti potvrdu o plaćanju kako bi korisnik vaučera/polaznik obrazovanja mogao pohađati program obrazovanja. Podržani formati su .pdf, .jpg, .jpeg, .png i .doc.',
  'EXTERNAL_EDUCATION_APPLICATION.TOOLTIP.ATTENDANCE_CERTIFICATE_INFO':
    'Potvrdu o prisutnosti ovjerenu od strane pružatelja usluga programa nezaposlena osoba prilaže do najkasnije svakog 5. u mjesecu, a ostali tražitelji zaposlenja nakon završetka programa obrazovanja. Podržani formati su .pdf, .jpg, .jpeg, .png i .doc.',
  'EXTERNAL_EDUCATION_APPLICATION.TOOLTIP.COMPETENCIES_CERTIFICATE_INFO': 'Potvrdu o završenom programu obrazovanja zatražite od pružatelja usluga obrazovanja. Potvrda mora sadržavati podatak o nazivu programa, trajanju i stečenim ishodima učenja/kompetencijama. Podržani formati su .pdf, .jpg, .jpeg, .png i .doc.',
  'EXTERNAL_EDUCATION_APPLICATION.TOOLTIP.OFFER_INFO': 'Priložite ponudu programa obrazovanja. Podržani formati su .pdf, .jpg, .jpeg, .png i .doc.',
  'EXTERNAL_EDUCATION_APPLICATION.TOOLTIP.OFFER_INFO_LABEL': 'Podržani formati su .pdf, .jpg, .jpeg, .png i .doc.',
  'EXTERNAL_EDUCATION_APPLICATION.ERROR.SKILL_DATA': 'Korak 1 ("Program obrazovanja"): Odaberite vještinu koju želite steći',
  'EXTERNAL_EDUCATION_APPLICATION.ERROR.EDUCATION_DATA': 'Korak 1 ("Program obrazovanja"): Odaberite dostupni program za stjecanje vještine',
  'EXTERNAL_EDUCATION_APPLICATION.ERROR.EMPLOYMENT_STATUS': 'Korak 2 ("O meni"): Molimo odaberite status zaposlenosti',
  'EXTERNAL_EDUCATION_APPLICATION.ERROR.CONTACT_INFORMATION': 'Korak 2 ("O meni"): Unesite podatke za kontakt',
  'EXTERNAL_EDUCATION_APPLICATION.ERROR.EMPLOYER_INFORMATION': 'Korak 2 ("O meni"): Unesite podatke o poslodavcu',
  'EXTERNAL_EDUCATION_APPLICATION.ERROR.APPLICATION_DESCRIPTION_LENGTH': 'Korak 1 ("Program obrazovanja"): Obrazloženje mora sadržavati minimalno 500 znakova',
  'EXTERNAL_EDUCATION_APPLICATION.ERROR.APPLICATION_DESCRIPTION_REQUIRED': 'Korak 1 ("Program obrazovanja"): Upišite obrazloženje prijave',
  'EXTERNAL_EDUCATION_APPLICATION.ERROR.FILE_CURRICULUM_VITAE': 'Korak 2 ("O meni"): Dodajte životopis',
  'EXTERNAL_EDUCATION_APPLICATION.ERROR.OFFER': 'Korak 1 ("Program obrazovanja"): Dodajte ponudu pružatelja',
  'EXTERNAL_EDUCATION_APPLICATION.ERROR.ENROLLMENT_REQUIREMENT': 'Korak 2 ("O meni"): Dodajte dokaz da posjedujete potrebne uvjete',
  'EXTERNAL_EDUCATION_APPLICATION.ERROR.STATEMENT_ACCEPTED': 'Korak 1 ("Program obrazovanja"): Pročitajte i prihvatite izjavu',
  'EXTERNAL_EDUCATION_APPLICATION.ERROR.FILE_OFFER': 'Korak 1 ("Program obrazovanja"): Dodajte ponudu programa obrazovanja',
  'EXTERNAL_EDUCATION_APPLICATION.ERROR.FILE_CURRICULUM': 'Dodajte kurikulum programa obrazovanja',
  'EXTERNAL_EDUCATION_APPLICATION.FILE.ERROR.LAST_FILE_OF_SPECIFIED_TYPE': 'Zadnji tip dokumenta nije moguće obrisati.',
  'EXTERNAL_EDUCATION_APPLICATION.FILE.FILE_REMOVED_SUCCESS': 'Datoteka "%{fileName}" obrisana',

  'EXTERNAL_EDUCATION_APPLICATION.VIEW.EVALUATOR_TITLE': 'Savjetnik: %{name}',
  'EXTERNAL_EDUCATION_APPLICATION.VIEW.STEP_ONE_TITLE': 'Podnošenje zahtjeva',
  'EXTERNAL_EDUCATION_APPLICATION.VIEW.STEP_TWO_TITLE': 'Odobravanje zahtjeva',
  'EXTERNAL_EDUCATION_APPLICATION.VIEW.STEP_THREE_TITLE': 'Trajanje obrazovanja',
  'EXTERNAL_EDUCATION_APPLICATION.VIEW.STEP_FOUR_TITLE': 'Zahtjev zatvoren',

  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR_PAYMENT_INFO.BANK_NAME_LABEL': 'Naziv banke pružatelja',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR_PAYMENT_INFO.IBAN_LABEL': 'IBAN pružatelja (HRcc AAAA AAAB BBBB BBBB B)',

  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE_PAYMENT_INFO.BANK_NAME_LABEL': 'Naziv vaše banke',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE_PAYMENT_INFO.IBAN_LABEL': 'Vaš IBAN (HRcc AAAA AAAB BBBB BBBB B)',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE_PAYMENT_INFO.START_DATE_TIME_LABEL': 'Datum početka programa',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE_PAYMENT_INFO.START_DATE_TIME_PLACEHOLDER': 'Unesite početak programa',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE_PAYMENT_INFO.START_DATE_TIME_TOOLTIP': 'Točan datum početka obrazovnog programa koji ste dogovorili s odabranim pružateljem usluge obrazovanja',

  'EXTERNAL_EDUCATION_APPLICATION.SURVEY.TRAINEE_SURVEY_LABEL': 'Ocjena programa obrazovanja',
  'EXTERNAL_EDUCATION_APPLICATION.SURVEY.EMPLOYER_SURVEY_LABEL': 'Ocjena poslodavca',
  'EXTERNAL_EDUCATION_APPLICATION.SURVEY.EDUCATION_PROVIDER_SURVEY_LABEL': 'Ocjena pružatelja usluga',

  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.CANCEL_APPLICATION_LABEL': 'Istekao je rok za doradu zahtjeva, a korisnik ga nije doradio?',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.IN_PROCCESS_TEXT': ' Ako zahtjev odgovara kriterijima odaberite "Odobrite", ako ne odgovara odaberite "Nemojte odobriti" zahtjev. U slučaju da nedostaju potrebne informacije, možete od podnositelja zahtjeva zatražiti informacije, odabirom "Vratite korisniku"',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.APPLICATION_APPROVED_TEXT': 'Odobrili ste zahtjev korisnika. Korisnik je dužan poslat ponudu kako bi mogao krenuti na program obrazovanja.',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.APPLICATION_DENIED_TEXT': 'Zahtjev nije odobren',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.TAKE_APPLICATION_BUTTON_TEXT': 'Preuzmite zahtjev',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.APPROVE_APPLICATION_BUTTON_TEXT': 'Odobrite',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.RETURN_APPLICATION_BUTTON_TEXT': 'Vratite korisniku',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.RETURN_APPLICATION_MODAL_TITLE': 'Jeste li sigurni da želite vratiti korisniku zahtjev?',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.RETURN_APPLICATION_PLACEHOLDER': 'Unesite razlog vraćanja zahtjeva.',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.REJECT_APPLICATION_BUTTON_TEXT': 'Nemojte odobriti',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.REJECT_APPLICATION_MODAL_TITLE': 'Jeste li sigurni da želite odbiti zahtjev?',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.COORDINATOR_CANCEL_USER_APPLICATION_LABEL': 'Želite odustati u ime korisnika?',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.COORDINATOR_CANCEL_USER_APPLICATION_MODAL_TITLE': 'Jeste li sigurni da želite odustati u ime korisnika?',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.REJECT_APPLICATION_PLACEHOLDER': 'Unesite razlog odbijanja zahtjeva.',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.REJECT_APPLICATION_CONFIRM_BUTTON': 'Odbijte',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.APPLICATION_CANCELED_TEXT': 'Korisnik je otkazao ovaj zahtjev',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.REQUEST_SIGNED_CONTRACT_BUTTON_TEXT': 'Pošaljite korisniku',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.PREVIEW_CONTRACT_BUTTON_TEXT': 'Pogledajte predložak ugovora',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.SEND_MUTUALY_SIGNED_FINANCING_AGREEMENT_BUTTON_TEXT': 'Pošaljite korisniku',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.EDIT_NEW_CONTRACT_TYPE_BUTTON_TEXT': 'Promijenite tip ugovora',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.SAVE_NEW_CONTRACT_TYPE_BUTTON_TEXT': 'Spremite novi tip ugovora',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.AWAITING_SIGNED_CONTRACT_TEXT': 'Korisnik će kroz aplikaciju dostaviti ugovor potpisan sa svoje strane, nakon čega ugovor potpisuje HZZ.',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.EDUCATION_NOT_ENTERED_TEXT': 'Upišite informacije o programu obrazovanja',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.EDUCATION_ENTERED_TEXT': 'Upisali ste informacije o programu obrazovanja',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.CONTRACT_GENERATION_TEXT': 'Informacije su spremljene. Pogledajte predložak ugovora i pošaljite ga korisniku. Odabirom opcije za slanje ugovor će se automatski kreirati.',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.SIGNED_CONTRACT_UPLOADED_TEXT': 'Ispišite ugovor i zamolite predstojnika područne službe/ureda da se potpiše na ugovor.',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.ENABLE_EDUCATION_TEXT': 'Kada priložite potvrdu o plaćanju omogućite korisniku pohađanje programa obrazovanja.',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.CANCEL_APPLICATION_APPROVAL_BUTTON_TEXT': 'Poništite odobrenje',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.CANCEL_APPLICATION_APPROVAL_LABEL': 'Želite poništiti odobrenje zahtjeva?',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.CANCEL_APPLICATION_APPROVAL_MODAL_TITLE': 'Jeste li sigurni da želite poništiti odobrenje?',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.CANCEL_APPLICATION_APPROVAL_PLACEHOLDER': 'Unesite razlog poništavanja odobrenja',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.OPEN_SURVEY_BUTTON_LABEL': 'Pogledajte ocjenu',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.ENABLE_EDUCATION_BUTTON_TEXT': 'Omogućite pohađanje',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.RETURN_TO_CONTRACT_DATA_PROCESSING_INFO_TEXT': 'Želite se vratit natrag na unos broja ponude, iznosa vaučera ili promjenu tipa ugovora?',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.RETURN_TO_CONTRACT_DATA_PROCESSING_BUTTON_LABEL': 'Povratak u fazu "U obradi"',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.RETURN_TO_CONTRACT_DATA_PROCESSING_CONFIRMATION_TEXT': 'Ova radnja će izbrisati dosad generirane ugovore.',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.COORDINATOR_HELP_FINISHED_BUTTON_TEXT': 'Savjetovanje obavljeno',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.ENTER_USER_TRAVEL_EXPENSE_LABEL': 'Korisniku je uplaćen putni trošak?',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.ENTER_USER_TRAVEL_EXPENSE_BUTTON_LABEL': 'Unos evidencije troška',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.MUTUALLY_SIGNED_FINANCING_AGREEMENT_TEXT': 'Priložite ugovor koji je potpisan od strane korisnika i od predstojnika područne službe.',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.CONTRACT_ANNEX_REQUESTED_LABEL': 'Aneksiranje ugovora',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.CONTRACT_ANNEX_TYPE_LABEL': 'Tip aneks ugovora',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.CONTRACT_ANNEX_TYPE_MESSAGE': 'Molimo odaberite tip aneks ugovora',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.CONTRACT_ANNEX_TYPE_PLACEHOLDER': 'Odaberite tip aneks ugovora',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.CONTRACT_ANNEX_REQUEST_TEXT': 'Potrebno je aneksiranje ugovora?',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.CONTRACT_ANNEX_REQUESTED_BUTTON_TEXT': 'Aneksirajte ugovor',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.CONTRACT_ANNEX_TEMPLATE_BUTTON_TEXT': 'Predložak aneks ugovora',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.CONTRACT_ANNEX_REQUESTED_TEXT': 'Kreirali ste aneks ugovora i zatražili potpis. Korisnik će kroz aplikaciju dostavit potpisan aneks ugovora.',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.CONTRACT_TERMINATED_TEXT': 'Ugovor je otkazan',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.REQUESTED_SIGNED_ANNEX_BUTTON_TEXT': 'Pošaljite korisniku',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.MUTUALLY_SIGNED_CONTRACT_ANNEX_TEXT': 'Priložite aneks ugovora koji je potpisan od strane korisnika i od predstojnika područne službe/ureda.',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.SIGNED_ANNEX_CONTRACT_UPLOADED_TEXT': 'Ispišite aneks ugovora i zamolite predstojnika područne službe/ureda da se potpiše.',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.CONTRACT_TERMINATED_BUTTON_TEXT': 'Otkažite obrazovanje',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.CONTRACT_TERMINATED_MODAL_TITLE': 'Jeste li sigurni da želite otkazati obrazovanje',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.CONTRACT_TERMINATED_CONFIRM_BUTTON_TEXT': 'Otkažite obrazovanje',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.CONTRACT_TERMINATED_PLACEHOLDER': 'Unesite razlog otkazivanja obrazovanja',

  // contract annex type
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.CONTRACT_ANNEX_TYPE_LABEL.CUSTOM': 'Proizvoljni aneks',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.CONTRACT_ANNEX_TYPE_LABEL.FINANCING_AGREEMENT_EMPLOYED_CORRECTION': 'izmjena ugovora za tražitelje zaposlenja',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.CONTRACT_ANNEX_TYPE_LABEL.FINANCING_AGREEMENT_UNEMPLOYED_CORRECTION': 'izmjena ugovora za nezaposlene',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.CONTRACT_ANNEX_TYPE_LABEL.START_DATE_TIME_CORRECTION_UNEMPLOYED': 'izmjena termina početka nastave (NO)',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.CONTRACT_ANNEX_TYPE_LABEL.START_DATE_TIME_CORRECTION_EMPLOYED': 'izmjena termina početka nastave (OTZ)',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.CONTRACT_ANNEX_TYPE_LABEL.EMPLOYED_TO_UNEMPLOYED': 'izmjena OTZ u NO',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.CONTRACT_ANNEX_TYPE_LABEL.UNEMPLOYED_TO_EMPLOYED': 'izmjena NO u OTZ',

  // external education application coordinator info text
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.EXTERNAL_EDUCATION_TEMPLATE_SELECTION_INFO_TEXT': 'Korisnik je podnio zahtjev za promjenom programa. Kroz aplikaciju će vam dostaviti novu ponudu.',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.CAN_PARTICIPATE_INFO_TEXT': 'Ovaj zahtjev trenutno obrađuje drugi savjetnik.',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.PAYMENT_REQUESTED_DATE_TIME_INFO_TEXT': 'Pružatelj programa je označio program obrazovanja kao završen. Uplatite ostatak iznosa vaučera.',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.CONSULTATION_REQUESTED_INFO_TEXT': 'Korisnik je poslao zahtjev za usmjeravanje. Preuzmite zahtjev kako bi odgovorili na korisnikov upit.',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.CONSULTATION_STARTED_INFO_TEXT': 'Preuzeli ste zahtjev za usmjeravanjem, kontaktirajte korisnika kako bi dogovorili daljnje korake.',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.CONSULTATION_TERMINATED_INFO_TEXT': 'Zahtjev za usmjeravanjem je poništen.',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.EXTERNAL_EDUCATION_APPLICATION_CREATION_INFO_TEXT': 'Korisnik ispunjava zahtjev za program obrazovanja',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.CONTRACT_GENERATION_INFO_TEXT': 'Pričekajte da korisnik kroz aplikaciju dostavi potpisani ugovor.',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.AWAITING_SIGNED_CONTRACT_INFO_TEXT': 'Korisnik je priložio potpisan ugovor. Priložite ugovor potpisan od strane HZZ-a.',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.AWAITING_PAYMENT_INFO_TEXT': 'Poslali ste obostrano potpisan ugovor. 10 dana prije početka termina programa obrazovanja priložite potvrdu o plaćanju i omogućite pohađanje.',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.EDUCATION_IN_PROGRESS_INFO_TEXT': 'Korisnik će po završetku programa poslati potvrdu o prisutnosti i potvrdu o stečenim kompetencijama.',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.EDUCATION_COMPLETED_TEXT': 'Program obrazovanja je završen.',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.CONTRACT_ANNEX_REQUESTED_INFO_TEXT': 'Pričekajte da korisnik kroz aplikaciju dostavi potpisani aneks ugovora.',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.CONTRACT_ANNEX_SUBMITTED_INFO_TEXT': 'Korisnik je priložio potpisani aneks ugovora. Priložite aneks ugovora potpisan od strane HZZ-a.',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.CONTRACT_DATA_PROCESSING_TEXT': 'Korisnik je priložio ponudu. Unesite podatke potrebne za ugovor.',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.SUBMITTED_INFO_TEXT': 'Zahtjev je podnesen. Preuzmite zahtjev i odaberite kojoj kategoriji korisnik pripada.',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.AWAITING_APPROVAL_INFO_TEXT': 'Korisnik je podnio zahtjev. Odaberite kojoj kategoriji korisnik pripada i ocijenite zahtjev.',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.RETURNED_TO_USER_INFO_TEXT': 'Vratili ste korisniku zahtjev na doradu.',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.CONTRACT_DATA_PROCESSING_INFO_TEXT': 'Odobrili ste zahtjev. Unesite informacije potrebne za ugovor i pošaljite ugovor korisniku.',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.EDUCATION_COMPLETED_INFO_TEXT': 'Program obrazovanja je završen. Pogledajte ocjene koje je korisnik ostavio.',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.USER_CANCELED_INFO_TEXT': 'Korisnik je otkazao ovaj zahtjev',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.EXTERNAL_EDUCATION_APPLICATION_DENIED_INFO_TEXT': 'Odbili ste ovaj zahtjev',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.CONTRACT_TERMINATED_INFO_TEXT': 'Obrazovanje je obustavljeno i ugovor raskinut.',

  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.RETURN_TO_EDUCATION_TEMPLATE_SELECTION_CONFIRMATION_TITLE': 'Promjena programa i/ili ponude',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR.RETURN_TO_EDUCATION_TEMPLATE_SELECTION_CONFIRMATION_TEXT': 'Jeste li sigurni da želite promijeniti program i/ili ponudu? Promjenom se briše stara ponuda i odabir programa. Time se onemogućuje generiranje ugovora sve do prilaganja nove ponude.',

  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.FINANCING_AGREEMENT_TEXT': 'U nastavku preuzmite ugovor, pročitajte ga i potpišite. Potrebno je vlastoručno potpisati ispisani ugovor.',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.FINANCING_AGREEMENT_ADDED_DATE_TIME_TEXT': 'Vrijeme generiranja %{addedDateTime}. Potpisani ugovor priložite u nastavku.',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.SIGNED_FINANCING_AGREEMENT_TEXT': 'Kada priložite potpisani ugovor, zatražite potpis od strane HZZ-a. Nakon što zatražite potpis ugovora više neće biti moguće promijeniti program niti ponudu.',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.REQUEST_SIGNED_FINANCING_AGREEMENT_BUTTON_TEXT': 'Pošaljite ugovor savjetniku',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.SUBMITED_AND_WAITING_COORDINATOR_TEXT': 'HZZ savjetnik/ca će pregledati Vaš zahtjev. Bit ćete obaviješteni putem e-maila kada zahtjev bude pregledan.',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.APPROVED_AND_CONTRACT_IN_GENERATION_TEXT': 'HZZ savjetnik/ca je upisao/la podatke potrebne za ugovor i zatražio/la od Vas potpisani ugovor.',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.ENTER_PAYMENT_INFO_TEXT': 'Upišite datum početka programa i informacije o svojoj banci. Informacije su potrebne kako bi se izvršile uplate putnih troškova.',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.ENTER_START_DATE_NOTE_TEXT':
    'Molimo upisati točan datum početka obrazovanja, nakon što on bude precizno određen u dogovoru s pružateljem obrazovanja. Preporučujemo navesti datum početka obrazovanja najmanje 10 dana prije početka obrazovanja, kako bi Vaš zahtjev bio pravovremeno obrađen.',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.ENTER_START_DATE_TEXT': 'Upišite datum početka programa.',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.CONTRACT_GENERATED_TEXT': 'Uspješno ste generirali ugovor. Preuzmite, pročitajte i vlastoručno potpišite ispisani ugovor.',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.MUTUALY_SIGNED_FINANCIG_AGREEMENT_TEXT': ' HZZ savjetnik/ca je priložio potpisan ugovor.',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.AWAITING_PAYMENT_TEXT': '10 dana prije početka programa savjetnik/ca će Vam poslati potvrdu o plaćanju.',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.EDUCATION_IN_PROGRESS_TEXT': 'Kontaktirajte pružatelja usluge obrazovanja i započnite s programom obrazovanja.',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.CONTRACT_ANNEX_SUBMITTED_TEXT': 'Poslali ste aneks ugovora i zatražili ste potpis aneksa od strane HZZ-a.',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.UNEMPLOYED_ATTENDANCE_CERTIFICATE_TEXT': 'Kao nezaposlena osoba ste se ugovorom obvezali najkasnije svakog 5. u mjesecu dostaviti potvrdu o prisutnosti.',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.UPLOAD_COMPETENCIES_CERTIFICATE_TEXT': 'Nakon završetka programa obrazovanja, priložite potvrdu o stečenim kompetencijama. Potvrdu zatražite od pružatelja usluge.',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.APPLICATION_CANCELED_TEXT': 'Otkazali ste ovaj zahtjev',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.EDUCATION_IN_PROGRESS_FINISH_TEXT': 'Kada završite obrazovni program i priložite potvrdu o stečenim kompetencijama, klikom na gumb u nastavku potvrdite završetak programa obrazovanja.',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.EDUCATION_COMPLETED_TEXT': 'Pristupite upitniku za ocjenu programa. Prema potpisanom ugovoru, obvezni ste u roku od 10 dana nakon završetka programa obrazovanja ispuniti upitnik.',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.DESCRIPTION_EDUCATION_COMPLETED_BUTTON_TEXT': 'Kada završite obrazovni program i priložite potrebne potvrde, klikom na gumb u nastavku potvrdite završetak programa obrazovanja.',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.TAKE_SURVEY_BUTTON_LABEL': 'Pristupite upitniku',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.CANCEL_APPLICATION_LABEL': 'Ne možete pohađati ovaj program?',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.CANCEL_APPLICATION_BUTTON_TEXT': 'Odbacite zahtjev',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.SUBMITTED_TEXT': 'Zahtjev je podnesen. HZZ Savjetnik/ca će u roku od 10 dana pregledat Vaš zahtjev.',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.CONTRACT_DATA_PROCESSING_COORDINATOR_TEXT': 'HZZ savjetnik/ca je pregledao/la Vaš zahtjev i odobrio/la ga. HZZ savjetnik/ca treba unijeti podatke potrebne za ugovor.',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.CHANGE_EDUCATION_APPLICATION_BUTTON_TEXT': 'Promijenite program',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.CHANGE_EDUCATION_APPLICATION_LABEL': 'Ipak želite promijeniti program?',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.SUBMIT_SIGNED_OFFER_BUTTON_TEXT': 'Pošaljite savjetniku',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.SELECTED_EXTERNAL_EDUCATION_TEMPLATE_TEXT': 'Trenutno odabrani program: "%{educationTemplateTitle}".',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.EXTERNAL_EDUCATION_TEMPLATE_SELECTION_GUIDE_TEXT': 'Klikom na gumb "Promijenite program" izlistat će vam se dostupni programi za odabranu vještinu.',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.EXTERNAL_EDUCATION_TEMPLATE_SELECTION_TEXT': 'Ponudu zatražite od pružatelja programa obrazovanja. Ako još nemate ponudu, ovdje možete otvoriti obrazac e-maila za pružatelja sa svim potrebnim podacima za ponudu: ',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.EXTERNAL_EDUCATION_TEMPLATE_SELECTION_LABEL': 'OTVORI OBRAZAC E-MAILA',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.SUBMIT_SIGNED_CONTRACT_TEXT': 'Kada priložite potpisani ugovor, zatražite potvrdu o plaćanju od HZZ savjetnika.',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.SUBMIT_SIGNED_CONTRACT_BUTTON_TEXT': 'Zatražite potvrdu o plaćanju',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.GENERATE_CONTRACT_TEXT': 'Kada upišete podatke, generirajte ugovor',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.GENERATE_CONTRACT_BUTTON_TEXT': 'Generirajte ugovor',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.SEND_TO_SIGN_BUTTON_TEXT': 'Zatražite potpis ugovora',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.EDUCATION_COMPLETED_BUTTON_TEXT': 'Obrazovanje završeno',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.OFFER_UPLOAD_TEXT': 'Kada Vam pružatelj pošalje ponudu, ponudu preuzmite i priložite u nastavku. Nakon toga pošaljite ponudu savjetniku.',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.SUBMIT_OFFER_BUTTON_TEXT': 'Pošaljite ponudu',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.DURATION_CANCEL_APPLICATION_LABEL': 'Ne možete pohađati ovaj program?',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.DURATION_CANCEL_APPLICATION_BUTTON_TEXT': 'Obustavite program',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.CONTRACT_ANNEX_REQUESTED_TEXT': 'U nastavku preuzmite aneks ugovora, pročitajte ga i potipišite. Potrebno je vlastoručno potpisati aneks ugovora.',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.SIGNED_CONTRACT_ANNEX_REQUESTED_TEXT': 'Potpisani aneks ugovora priložite u nastavku.',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.MUTUALLY_SIGNED_CONTRACT_ANNEX_REQUESTED_TEXT': 'Kada priložite potpisani ankes ugovora, zatražite da aneks potpiše predstojnik HZZ-a.',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.MUTUALLY_SIGNED_CONTRACT_ANNEX_REQUESTED_BUTTON_LABEL': 'Zatražite potpis aneksa',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.RETURN_TO_EDUCATION_TEMPLATE_SELECTION_LABEL': 'Želite promijeniti program i/ili ponudu?',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.RETURN_TO_EDUCATION_TEMPLATE_SELECTION_BUTTON_TEXT': 'Promijenite',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.CONTRACT_TERMINATED_TEXT': 'Ugovor je otkazan',
  // external education application trainee info text
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.RETURN_TOUSER_BUTTON_LABEL': 'Prikaži aktivnosti',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.CONSULTATION_REQUESTED_INFO_TEXT': 'Poslali ste zahtjev za usmjeravanje. HZZ savjetnik/ca će Vas ubrzo kontaktirati.',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.CONSULTATION_STARTED_INFO_TEXT': 'HZZ savjetnik/ca je preuzela zahtjev za usmjeravanjem, te će Vas uskoro kontaktirati.',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.CONSULTATION_TERMINATED_INFO_TEXT': 'Zahtjev za usmjeravanjem je poništen.',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.EXTERNAL_EDUCATION_APPLICATION_CREATION_INFO_TEXT': 'Unesite sve potrebne podatke i predajte zahtjev, ili ga spremite i predajte kasnije.',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.SUBMITTED_INFO_TEXT': 'Poslali ste zahtjev. Pričekajte da HZZ savjetnik/ca preuzme i obradi zahtjev.',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.AWAITING_APPROVAL_INFO_TEXT': 'Poslali ste zahtjev. Pričekajte da HZZ savjetnik/ca preuzme i obradi zahtjev.',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.USER_CANCELED_INFO_TEXT': 'Otkazali ste zahtjev za vaučerom.',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.RETURNED_TO_USER_INFO_TEXT': 'HZZ savjetnik/ca vratio/la Vam je zahtjev na doradu. Više informacija o potrebnim doradama potražite ovdje.',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.EXTERNAL_EDUCATION_APPLICATION_DENIED_INFO_TEXT': 'Zahtjev nije odobren.',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.EXTERNAL_EDUCATION_TEMPLATE_SELECTION_INFO_TEXT': 'Odabrali ste promijeniti program i/ili ponudu. Odaberite novi program obrazovanja i/ili pošaljite novu ponudu.',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.CONTRACT_DATA_PROCESSING_INFO_TEXT': 'HZZ savjetnik/ca obrađuje zahtjev.',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.CONTRACT_GENERATION_INFO_TEXT': 'HZZ savjetnik/ca poslao/la Vam je ugovor na potpis. Preuzmite, potpišite i unesite ugovor te zatražite potpis od strane HZZ-a.',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.AWAITING_SIGNED_CONTRACT_INFO_TEXT': 'Pričekajte da HZZ savjetnik/ca unese obostrano potpisani ugovor.',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.CONTRACT_TERMINATED_INFO_TEXT': 'Obrazovanje je obustavljeno i ugovor raskinut.',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.AWAITING_PAYMENT_INFO_TEXT': 'Pričekajte da HZZ savjetnik/ca unese potvrdu o plaćanju programa obrazovanja.',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.EDUCATION_IN_PROGRESS_INFO_TEXT': 'HZZ savjetnik je odobrio Vaš zahtjev i priložio potvrdu o plaćanju.',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.EDUCATION_COMPLETED_INFO_TEXT': 'Završili ste program obrazovanja. Unesite potvrdu o stečenoj kompetenciji i ispunite upitnik.',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.CONTRACT_ANNEX_REQUESTED_INFO_TEXT': 'HZZ savjetnik/ca je poslao aneks ugovora na potpis. Preuzmite, potpišite i unesite aneks ugovora te zatražite potpis od strane HZZ-a.',
  'EXTERNAL_EDUCATION_APPLICATION.TRAINEE.CONTRACT_ANNEX_SUBMITTED_INFO_TEXT': 'Pričekajte da HZZ savjetnik/ca unese obostrano potpisani aneks ugovora.',

  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR_ADD_LABEL': 'Dodajte savjetnika',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR_CHANGE_LABEL': 'Promijenite savjetnika',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR_SEARCH_PLACEHOLDER': 'Pronađite savjetnika',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR_VALIDATION_MESSAGE': 'Molimo odaberite novog savjetnika',
  'EXTERNAL_EDUCATION_APPLICATION.COORDINATOR_LABEL': 'Kliknite u izbornik i upišite ime novog savjetnika. Klikom na OK savjetnik će se automatski ažurirati.',

  // agreement form
  'EXTERNAL_EDUCATION_APPLICATION.AGREEMENT_FORM.CODE_OFFER_LABEL': 'Broj ponude',
  'EXTERNAL_EDUCATION_APPLICATION.AGREEMENT_FORM.EDUCATION_EXPENSE_LABEL': 'Cijena programa',
  'EXTERNAL_EDUCATION_APPLICATION.AGREEMENT_FORM.CO_FINANCED_EDUCATION_PRICE_LABEL': 'Iznos vaučera',
  'EXTERNAL_EDUCATION_APPLICATION.AGREEMENT_FORM.CO_FINANCED_EDUCATION_PRICE_PLACEHOLDER': 'Upišite sufinancirani iznos',
  'EXTERNAL_EDUCATION_APPLICATION.AGREEMENT_FORM.DISTRICT_OFFICE_ADDRESS_LABEL': 'Sjedište PS/PU',
  'EXTERNAL_EDUCATION_APPLICATION.AGREEMENT_FORM.CODE_OFFER_PLACEHOLDER': 'Upišite broj ponude',
  'EXTERNAL_EDUCATION_APPLICATION.AGREEMENT_FORM.EDUCATION_EXPENSE_PLACEHOLDER': 'Upišite iznos troška',
  'EXTERNAL_EDUCATION_APPLICATION.AGREEMENT_FORM.DISTRICT_OFFICE_ADDRESS_PLACEHOLDER': 'Upišite sjedište PS/PU',
  'EXTERNAL_EDUCATION_APPLICATION.AGREEMENT_FORM.FINANCING_AGREEMENT_TYPE_LABEL': 'Tip ugovora',
  'EXTERNAL_EDUCATION_APPLICATION.AGREEMENT_FORM.FINANCING_AGREEMENT_TYPE_PLACEHOLDER': 'Odaberite tip ugovora',
  'EXTERNAL_EDUCATION_APPLICATION.AGREEMENT_FORM.FINANCING_AGREEMENT_TYPE_LABEL.EMPLOYED': ' Za tražitelja zaposlenja',
  'EXTERNAL_EDUCATION_APPLICATION.AGREEMENT_FORM.FINANCING_AGREEMENT_TYPE_LABEL.EMPLOYED_CO_FINANCED_BY_EMPLOYER': 'Za tražitelja zaposlenja s mogućnošću sufinanciranja od strane poslodavca',
  'EXTERNAL_EDUCATION_APPLICATION.AGREEMENT_FORM.FINANCING_AGREEMENT_TYPE_LABEL.EMPLOYED_CO_FINANCED_BY_USER': 'Za tražitelja zaposlenja s mogućnošću sufinanciranja od strane korisnika',
  'EXTERNAL_EDUCATION_APPLICATION.AGREEMENT_FORM.FINANCING_AGREEMENT_TYPE_LABEL.UNEMPLOYED': 'Za nezaposlenu osobu',
  'EXTERNAL_EDUCATION_APPLICATION.AGREEMENT_FORM.FINANCING_AGREEMENT_TYPE_LABEL.UNEMPLOYED_CO_FINANCED': 'Za nezaposlenu osobu s mogućnošću sufinanciranja',
  'EXTERNAL_EDUCATION_APPLICATION.AGREEMENT_FORM.FINANCING_AGREEMENT_TYPE_LABEL.UNEMPLOYED_WAIVER_OF_FINANCIAL_AID': 'Ugovor - NO - Odustanak od NP',
  'EXTERNAL_EDUCATION_APPLICATION.AGREEMENT_FORM.FINANCING_AGREEMENT_TYPE_LABEL.UNEMPLOYED_CO_FINANCED_WAIVER_OF_FINANCIAL_AID': 'Ugovor - NO - sufin - Odustanak od NP',
  //  agreement form validation message
  'EXTERNAL_EDUCATION_APPLICATION.AGREEMENT_FORM.VALIDATION.CODE_OFFER_MESSAGE': 'Molimo unesite broj ponude',
  'EXTERNAL_EDUCATION_APPLICATION.AGREEMENT_FORM.VALIDATION.EDUCATION_EXPENSE_MESSAGE': 'Molimo unesite iznos troška',
  'EXTERNAL_EDUCATION_APPLICATION.AGREEMENT_FORM.VALIDATION.DISTRICT_OFFICE_ADDRESS_MESSAGE': 'Molimo unesite sjedište PS/PU',
  'EXTERNAL_EDUCATION_APPLICATION.AGREEMENT_FORM.VALIDATION.FINANCING_AGREEMENT_TYPE_MESSAGE': 'Molimo odaberite tip željenog ugovora',
  'EXTERNAL_EDUCATION_APPLICATION.AGREEMENT_FORM.VALIDATION.CO_FINANCED_EDUCATION_PRICE_MESSAGE': 'Molimo unesite sufinancirani iznos',

  // user category form
  'EXTERNAL_EDUCATION_APPLICATION.USER_CATEGORY.FORM.USER_CATEGORY_LABEL': 'Kategorija korisnika',
  'EXTERNAL_EDUCATION_APPLICATION.USER_CATEGORY.FORM.USER_CATEGORY_TOOLTIP_LABEL': 'Klasifikacija korisnika vidljiva je samo savjetnicima.',
  'EXTERNAL_EDUCATION_APPLICATION.USER_CATEGORY.FORM.USER_CATEGORY_PLACEHOLDER': 'Odaberite kategoriju korisnika',
  'USER_CATEGORY.NEET_LABEL': 'NEET korisnik',
  'USER_CATEGORY.LONG_TERM_UNEMPLOYED_LABEL': 'Dugotrajno nezaposleni',
  'USER_CATEGORY.PERSON_WITH_DISABILITIES_LABEL': 'Osoba s invaliditetom',
  'USER_CATEGORY.VICTIM_OF_DOMESCTIC_VIOLENCE_LABEL': 'Žrtva obiteljskog nasilja',
  'USER_CATEGORY.HOMELESS_LABEL': 'Beskućnik',
  'USER_CATEGORY.INTERNACTIONAL_PROTECTED_PERSON_LABEL': 'Osoba pod međunarodnom zaštitom',
  'USER_CATEGORY.ROMA_LABEL': 'Osoba romske nacionalne manjine',
  'USER_CATEGORY.OLDER_THAN_FIFTY_LABEL': 'Osoba starija od 50 godina',
  'USER_CATEGORY.OTHER_LABEL': 'Osoba nije pripadnik osjetljive skupine',
  // user category modal
  'USER_CATEGORY.MODAL.TITLE': 'Uredite kategorije korisnika',

  // ---------- External education application timeline
  'EXTERNAL_EDUCATION_APPLICATION.ACTIVITY.TITLE': 'Aktivnosti i bilješke zahtjeva',
  'EXTERNAL_EDUCATION_APPLICATION.ACTIVITY.EXTERNAL_EDUCATION_APPLICATION_SUBMITTED': '%{name} je podnio/la zahtjev.',
  'EXTERNAL_EDUCATION_APPLICATION.ACTIVITY.EXTERNAL_EDUCATION_APPLICATION_APPROVED': '%{name} je odobrio/la zahtjev.',
  'EXTERNAL_EDUCATION_APPLICATION.ACTIVITY.EXTERNAL_EDUCATION_APPLICATION_DENIED': '%{name} je odbio/la zahtjev korisniku.',
  'EXTERNAL_EDUCATION_APPLICATION.ACTIVITY.COORDINATOR_ADDED': '%{name} je dodan/a kao savjetnik.',
  'EXTERNAL_EDUCATION_APPLICATION.ACTIVITY.COORDINATOR_REMOVED': '%{name} je uklonjen/a kao savjetnik.',
  'EXTERNAL_EDUCATION_APPLICATION.ACTIVITY.SIGNED_FINANCING_AGREEMENT_REQUESTED': '%{name} je zatražio/la potpisan ugovor.',
  'EXTERNAL_EDUCATION_APPLICATION.ACTIVITY.FILE_ATTACHED': '%{name} je priložio/la datoteku %{filename}.',
  'EXTERNAL_EDUCATION_APPLICATION.ACTIVITY.EDUCATION_COMPLETED': '%{name} je završio/la program obrazovanja.',
  'EXTERNAL_EDUCATION_APPLICATION.ACTIVITY.SURVEY_SUBMITTED': '%{name} je ispunio/la upitnik.',
  'EXTERNAL_EDUCATION_APPLICATION.ACTIVITY.SURVEY_SUBMITTED_EDUCATION_PROVIDER': 'Pružatelj obrazovanja je ispunio upitnik.',
  'EXTERNAL_EDUCATION_APPLICATION.ACTIVITY.SURVEY_SUBMITTED_EMPLOYER': 'Poslodavac je ispunio upitnik.',
  'EXTERNAL_EDUCATION_APPLICATION.ACTIVITY.NOTE.TITLE': '%{name} je napisao bilješku.',
  'EXTERNAL_EDUCATION_APPLICATION.ACTIVITY.CONSULTATION_REQUESTED': '%{name} je zatražio profesionalno usmjeravanje.',
  'EXTERNAL_EDUCATION_APPLICATION.ACTIVITY.CONSULTATION_TERMINATED': '%{name} je otkazao profesionalno usmjeravanje.',
  'EXTERNAL_EDUCATION_APPLICATION.ACTIVITY.UNKNOWN_FILE_TITLE': '[Nepoznata datoteka]',
  'EXTERNAL_EDUCATION_APPLICATION.ACTIVITY.EXTERNAL_EDUCATION_APPLICATION_RETURNED_TO_USER': 'Vraćeno korisniku.',
  'EXTERNAL_EDUCATION_APPLICATION.ACTIVITY.MUTUALLY_SIGNED_FINANCING_AGREEMENT_REQUESTED': '%{name} je zatražio/la obostrano potpisan ugovor.',
  'EXTERNAL_EDUCATION_APPLICATION.ACTIVITY.EXTERNAL_EDUCATION_TEMPLATE_CHANGED': '%{name} je promijenio/la program obrazovanja.',
  'EXTERNAL_EDUCATION_APPLICATION.ACTIVITY.SIGNED_CONTRACT_ANNEX_REQUESTED': '%{name} je zatražio/la potpisan aneks ugovora.',
  'EXTERNAL_EDUCATION_APPLICATION.ACTIVITY.MUTUALLY_SIGNED_CONTRACT_ANNEX_REQUESTED': '%{name} je zatražio/la obostrano potpisan aneks ugovora.',
  'EXTERNAL_EDUCATION_APPLICATION.ACTIVITY.EXTERNAL_EDUCATION_APPLICATION_CHANGES_SUBMITTED': '%{name} je odradio/la promjene na zahtjevu za program obrazovanja.',
  'EXTERNAL_EDUCATION_APPLICATION.ACTIVITY.CONSULTATION_COMPLETED': 'Profesionalno usmjeravanje završeno.',
  'EXTERNAL_EDUCATION_APPLICATION.ACTIVITY.COORDINATOR_REVOKED_APPROVAL': 'HZZ savjetnik je poništio odobrenje za ovaj zahtjev',
  'EXTERNAL_EDUCATION_APPLICATION.ACTIVITY.EXTERNAL_EDUCATION_APPLICATION_USER_CANCELLED': '%{name} je otkazao ovaj zahtjev',
  'EXTERNAL_EDUCATION_APPLICATION.ACTIVITY.CONTRACT_REGENERATION': '%{name} je ponovno zatražio potpisan ugovor.',
  'EXTERNAL_EDUCATION_APPLICATION.ACTIVITY.EDUCATION_PROVIDER_REQUESTED_PAYMENT': 'Pružatelj je označio završetak programa %{endDateTime}. Datum potraživanja uplate %{paymentRequestedDateTime}.',
  // ---------- Education outcome picker
  'EDUCATION_OUTCOME.PICKER.OUTCOME_PLACEHOLDER': 'Pretražite postojeće ishode',
  'EDUCATION_OUTCOME.PICKER.OUTCOME_EMPTY_MESSAGE': 'Nema pronađenih ishoda',

  // ---------- External education template picker
  'EXTERNAL_EDUCATION_TEMPLATE.PICKER.SEARCH_PLACEHOLDER': 'Pronađite program obrazovanja',

  // ----------- External education template tabs
  'EXTERNAL_EDUCATION_TEMPLATE.TABS.EDUCATION_INSTANCES_LABEL': 'Načini izvođenja',
  'EXTERNAL_EDUCATION_TEMPLATE.TABS.EDUCATION_PROVIDER_LABEL': 'Pružatelj programa',
  'EXTERNAL_EDUCATION_TEMPLATE.TABS.RATING_LABEL': 'Ocjene',
  'EXTERNAL_EDUCATION_TEMPLATE.TABS.ACTIVITY_HISTORY_LABEL': 'Aktivnosti',

  // ----------- External education template
  'EXTERNAL_EDUCATION_TEMPLATE.VIEW_SECTION.TITLE': 'O programu obrazovanja',
  'EXTERNAL_EDUCATION_TEMPLATE.VIEW_SECTION.VERIFICATION_BUTTON_LABEL': 'Pošaljite na verifikaciju',
  'EXTERNAL_EDUCATION_TEMPLATE.VIEW_SECTION.EDUCATION_PROVIDER_NAME_LABEL': 'pružatelj usluga',
  'EXTERNAL_EDUCATION_TEMPLATE.VIEW_SECTION.EDUCATION_PROVIDER_ADDRESS_LABEL': 'adresa pružatelja',
  'EXTERNAL_EDUCATION_TEMPLATE.VIEW_SECTION.EDUCATION_PROVIDER_IDENTIFICATION_NUMBER_LABEL': 'OIB pružatelja',
  'EXTERNAL_EDUCATION_TEMPLATE.VIEW_SECTION.EDUCATION_PROVIDER_EMAIL_LABEL': 'e-mail pružatelja',
  'EXTERNAL_EDUCATION_TEMPLATE.VIEW_SECTION.EDUCATION_DESCRIPTION': 'program obrazovanja',
  'EXTERNAL_EDUCATION_TEMPLATE.VIEW_SECTION.EDUCATION_DURATION': '%{duration} sati',
  'EXTERNAL_EDUCATION_TEMPLATE.VIEW_SECTION.EDUCATION_DURATION_LABEL': 'trajanje programa',
  'EXTERNAL_EDUCATION_TEMPLATE.VIEW_SECTION.EDUCATION_OUTCOME_LABEL': 'Ishodi programa',
  'EXTERNAL_EDUCATION_TEMPLATE.VIEW_SECTION.EDUCATION_OUTCOME_DESCRIPTION': 'ishod programa',
  'EXTERNAL_EDUCATION_TEMPLATE.VIEW_SECTION.COST_LABEL': '%{averagePrice}',
  'EXTERNAL_EDUCATION_TEMPLATE.VIEW_SECTION.AVERAGE_PRICE_DESCRIPTION': 'prosječna cijena (Tečaj 1€ = %{eurToKunaExchangeRate} kn)',
  'EXTERNAL_EDUCATION_TEMPLATE.VIEW_SECTION.MAX_VOUCHER_PRICE_TITLE': 'Maksimalni iznos vaučera koji će se dodijeliti',
  'EXTERNAL_EDUCATION_TEMPLATE.VIEW_SECTION.MAX_VOUCHER_PRICE_DESCRIPTION': 'Maksimalni iznos (Tečaj 1€ = %{eurToKunaExchangeRate} kn)',
  'EXTERNAL_EDUCATION_TEMPLATE.VIEW_SECTION.CONTRACTOR_QUALIFICATION_DESCRIPTION': 'kvalifikacije izvoditelja',
  'EXTERNAL_EDUCATION_TEMPLATE.VIEW_SECTION.CERTIFICATE_NAME_DESCRIPTION': 'naziv potvrde po završetku',
  'EXTERNAL_EDUCATION_TEMPLATE.VIEW_SECTION.DESCRIPTION_TITLE': 'Opis programa',
  'EXTERNAL_EDUCATION_TEMPLATE.VIEW_SECTION.ENROLLMENT_REQUIREMENTS_TITLE': 'Uvjeti upisa programa',
  'EXTERNAL_EDUCATION_TEMPLATE.VIEW_SECTION.ENROLLMENT_REQUIREMENTS_DESCRIPTION': 'uvjet za pohađanje programa',
  'EXTERNAL_EDUCATION_TEMPLATE_RATE.VIEW_SECTION.HEADER_TITLE': 'Ocjene vidljive savjetnicima i pružateljima',
  'EXTERNAL_EDUCATION_TEMPLATE.VIEW_SECTION.SKILLS_TITLE': ' Vještine koje se stječu završetkom programa obrazovanja',
  'EXTERNAL_EDUCATION_TEMPLATE.VIEW_SECTION.EDUCATION_SECTOR_TITLE': 'Obrazovni sektor',
  'EXTERNAL_EDUCATION_TEMPLATE.VIEW_SECTION.DETAILS_TITLE': 'Detalji programa',
  'EXTERNAL_EDUCATION_TEMPLATE.VIEW_SECTION.DOCUMENTS_LABEL': 'Datoteke',
  'EXTERNAL_EDUCATION_TEMPLATE.VIEW_SECTION.VERIFICATION_BUTTON_TOOLTIP_LABELF': 'Priložite dokumente kako bi mogli poslat program na verifikaciju',

  'EXTERNAL_EDUCATION_TEMPLATE_LIST.FILTER.EDUCATION_PROVIDER_LABEL': 'Pružatelj',
  'EXTERNAL_EDUCATION_TEMPLATE_LIST.FILTER.EVALUATOR_LABEL': 'Savjetnik',
  'EXTERNAL_EDUCATION_TEMPLATE_LIST.FILTER.APPROVAL_PHASE_LABEL': 'Faza programa',
  'EXTERNAL_EDUCATION_TEMPLATE_LIST.FILTER.TEMPLATE_TITLE_LABEL': 'Naziv programa',
  'EXTERNAL_EDUCATION_TEMPLATE_LIST.FILTER.TEMPLATE_TITLE_PLACEHOLDER': 'Upišite naziv programa',
  'EXTERNAL_EDUCATION_TEMPLATE_LIST.FILTER.STATUS_LABEL': 'Status programa',

  'EDUCATION_PROVIDER.VIEW_SECTION.HEADER_TITLE': 'O pružatelju programa obrazovanja',
  'EDUCATION_PROVIDER.VIEW_SECTION.SHOW_PROFILE_BUTTON_LABEL': 'Pogledaj profil',

  // ----------- External education application statistics
  'EXTERNAL_EDUCATION_APPLICATION_STATISTICS.VIEW_STATISTICS_BUTTON_LABEL': 'Prikaži statistiku',
  'EXTERNAL_EDUCATION_APPLICATION_STATISTICS.SURVEY_REPORT.GRADE_TITLE': 'Ocjene',
  'EXTERNAL_EDUCATION_APPLICATION_STATISTICS.SURVEY_REPORT.SURVEYS_BY_SURVEY_TYPE': 'Ispunjenih upitnika prema vrsti upitnika ',
  'EXTERNAL_EDUCATION_APPLICATION_STATISTICS.SURVEY_REPORT.SUBMITTED_SURVEYS': 'Ukupno ispunjenih upitnika',
  'EXTERNAL_EDUCATION_APPLICATION_STATISTICS.SURVEY_REPORT.EDUCATION_PROVIDER_SURVEYS': 'pružatelji programa obrazovanja',
  'EXTERNAL_EDUCATION_APPLICATION_STATISTICS.SURVEY_REPORT.EMPLOYER_SURVEYS': 'poslodavci',
  'EXTERNAL_EDUCATION_APPLICATION_STATISTICS.SURVEY_REPORT.USER_EDUCATION_COMPLETED_SURVEYS': 'korisnici odmah po završetku',
  'EXTERNAL_EDUCATION_APPLICATION_STATISTICS.SURVEY_REPORT.USER_EDUCATION_COMPLETED_CHECK_IN_SURVEYS': 'korisnici nakon 6 mjeseci',
  'EXTERNAL_EDUCATION_APPLICATION_STATISTICS.SURVEY_REPORT.SURVEY_QUESTION_LABEL': '%{orderNumber}. %{questionText} (%{numberOfAnswers} odgovora)',
  'EXTERNAL_EDUCATION_APPLICATION_STATISTICS.SURVEY_REPORT.EDUCATION_PROVIDER_SURVEYS_AVERAGE_QUESTION_TITLE': 'Prosječni odgovori po pitanju "Upitnik za pružatelja programa obrazovanja"',
  'EXTERNAL_EDUCATION_APPLICATION_STATISTICS.SURVEY_REPORT.EMPLOYER_SURVEY_AVERAGE_QUESTION_TITLE': 'Prosječni odgovori po pitanju "Upitnik za poslodavce"',
  'EXTERNAL_EDUCATION_APPLICATION_STATISTICS.SURVEY_REPORT.EDUCATION_COMPLETED_SURVEY_AVERAGE_QUESTION_TITLE': 'Prosječni odgovori po pitanju "Upitnik za korisnike odmah nakon završetka"',

  'EXTERNAL_EDUCATION_APPLICATION_STATISTICS.MODAL.STATISTICS_TITLE': 'Statistika',
  'EXTERNAL_EDUCATION_APPLICATION_STATISTICS.STATISTICS_COUNT_TITLE': 'Broj zahtjeva',
  'EXTERNAL_EDUCATION_APPLICATION_STATISTICS.STATISTICS_TOTAL_COUNT_TITLE': 'Ukupno zahtjeva',
  'EXTERNAL_EDUCATION_APPLICATION_STATISTICS.STATISTICS_COUNT_PER_APPLICATION_STATUS_TITLE': 'Prema statusu zahtjeva',
  'EXTERNAL_EDUCATION_APPLICATION_STATISTICS.STATISTICS_COUNT_PER_EMPLYOMENT_STATUS_TITLE': 'Prema statusu zaposlenosti korisnika',
  'EXTERNAL_EDUCATION_APPLICATION_STATISTICS.STATISTICS_COUNT_PER_EDUCATION_CATEGORY_TITLE': 'Prema kategoriji programa',
  'EXTERNAL_EDUCATION_APPLICATION_STATISTICS.STATISTICS_COUNT_PER_USER_CATEGORY_TITLE': 'Prema kategoriji korisnika',
  'EXTERNAL_EDUCATION_APPLICATION_STATISTICS.STATISTICS_COUNT_SUBMITTED_APPLICATIONS': 'podneseni zahtjevi',
  'EXTERNAL_EDUCATION_APPLICATION_STATISTICS.STATISTICS_COUNT_APPLICATIONS_IN_PROGRESS': 'zahtjevi u tijeku',
  'EXTERNAL_EDUCATION_APPLICATION_STATISTICS.STATISTICS_COUNT_APPLICATIONS_IN_PROCESS': 'zahtjevi u obradi',
  'EXTERNAL_EDUCATION_APPLICATION_STATISTICS.STATISTICS_COUNT_APPLICATIONS_COMPLETED': 'završeni zahtjevi',
  'EXTERNAL_EDUCATION_APPLICATION_STATISTICS.STATISTICS_COUNT_APPLICATIONS_EMPLOYED': 'zaposleni',
  'EXTERNAL_EDUCATION_APPLICATION_STATISTICS.STATISTICS_COUNT_APPLICATIONS_UNEMPLYOED': 'nezaposleni',

  'EXTERNAL_EDUCATION_APPLICATION_STATISTICS.STATISTICS_AVERAGE_EXPENSES_TITLE': 'Prosječni troškovi u kunama',

  // ----------- Admin codebooks
  'CODEBOOK.CODEBOOK_TITLE': 'Šifrarnici',
  [`CODEBOOK.TITLE_LABEL.${CodebookEnum.GRADE}`]: 'Ocjena',
  [`CODEBOOK.TITLE_LABEL.${CodebookEnum.EDUCATION_CATEGORY}`]: 'Kategorija programa',
  [`CODEBOOK.TITLE_LABEL.${CodebookEnum.EDUCATION_SECTOR}`]: 'Obrazovni sektor',
  [`CODEBOOK.TITLE_LABEL.${CodebookEnum.EDUCATION_QUALIFICATION}`]: 'Razina obrazovanja',
  [`CODEBOOK.TITLE_LABEL.${CodebookEnum.ENROLLMENT_REQUIREMENT}`]: 'Uvjeti upisa',
  [`CODEBOOK.TITLE_LABEL.${CodebookEnum.USER_CATEGORY}`]: 'Kategorija korisnika',
  [`CODEBOOK.TITLE_LABEL.${CodebookEnum.SKILL_LEVEL}`]: 'Razina vještina',
  [`CODEBOOK.TITLE_LABEL.${CodebookEnum.LOCATION}`]: 'Lokacija',
  // ------ Grade
  'CODEBOOK_GRADE.CREATE_CODED_GRADE_BUTTON_LABEL': 'Nova ocjena',
  'CODEBOOK_GRADE.CODED_GRADE_DESCRIPTION_LABEL': 'Opis:',
  'CODEBOOK_GRADE_FORM.TITLE': 'Kreiranje nove ocjene',
  'CODEBOOK_GRADE_FORM.NAME_LABEL': 'Naziv ocjene',
  'CODEBOOK_GRADE_FORM.DESCRIPTION_LABEL': 'Opis ocjene',
  'CODEBOOK_GRADE_FORM_FORM.ORDERING_LABEL': 'Redoslijed',
  // info message
  'CODEBOOK_GRADE.CREATE_INFO_MESSAGE': 'Uspješno ste kreirali šifrarnik ocjene',
  'CODEBOOK_GRADE.DELETE_INFO_MESSAGE': 'Uspješno ste obrisali šifrarnik ocjene',
  // error message
  'CODEBOOK_GRADE.ERROR.INVALID_ORDERING': 'Šifrarnik ocjene postoji s trenutnim rednim brojem',

  // ------ Education qualification
  'EDUCATION_QUALIFICATION.CREATE_EDUCATION_QUALIFICATION_BUTTON_LABEL': 'Nova razina znanja',
  'EDUCATION_QUALIFICATION_FORM.TITLE': 'Kreiranje nove razine obrazovanja',
  'EDUCATION_QUALIFICATION_FORM.NAME_LABEL': 'Naziv razine znanja',
  'EDUCATION_QUALIFICATION_FORM.DESCRIPTION_LABEL': 'Opis razine znanja',
  // info message
  'EDUCATION_QUALIFICATION.CREATE_INFO_MESSAGE': 'Uspješno ste kreirali šifrarnik razine obrazovanja',
  'EDUCATION_QUALIFICATION.DELETE_INFO_MESSAGE': 'Uspješno ste obrisali šifrarnik razine obrazovanja',

  // ------ Enrollment requirement
  'ENROLLMENT_REQUIREMENT.CREATE_BUTTON_LABEL': 'Novi uvjet upisa',
  'ENROLLMENT_REQUIREMENT_FORM.TITLE': 'Kreiranje uvjeta upisa',
  'ENROLLMENT_REQUIREMENT_FORM.NAME_LABEL': 'Naziv',
  'ENROLLMENT_REQUIREMENT_FORM.DESCRIPTION_LABEL': 'Opis',
  'ENROLLMENT_REQUIREMENT.DESCRIPTION_LABEL': 'Opis:',
  // info message
  'ENROLLMENT_REQUIREMENT.CREATE_INFO_MESSAGE': 'Uspješno ste kreirali uvjet upisa',
  'ENROLLMENT_REQUIREMENT.DELETE_INFO_MESSAGE': 'Uspješno ste obrisali uvjet upisa',

  // ------ Education sector
  'EDUCATION_SECTOR.CREATE_BUTTON_LABEL': 'Novi obrazovni sektor',
  'EDUCATION_SECTOR_FORM.TITLE': 'Kreiranje obrazovnog sektora',
  'EDUCATION_SECTOR_FORM.NAME_LABEL': 'Naziv',
  'EDUCATION_SECTOR_FORM.DESCRIPTION_LABEL': 'Opis',
  'EDUCATION_SECTOR.DESCRIPTION_LABEL': 'Opis:',
  // info message
  'EDUCATION_SECTOR.CREATE_INFO_MESSAGE': 'Uspješno ste kreirali obrazovni sektor',
  'EDUCATION_SECTOR.DELETE_INFO_MESSAGE': 'Uspješno ste obrisali obrazovni sektor',

  // ------ Education category
  'EDUCATION_CATEGORY.CREATE_BUTTON_LABEL': 'Nova kategorija programa',
  'EDUCATION_CATEGORY_FORM.TITLE': 'Kreiranje kategorije programa',
  'EDUCATION_CATEGORY_FORM.NAME_LABEL': 'Naziv',
  'EDUCATION_CATEGORY_FORM.DESCRIPTION_LABEL': 'Opis',
  'EDUCATION_CATEGORY.DESCRIPTION_LABEL': 'Opis:',
  // info message
  'EDUCATION_CATEGORY.CREATE_INFO_MESSAGE': 'Uspješno ste kreirali kategoriju programa',
  'EDUCATION_CATEGORY.DELETE_INFO_MESSAGE': 'Uspješno ste obrisali kategoriju programa',

  // ------ LOCATION
  'LOCATION_CODEBOOK.CREATE_LOCATION_BUTTON_LABEL': 'Nova lokacija',
  'LOCATION_CODEBOOK.LOCATION_DESCRIPTION_LABEL': 'Tip lokacije:',
  'LOCATION_FORM.DESCRIPTION_LABEL': 'Opis razine znanja',
  'LOCATION_CODEBOOK_FORM.TITLE': 'Kreiranje nove lokacije',
  'LOCATION_CODEBOOK_FORM.TITLE_LABEL': 'Naziv',
  'LOCATION_CODEBOOK_FORM.ADRESS_LABEL': 'Adresa',
  'LOCATION_CODEBOOK_FORM.LOCATION_TYPE_LABEL': 'Tip lokacije',
  'LOCATION_CODEBOOK_FORM.MANAGER_LABEL': 'Predstojnik',
  'LOCATION_CODEBOOK_FORM.CONTACT_DATA_LABEL': 'Kontakt',
  'LOCATION_TYPE.DISTRICT_OFFICE_LABEL': 'Područni ured/služba',
  // info message
  'LOCATION_CODEBOOK.CREATE_INFO_MESSAGE': 'Uspješno ste kreirali šifrarnik lokacije',
  'LOCATION_CODEBOOK.DELETE_INFO_MESSAGE': 'Uspješno ste obrisali šifrarnik lokacije',

  // ------Skill level
  'SKILL_LEVEL.CREATE_BUTTON_LABEL': 'Nova razina vještine',
  'SKILL_LEVEL_MODAL.TITLE': 'Razina vještine',
  'SKILL_LEVEL_FORM.LEVEL_LABEL': 'Razina',
  'SKILL_LEVEL_FORM.NAME_LABEL': 'Naziv',
  // info message
  'SKILL_LEVEL.CREATE_INFO_MESSAGE': 'Uspješno ste kreirali šifrarnik razine znanja lokacije',

  // ------User category
  'USER_CATEGORY.CREATE_BUTTON_LABEL': 'Nova vrsta korisnika',
  // info message
  'USER_CATEGORY.CREATE_INFO_MESSAGE': 'Uspješno ste kreirali šifrarnik vrste korisnika',

  // ----------- Contact data property input
  'CONTACT_DATA_PROPERTY_INPUT.ADD_CONTACT_LABEL': 'Dodajte kontakt',
  'CONTACT_DATA_PROPERTY_INPUT.TYPE.EMAIL_LABEL': 'E-mail',
  'CONTACT_DATA_PROPERTY_INPUT.TYPE.PHONE_LABEL': 'Telefon',
  'CONTACT_DATA_PROPERTY_INPUT.TYPE.MOBILE_PHONE_LABEL': 'Mobitel',
  // error message
  'CONTACT_DATA_PROPERTY_INPUT.ERROR_MESSAGE.MINIMUM_FIELD_REQUIRED': 'Molimo Vas da uneste barem jedan kontakt',

  // ----------- Address property input
  'ADDRESS_PROPERTY_INPUT.STREET_WITH_HOME_NUMBER_LABEL': 'Ulica i kućni broj',
  'ADDRESS_PROPERTY_INPUT.CITY_LABEL': 'Mjesto',
  'ADDRESS_PROPERTY_INPUT.ZIP_LABEL': 'Poštanski broj',
  'ADDRESS_PROPERTY_INPUT.COUNTRY_LABEL': 'Država',

  // ---------- Address short info
  'ADDRESS_SHORT_INFO_INPUT.CITY_PLACEHOLDER': 'Mjesto',
  'ADDRESS_SHORT_INFO_INPUT.STREET_WITH_HOME_NUMBER_PLACEHOLDER': 'Upišite ulicu i kućni broj',

  // ----------- Skill level classification
  'SKILL_LEVEL_CLASSIFICATION_LIST.NO_DATA': 'Nisu unesene razine vještina. Molimo kontaktirajte svog administratora.',
  'SKILL_LEVEL_CLASSIFICATION_LIST.LEVEL_LABEL': 'Br. razine',
  'SKILL_LEVEL_CLASSIFICATION_LIST.LEVEL_DESCRIPTION_LABEL': 'Opis razine',
  'SKILL_LEVEL_CLASSIFICATION_LIST.LEVEL_NAME_LABEL': 'Naziv razine',

  // ----------- Skill level classification form
  'SKILL_LEVEL_CLASSIFICATION.FORM.LEVEL_DESCRIPTION_LABEL': 'Opis Razine %{levelNumber}',
  'SKILL_LEVEL_CLASSIFICATION.FORM.LEVEL_DESCRIPTION_PLACEHOLDER': 'Upišite opis razine %{levelNumber}',
  'SKILL_LEVEL_CLASSIFICATION.FORM.EDIT_SKILL_LEVEL_BUTTON_LABEL': 'Uredi razine',

  // ----------- Skill level classification data picker
  'SKILL_LEVEL_CLASSIFICATION_PICKER.LEVEL_DESCRIPTION_LABEL': 'Opis razine:',

  // ----------- Skill level classification modal
  'SKILL_LEVEL_CLASSIFICATION.MODAL.TITLE': 'Uredi razine programa vještine',

  // ----------- Skill tree picker
  'SKILL_TREE_PICKER.SELECT_PLACEHOLDER': 'Izaberite vještinu',

  // ---------- Question Types
  'QUESTION_TYPE.YES_NO': 'Da/ne',
  'QUESTION_TYPE.SINGLE_ANSWER': 'Jedan točan odgovor',
  'QUESTION_TYPE.MULTIPLE_ANSWERS': 'Više točnih odgovora',
  'QUESTION_TYPE.ANSWER_PAIRS': 'Uparivanje odgovora',
  'QUESTION_TYPE.PAIR_DRAG': 'Povlačenje parova',
  'QUESTION_TYPE.WORD_INSERT': 'Upisivanje riječi',
  'QUESTION_TYPE.ELEMENT_INSERT': 'Upisivanje u elemente',
  'QUESTION_TYPE.WORD_SELECT': 'Odabiranje riječi',
  'QUESTION_TYPE.WORD_DRAG': 'Povlačenje riječi',
  'QUESTION_TYPE.ELEMENT_GROUP_SORT': 'Razvrstavanje elemenata',
  'QUESTION_TYPE.ELEMENT_ORDER': 'Uređivanje poretka elemenata',
  'QUESTION_TYPE.NUMERIC_RANGE': 'Numerički',
  'QUESTION_TYPE.PICTURE_DRAG': 'Povlačenje na sliku',
  'QUESTION_TYPE.REPL': 'REPL zadatak',
  'QUESTION_TYPE.ESSAY': 'Esejsko pitanje',
  'QUESTION_TYPE.FILE': 'Pitanje s datotekom',
  // ---------- Survey Question Types
  'QUESTION_TYPE.SURVEY_SINGLE_ANSWER': 'Jedan točan odgovor',
  'QUESTION_TYPE.SURVEY_MULTIPLE_ANSWERS': 'Više točnih odgovora',
  'QUESTION_TYPE.LINEAR_SCALE': 'Linearna ljestvica',
  'QUESTION_TYPE.GRID': 'Grid',

  // ----------- Organization
  'ORGANIZATION_VIEW.EDUCATION_PROVIDER_LABEL': 'pružatelj usluge',
  'ORGANIZATION_VIEW.EXTERNAL_EDUCATION_TEMPLATES_TAB_LABEL': 'Programi obrazovanja',
  'ORGANIZATION_VIEW.EXTERNAL_EDUCATION_APPLICATIONS_TAB_LABEL': 'Popis ponuda',
  'ORGANIZATION_VIEW.USERS_TAB_LABEL': 'Povezani korisnici',
  'ORGANIZATION_VIEW.USERS_EMPTY': 'Ova organizacija nema povezanih korisnika',
  'ORGANIZATION_VIEW.DESCRIPTION_LABEL': 'Opis',
  'ORGANIZATION_VIEW.IDENTIFICATION_NUMBER_LABEL': 'OIB',
  'ORGANIZATION_VIEW.ADDRESS_LABEL': 'sjedište',
  'ORGANIZATION_VIEW.BANK_LABEL': 'banka pružatelja (vidljivo savjetnicima)',
  'ORGANIZATION_VIEW.IBAN_LABEL': 'IBAN pružatelja (vidljivo savjetnicima)',
  'ORGANIZATION_VIEW.URL_LABEL': 'poveznica na web stranicu',
  'ORGANIZATION_VIEW.CONTACT_LABEL': 'e-mail',
  'ORGANIZATION_LIST.NO_DATA': 'Nema poslovnih profila',
  'ORGANIZATION_LIST.ADD_BUTTON_LABEL': 'Novi pružatelj',
  'ORGANIZATION_LIST.NAME_FILTER_LABEL': 'Ime',
  'ORGANIZATION_FORM.TITLE_EDIT': 'Uredi',
  'ORGANIZATION_FORM.TITLE_CREATE': 'Novi profil pružatelja usluga',
  'ORGANIZATION_FORM.DESCRIPTION_LABEL': 'Opis ustanove i usluga',
  'ORGANIZATION_FORM.DESCRIPTION_PLACEHOLDER_LABEL': 'Upišite osnovne informacije o ustanovi i uslugama koje pruža',
  'ORGANIZATION_FORM.URL_LABEL': 'Poveznica na web stranicu pružatelja',
  'ORGANIZATION_FORM.URL_PLACEHOLDER_LABEL': 'Upišite link',
  'ORGANIZATION_FORM.LOGO_LABEL': 'Logo pružatelja',
  'ORGANIZATION_FORM.COMPANY_REQUIRED_LABEL': 'Molimo unesite podatke o organizaciji',
  'ORGANIZATION_VIEW.JOINED_ORGANIZATION_INFO_MESSAGE': 'Uspješno ste se pridružili organizaciji!',
  'ORGANIZATION_VIEW.NEW_MEMBER_BUTTON': 'Novi član',
  'ORGANIZATION_VIEW.EDIT_BUTTON': 'Uredite profil',

  'ORGANIZATION_GROUP.NO_DATA': 'Nema organizacijskih grupa',
  'ORGANIZATION_GROUP.NEW_GROUP_TITLE': 'Nova organizacijska grupa',
  'ORGANIZATION_GROUP.EDIT_GROUP_TITLE': 'Uredi organizacijsku grupu',
  'ORGANIZATION_GROUP.CREATED_GROUP_MESSAGE': 'Organizacijska grupa spremljena',

  'ORGANIZATION_MEMBER_LIST.ROLE_TYPE.OWNER': 'Vlasnik',
  'ORGANIZATION_MEMBER_LIST.ROLE_TYPE.ADMIN': 'Administrator grupe',
  'ORGANIZATION_MEMBER_LIST.ROLE_TYPE.MEMBER': 'Član',

  'ORGANIZATION.DATA_PICKER.ORGANIZATION_PLACEHOLDER': 'Pretražite postojeće pružatelje',

  'ORGANIZATION_EXTERNAL_EDUCATION_TEMPLATE.LIST.OFFER_CODE_HEADER_LABEL': 'Broj ponude',
  'ORGANIZATION_EXTERNAL_EDUCATION_TEMPLATE.LIST.EXTERNAL_EDUCATION_TEMPLATE_HEADER_LABEL': 'Naziv programa',
  'ORGANIZATION_EXTERNAL_EDUCATION_TEMPLATE.LIST.ASSIGNEE_HEADER_LABEL': 'Korisnik',
  'ORGANIZATION_EXTERNAL_EDUCATION_TEMPLATE.LIST.EXTERNAL_EDUCATION_APPLICATION_PHASE_HEADER_LABEL': 'Status zahtjeva',
  'ORGANIZATION_EXTERNAL_EDUCATION_TEMPLATE.LIST.EXTERNAL_EDUCATION_APPLICATION_PAYMENT_REQUESTED_DATE_TIME_HEADER_LABEL': 'Datum zatraživanja',
  'ORGANIZATION_EXTERNAL_EDUCATION_TEMPLATE.LIST.EXTERNAL_EDUCATION_APPLICATION_END_DATE_TIME_HEADER_LABEL': 'Datum završetka',
  'ORGANIZATION_EXTERNAL_EDUCATION_TEMPLATE.LIST.ACTION_REQUEST_PAYMENT_BUTTON_LABEL': 'Zatražite uplatu',

  'ORGANIZATION_EDUCATION_APPLICATION.LIST_FILTER.EDUCATION_LABEL': 'Naziv programa',
  'ORGANIZATION_EDUCATION_APPLICATION.LIST_FILTER.OFFER_CODE_LABEL': 'Broj ponude',
  'ORGANIZATION_EDUCATION_APPLICATION.LIST_FILTER.EDUCATION_APPLICATION_PHASE_LABEL': 'Status',
  'ORGANIZATION_EDUCATION_APPLICATION.LIST_FILTER.PAYMENT_REQUESTED_LABEL': 'Zatražena uplata',

  'ORGANIZATION_PAYMENT_REQUEST.MODAL.TITLE': 'Zahtjev za uplatom',
  'ORGANIZATION_PAYMENT_REQUEST.FORM.PAYMENT_REQUESTED_DATE_TIME_LABEL': 'Datum završetka programa',
  'ORGANIZATION_PAYMENT_REQUEST.FORM.IS_ONLINE_LABEL': 'Izvođenje online',
  'ORGANIZATION_PAYMENT_REQUEST.FORM.EDUCATION_LOCATION_LABEL': 'Mjesto izvođenja',
  // error messages
  'ORGANIZATION_ERROR_MESSAGE.NON_EXISTING_ORGANIZATION_PROFILE': 'Kod ne odgovara ni jednoj organizaciji u sustavu',

  // ----------- Payment Info
  'PAYMENT_INFO_FORM.BANK_NAME_LABEL': 'Banka (vidljivo savjetnicima)',
  'PAYMENT_INFO_FORM.IBAN_LABEL': 'IBAN (vidljivo savjetnicima)',
  'PAYMENT_INFO_FORM.BANK_NAME_PLACEHOLDER_LABEL': 'Upišite banku',
  'PAYMENT_INFO_FORM.IBAN_PLACEHOLDER_LABEL': 'Upišite IBAN',

  // ----------- SkillBased Recommendations
  'SKILL_BASED_RECOMMENDATION.FILTER.TYPE_LABEL': 'Preporuči za',
  'SKILL_BASED_RECOMMENDATION.FILTER.TYPE_USER_LABEL': 'korisnika',
  'SKILL_BASED_RECOMMENDATION.FILTER.TYPE_WORKPOSITION_LABEL': 'radno mjesto',
  'SKILL_BASED_RECOMMENDATION.FILTER.USER_LABEL': 'Korisnik',
  'SKILL_BASED_RECOMMENDATION.FILTER.WORKPOSITION_LABEL': 'Radno mjesto',
  'SKILL_BASED_RECOMMENDATION.FILTER.VALUE_RELATION_LABEL': 'Smjer razlike',
  'SKILL_BASED_RECOMMENDATION.FILTER.MAX_ABSOLUTE_DIFF_LABEL': 'Maksimalna razlika',
  'SKILL_BASED_RECOMMENDATION.FILTER.RELATION_TYPE_LOWER': 'Manje',
  'SKILL_BASED_RECOMMENDATION.FILTER.RELATION_TYPE_HIGHER': 'Više',
  'SKILL_BASED_RECOMMENDATION.FILTER.RELATION_TYPE_BETWEEN': 'Između',
  'SKILL_BASED_RECOMMENDATION.FILTER.VALUE_REALTION_TOOLTIP': 'Manje - oni koji imaju manju razinu vještine u zadanoj maksimalnoj razlici. Više - oni koji imaju veću razinu vještine u zadanoj maksimalnoj razlici. Između - oni koji imaju manju/višu razinu vještine u zadanoj maksimalnoj razlici',
  'SKILL_BASED_RECOMMENDATION.LIST_ITEM_COMPATIBILITY_LABEL': 'Poklapanje',

  // ---------- Certificate list view
  'CERTIFICATE.COMPLETED_COURSE_LABEL': 'Potvrda o završenom tečaju',

  // ---------- Skill administration
  'ADMINISTRATION_SKILL_VIEW.SIDER_MENU.SKILL_GROUP': 'Vještine',
  'ADMINISTRATION_SKILL_VIEW.SIDER_MENU.SKILLS_GAP': 'Skills gap',

  // ---------- Progress tracker
  'PROGRESS_TRACKER.DATE_LABEL': 'Datum i vrijeme',
  'PROGRESS_TRACKER.STATUS_LABEL': 'Status',
  'PROGRESS_TRACKER.ACTION_LABEL': 'Akcija',
  'PROGRESS_TRACKER.BUTTON_USER_PARSER': 'Prikaži deaktivirane korisnike',
  'PROGRESS_TRACKER.BUTTON_REPORT_CREATION': 'Prikaži stvorene izvještaje',
  'PROGRESS_TRACKER.RELOAD_BUTTON_TOOLTIP': 'Osvježi status sinkronizacije',

  // ---------- Deactivated users
  'DEACTIVATED_USER_LIST_VIEW.MODAL.TITLE': 'Deaktivirani korisnici',

  // ---------- Course status button update
  [`COURSE_UPDATE_STATUS.${CourseStatusEnum.IN_CREATION}_BUTTON`]: 'Vrati na uređivanje',
  [`COURSE_UPDATE_STATUS.${CourseStatusEnum.CREATION_FINISHED}_BUTTON`]: 'Završi uređivanje',
  [`COURSE_UPDATE_STATUS.${CourseStatusEnum.ARCHIVED}_BUTTON`]: ' Arhiviraj tečaj',
  [`COURSE_UPDATE_STATUS.${CourseStatusEnum.PUBLISHED}_BUTTON`]: ' Objavi tečaj',

  // ----------- Progress tracker status
  [`PROGRESS_TRACKER.STATUS_ENUM.${ProgressTrackerStatusEnum.COMPLETED}_LABEL`]: 'Završeno',
  [`PROGRESS_TRACKER.STATUS_ENUM.${ProgressTrackerStatusEnum.IN_PROGRESS}_LABEL`]: 'U tijeku',
  [`PROGRESS_TRACKER.STATUS_ENUM.${ProgressTrackerStatusEnum.FAILED}_LABEL`]: 'Neuspješno',

  // ----------- Timun user import
  'TIMUN_IMPORT_USER.BUTTON': 'Uvoz korisnika',
  'TIMUN_IMPORT_USER.CREATE_INFO_MESSAGE': 'Uspješno dodan korisnik',
  'TIMUN_IMPORT_USER.VALID_USER_TITLE': 'Ispravni korisnici',
  'TIMUN_IMPORT_USER.INVALID_USER_TITLE': 'Neispravni korisnici',
  'TIMUN_IMPORT_USER.ADD_TIMUN_USERS_TITLE': 'Uvoz korisnika',
  'TIMUN_IMPORT_USER.USER_ERROR': 'Razlog zašto korisnik ne može biti stvoren',

  // -----------Import user error data
  [`TIMUN_IMPORT_USER.USER_DATA_ERROR_ENUM.${TimunImportUserErrorEnum.MISSING_MANDATORY_DATA}_ERROR.${DataErrorEnum.USERNAME}_LABEL`]: 'Nedostaje korisničko ime',
  [`TIMUN_IMPORT_USER.USER_DATA_ERROR_ENUM.${TimunImportUserErrorEnum.MISSING_MANDATORY_DATA}_ERROR.${DataErrorEnum.PASSWORD}_LABEL`]: 'Neispravna lozinka',
  [`TIMUN_IMPORT_USER.USER_DATA_ERROR_ENUM.${TimunImportUserErrorEnum.MISSING_MANDATORY_DATA}_ERROR.${DataErrorEnum.FIRST_NAME}_LABEL`]: 'Nedostaje ime',
  [`TIMUN_IMPORT_USER.USER_DATA_ERROR_ENUM.${TimunImportUserErrorEnum.MISSING_MANDATORY_DATA}_ERROR.${DataErrorEnum.LAST_NAME}_LABEL`]: 'Nedostaje prezime',
  [`TIMUN_IMPORT_USER.USER_DATA_ERROR_ENUM.${TimunImportUserErrorEnum.MISSING_MANDATORY_DATA}_ERROR.${DataErrorEnum.EMAIL}_LABEL`]: 'Nedostaje e-mail',
  [`TIMUN_IMPORT_USER.USER_DATA_ERROR_ENUM.${TimunImportUserErrorEnum.INVALID_DATE_FORMAT}_ERROR.${DataErrorEnum.DATE_OF_BIRTH}_LABEL`]: 'Neispravan format datuma rođenja',
  [`TIMUN_IMPORT_USER.USER_DATA_ERROR_ENUM.${TimunImportUserErrorEnum.INVALID_DATE_FORMAT}_ERROR.${DataErrorEnum.WORK_START_DATE}_LABEL`]: 'Neispravan format datuma početka rada',
  [`TIMUN_IMPORT_USER.USER_DATA_ERROR_ENUM.${TimunImportUserErrorEnum.NON_EXISTING_WORK_POSITION}_ERROR.${DataErrorEnum.WORK_POSITION}_LABEL`]: 'Neispravno radno mjesto',
  [`TIMUN_IMPORT_USER.USER_DATA_ERROR_ENUM.${TimunImportUserErrorEnum.PASSWORD_TOO_SHORT}_ERROR.${DataErrorEnum.PASSWORD}_LABEL`]: 'Prekratka lozinka',
  [`TIMUN_IMPORT_USER.USER_DATA_ERROR_ENUM.${TimunImportUserErrorEnum.INVALID_EMAIL_ADDRESS}_ERROR.${DataErrorEnum.EMAIL}_LABEL`]: 'Neispravan e-mail',
  [`TIMUN_IMPORT_USER.USER_DATA_ERROR_ENUM.${TimunImportUserErrorEnum.INVALID_ADDRESS}_ERROR.${DataErrorEnum.PHONE_NUMBER}_LABEL`]: 'Nedostaje broj mobitela',
  [`TIMUN_IMPORT_USER.USER_DATA_ERROR_ENUM.${TimunImportUserErrorEnum.INVALID_ADDRESS}_ERROR.${DataErrorEnum.MOBILE_PHONE}_LABEL`]: 'Nedostaje telefonski broj',
  [`TIMUN_IMPORT_USER.USER_DATA_ERROR_ENUM.${TimunImportUserErrorEnum.INVALID_ADDRESS}_ERROR.${DataErrorEnum.STREET}_LABEL`]: 'Nedostaje ulica',
  [`TIMUN_IMPORT_USER.USER_DATA_ERROR_ENUM.${TimunImportUserErrorEnum.INVALID_ADDRESS}_ERROR.${DataErrorEnum.HOME_NUMBER}_LABEL`]: 'Nedostaje kućni broj',
  [`TIMUN_IMPORT_USER.USER_DATA_ERROR_ENUM.${TimunImportUserErrorEnum.INVALID_ADDRESS}_ERROR.${DataErrorEnum.CITY}_LABEL`]: 'Nedostaje grad',
  [`TIMUN_IMPORT_USER.USER_DATA_ERROR_ENUM.${TimunImportUserErrorEnum.INVALID_ADDRESS}_ERROR.${DataErrorEnum.ZIP_CODE}_LABEL`]: 'Nedostaje poštanski broj',
  [`TIMUN_IMPORT_USER.USER_DATA_ERROR_ENUM.${TimunImportUserErrorEnum.INVALID_ADDRESS}_ERROR.${DataErrorEnum.COUNTRY}_LABEL`]: 'Nedostaje država',
  [`TIMUN_IMPORT_USER.USER_DATA_ERROR_ENUM.${TimunImportUserErrorEnum.USERNAME_ALREADY_IN_USE}_ERROR.${DataErrorEnum.USERNAME}_LABEL`]: 'Korisničko ime već postoji',

  // ----------- API response errors
  'API_RESPONSE_ERROR.UNRECOGNIZED_EXCEPTION': 'Nepoznata iznimka!',
  'API_RESPONSE_ERROR.UNKNOWN_TENANT': 'Tenant nije prepoznat ili nije poslan!',
  'API_RESPONSE_ERROR.JSON_PARSE_ERROR': 'Greška prilikom pokušaja raščlanjivanja JSON-a!',
  'API_RESPONSE_ERROR.XML_PARSE_ERROR': 'Neuspješno raščlanjivanje XML-a.',
  'API_RESPONSE_ERROR.NOT_IMPLEMENTED': 'Metoda nije implementirana.',
  'API_RESPONSE_ERROR.TEMPLATE_ERROR': 'Greška prilikom dohvaćanja predloška.',
  'API_RESPONSE_ERROR.USER_NOT_FOUND': 'Korisnik sa navedenim ID-em nije pronađen!',
  'API_RESPONSE_ERROR.RESOURCE_NOT_FOUND': 'Resurs sa navedenim ID-em nije pronađen!',
  'API_RESPONSE_ERROR.BAD_CREDENTIALS': 'Neispravni pristupni podaci!',
  'API_RESPONSE_ERROR.NUMBER_OF_CHARACTERS_EXCEEDED': 'Prekoračen broj znakova!',
  'API_RESPONSE_ERROR.SESSION_EXPIRED': 'Sesija je istekla!',
  'API_RESPONSE_ERROR.UNAUTHORIZED': 'Neovlašten zahtjev!',
  'API_RESPONSE_ERROR.STORAGE_EXCEPTION': 'Nije moguće spremiti dokument!',
  'API_RESPONSE_ERROR.BAD_REQUEST': 'Pogrešan zahtjev!',
  'API_RESPONSE_ERROR.FILE_NOT_IMAGE': 'Samo PNG, JPG i JPEG tipovi su dopušteni!',
  'API_RESPONSE_ERROR.ACTIVITY_BACKEND_ERROR': 'Back-end greška aktivnosti!',
  'API_RESPONSE_ERROR.ACTIVITY_ACTION_NO_PERMISSION': 'Nemate ovlasti za ovaj tip radnje!',
  'API_RESPONSE_ERROR.REMOVE_COVER_IMAGE_FAILED': 'Neuspješno uklanjanje naslovne slike!',
  'API_RESPONSE_ERROR.OBJECT_NOT_FOUND': 'Objekt sa navedenim ID-em i tipom nije pronađen!',
  'API_RESPONSE_ERROR.TITLE_ALREADY_IN_USE': 'Naziv je već u upotrebi!',
  'API_RESPONSE_ERROR.REMOVE_FILE_RESOURCE_FAILED': 'Neuspješno uklanjanje dokumenta!',
  'API_RESPONSE_ERROR.ADD_FILE_RESOURCE_FAILED': 'Neuspješno dodavanje dokumenta!',
  'API_RESPONSE_ERROR.NON_EXISTING_CITY': 'Grad s navedenim ID-em ne postoji!',

  // ----------- Activity controller
  'EXTERNAL_EDUCATION_TEMPLATE.ACTIVITY.ERROR.NON_EXISTING_ACTIVITY': 'Aktivnost sa navedenim ID-em ne postoji!',
  'EXTERNAL_EDUCATION_TEMPLATE.ACTIVITY.ERROR.ACTIVITY_USER_ALREADY_PARTICIPANT': 'Korisnik je već sudionik u aktivnosti!',
  'EXTERNAL_EDUCATION_TEMPLATE.ACTIVITY.ERROR.ACTIVITY_EVALUATOR_ALREADY_ASSIGNED': 'Evaluator je već dodjeljen ovoj aktivnosti!',
  'EXTERNAL_EDUCATION_TEMPLATE.ACTIVITY.ERROR.INVALID_ACTIVITY_PHASE_TRANSITION': 'Nije moguće prijeći u sljedeću fazu!',
  'EXTERNAL_EDUCATION_TEMPLATE.ACTIVITY.ERROR.USER_NOT_ACTIVITY_PARTICIPANT': 'Korisnik nije sudionik aktivnosti s navedenim ID-em!',
  'EXTERNAL_EDUCATION_TEMPLATE.ACTIVITY.ERROR.PARTICIPANT_NOT_ALLOWED_TO_MOVE_ACTIVITY_TO_PROVIDED_PHASE': 'Sudioniku nije dopušteno premjestiti aktivnost u navedenu fazu!',
  'EXTERNAL_EDUCATION_TEMPLATE.ACTIVITY.ERROR.ACTIVITY_PHASE_TRANSITION_NOT_POSSIBLE': 'Nedostaju obvezni podaci za prelazak faze!',

  'EXTERNAL_EDUCATION_TEMPLATE.ACTIVITY.ERROR.ACTIVITY_NOT_IN_EVALUATION_PHASE': 'Aktivnost nije u fazi evaluacije!',

  // ----------- Coded grade public
  'CODEBOOK_GRADE.ERROR.NON_EXISTING_CODED_GRADE': 'Ocjena s navedenim ID-em ne postoji!',
  'CODEBOOK_GRADE.ERROR.CODED_GRADE_ALREADY_EXISTS': 'Ocjena s istim nazivom već postoji. Odaberite drugi naziv. ',

  // ----------- Comment
  'COMMENTS_VIEW.ERROR.NON_EXISTING_COMMENT': 'Komentar s navedenim ID-em ne postoji!',
  'COMMENTS_VIEW.ERROR.REMOVE_COMMENT_RESOURCE_FAILED': 'Uklanjanje datoteke iz komentara nije uspjelo!',
  'COMMENTS_VIEW.ERROR.ADD_VOTE_FAILED': 'Dodavanje oznake komentaru nije uspjelo!',
  'COMMENTS_VIEW.ERROR.REMOVE_VOTE_FAILED': 'Uklanjanje oznake komentaru nije uspjelo!',

  // ----------- Course
  'COURSE.ERROR.NON_EXISTING_CREATION_STATUS': 'Status kreiranja s navedenim ID-em ne postoji!',
  'COURSE.ERROR.NON_EXISTING_COURSE_GROUP': 'Grupa tečajeva s navedenim ID-em ne postoji!',
  'COURSE.ERROR.NON_EXISTING_EXAM_TEMPLATE': 'Predložak provjere znanja s navedenim ID-em ne postoji',
  'COURSE.ERROR.COURSE_ALREADY_EXISTS': 'Tečaj s istim nazivom već postoji. Odaberite drugi naziv. ',
  'COURSE.ERROR.FAILED_DISENROLLING_TRAINEES': 'Ispisivanje polaznika nije uspjelo!',
  'COURSE.ERROR.RESOURCE_HAS_NO_CONTENT': 'Sadržaj resursa ne postoji!',
  // ----------- Course groups
  'COURSE.ERROR.COURSE_GROUP_ALREADY_EXISTS': 'Grupa tečajeva s istim nazivom već postoji. Odaberite drugi naziv. ',
  'COURSE.ERROR.DELETING_COURSE_GROUP_NOT_POSSIBLE': 'Nije moguće obrisati tečajnu grupu!',

  // ----------- Education category
  'EDUCATION_CATEGORY.ERROR.EDUCATION_CATEGORY_ALREADY_EXIST': 'Kategorija programa s istim nazivom već postoji. Odaberite drugi naziv. ',
  'EDUCATION_CATEGORY.ERROR.NON_EXISTING_EDUCATION_CATEGORY': 'Kategorija obrazovanja s navedenim ID-em ne postoji!',

  // ----------- Education group
  'EDUCATION_GROUP.ERROR.EDUCATION_GROUP_ALREADY_EXISTS': 'Program obrazovanja s istim nazivom već postoji. Odaberite drugi naziv.',
  'EDUCATION_GROUP.ERROR.NON_EXISTING_EDUCATION_GROUP': 'Program obrazovanja s navedenim ID-em ne postoji!',
  'EDUCATION_GROUP.ERROR.EDUCATION_ITEM_ALREADY_IN_EDUCATION_GROUP': 'Stavka obrazovanja je već u kategoriji obrazovanja!',

  // ----------- Education outcome
  'EDUCATION_OUTCOME.ERROR.NON_EXISTING_EDUCATION_OUTCOME': 'Ishod obrazovanja s navedenim ID-em ne postoji!',
  'EDUCATION_OUTCOME.ERROR.EDUCATION_OUTCOME_ALREADY_EXISTS': 'Ishod obrazovanja s istim nazivom već postoji. Odaberite drugi naziv.',

  // ----------- Education qualification
  'EDUCATION_QUALIFICATION.ERROR.EDUCATION_QUALIFICATION_ALREADY_EXISTS': 'Razina obrazovanja s istim nazivom već postoji. Odaberite drugi naziv.',
  'EDUCATION_QUALIFICATION.ERROR.NON_EXISTING_EDUCATION_QUALIFICATION': 'Razina obrazovanja s navedenim ID-em ne postoji!',

  // ----------- Education sector
  'EDUCATION_SECTOR.ERROR.EDUCATION_SECTOR_ALREADY_EXIST': 'Obrazovni sektor  s istim nazivom već postoji. Odaberite drugi naziv. ',

  // ----------- Email template
  'EMAIL_TEMPLATE.ERROR.NON_EXISTING_EMAIL_TEMPLATE': 'Predložak e-pošte s navedenim ID-em ne postoji!',
  'EMAIL_TEMPLATE.ERROR.NON_EXISTING_EMAIL_TEMPLATE_TYPE': 'Nepostojeći tip predloška e-pošte!',
  'EMAIL_TEMPLATE.ERROR.TITLE_ALREADY_IN_USE': 'E-mail predložak s istim nazivom već postoji. Odaberite drugi naziv. ',

  // ----------- Enrollment sector
  'ENROLLMENT_REQUIREMENT.ERROR.ENROLLMENT_REQUIREMENT_ALREADY_EXIST': 'Uvjet za upis s istim nazivom već postoji. Odaberite drugi naziv.',
  'ENROLLMENT_REQUIREMENT.ERROR.NON_EXISTING_ENROLLMENT_REQUIREMENT': 'Uvjet za upis s navedenim ID-em ne postoji!',

  // ----------- Exam instance
  'EXAM_INSTANCE.ERROR.NON_EXISTING_EXAM_INSTANCE': 'Instanca ispita s navedenim ID-em ne postoji!',
  'EXAM_INSTANCE.ERROR.ACTIVITY_USER_NOT_PARTICIPANT': 'Korisnik nije sudionik aktivnosti!',
  'EXAM_INSTANCE.ERROR.EXAM_INSTANCE_ALREADY_EXISTS': 'Provjera znanja s istim nazivom već postoji. Odaberite drugi naziv.',
  'EXAM_INSTANCE.ERROR.NON_EXISTING_QUESTION': 'Pitanje s navedenim ID-em ne postoji.',
  'EXAM_INSTANCE.ERROR.NON_EXISTING_SUBMISSION': 'Nema predane provjere znanja za navedeni ID',

  // ----------- Exam template
  'EXAM_TEMPLATE.ERROR.NON_EXISTING_COLLECTION': 'Kolekcija s navedenim ID-em ne postoji!',
  'EXAM_TEMPLATE.ERROR.NON_EXISTING_EXAM_TEMPLATE': 'Predložak provjere znanja s navedenim ID-em ne postoji',
  'EXAM_TEMPLATE.ERROR.EXAM_REVISION_NOT_ALLOWED': 'Ponovno polaganje provjere znanja nije dopuštena!',
  'EXAM_TEMPLATE.ERROR.EXAM_TEMPLATE_WITHOUT_QUESTION_POOL': 'Predložak provjere znanja nema skup pitanja',

  // ----------- External content
  'EXTERNAL_CONTENT.ERROR.NON_EXISTING_EXTERNAL_CONTENT': 'Vanjski sadržaj s navedenim ID-em ne postoji!',

  // ----------- External education application
  'EXTERNAL_EDUCATION_APPLICATION.ERROR.NON_EXISTING_EXTERNAL_EDUCATION_APPLICATION': 'Program obrazovanja s navedenim ID-em ne postoji!',
  'EXTERNAL_EDUCATION_APPLICATION.ERROR.ACTIVITY_NOT_IN_THE_RIGHT_PHASE': 'Aktivnost nije u ispravoj fazi!',
  'EXTERNAL_EDUCATION_APPLICATION.ERROR.PAYMENT_ALREADY_REQUESTED': 'Zatraživanje uplate je poslano',

  // ----------- External education instance
  'EXTERNAL_EDUCATION_INSTANCE.ERROR.INVALID_STATUS': 'Nevažeći status!',
  'EXTERNAL_EDUCATION_INSTANCE.ERROR.EXTERNAl_EDUCATION_TEMPLATE_INVALID_STATUS': 'Program obrazovanja nije u ispravnom statusu!',
  'EXTERNAL_EDUCATION_INSTANCE.ERROR.MANDATORY_FIELD_INVALID_VALUE': 'Obavezno polje sadrži nevažeću vrijednost!',
  'EXTERNAL_EDUCATION_INSTANCE.ERROR.NON_EXISTING_EXTERNAL_EDUCATION_INSTANCE': 'Način izvođenja programa obrazovanja s navedenim ID-em ne postoji!',
  'EXTERNAL_EDUCATION_INSTANCE.ERROR.NON_EXISTING_EXECUTION_METHOD': 'Metoda izvršenja s navedenim ID-em ne postoji!',
  'EXTERNAL_EDUCATION_INSTANCE.ERROR.NON_EXISTING_EXTERNAL_EDUCATION_TEMPLATE': 'Predložak programa obrazovanja s navedenim ID-em ne postoji!',
  'EXTERNAL_EDUCATION_INSTANCE.ERROR.NON_EXISTING_CREATION_STATUS': 'Status kreiranja s navedenim ID-em ne postoji!',
  'EXTERNAL_EDUCATION_INSTANCE.ERROR.NON_EXISTING_EXTERNAL_EDUCATION_APPLICATION': 'Program obrazovanja s navedenim ID-em ne postoji!',
  'EXTERNAL_EDUCATION_INSTANCE.ERROR.EXTERNAL_EDUCATION_INSTANCE_NOT_IN_CREATION_STATUS': 'Način izvođenja programa obrazovanja nije u statusu kreiranja!',

  // ----------- External education template
  'EXTERNAL_EDUCATION_TEMPLATE.ERROR.NON_EXISTING_ORGANIZATION_PROFILE': 'Profil organizacije ne postoji!',
  'EXTERNAL_EDUCATION_TEMPLATE.ERROR.INACTIVE_ORGANIZATION_PROFILE': 'Profil organizacije nije aktivan!',
  'EXTERNAL_EDUCATION_TEMPLATE.ERROR.NON_EXISTING_EDUCATION_OUTCOME': 'Ishod obrazovanja s navedenim ID-em ne postoji!',
  'EXTERNAL_EDUCATION_TEMPLATE.ERROR.NON_EXISTING_EXTERNAL_EDUCATION_TEMPLATE': 'Predložak programa obrazovanja s navedenim ID-em ne postoji!',
  'EXTERNAL_EDUCATION_TEMPLATE.ERROR.NON_EXISTING_CREATION_STATUS': 'Status kreiranja s navedenim ID-em ne postoji!',
  'EXTERNAL_EDUCATION_TEMPLATE.ERROR.EXTERNAL_EDUCATION_TEMPLATE_NOT_IN_CREATION_STATUS': 'Predložak programa obrazovanja nije u statusu kreiranja!',

  // ----------- Lecture
  'LECTURE_GROUP.ERROR.NON_EXISTING_LECTURE_GROUP': 'Grupe lekcija s navedenim ID-em ne postoji!',
  'LECTURE_GROUP.ERROR.NON_EXISTING_LECTURE': 'Lekcija s navedenim ID-em ne postoji!',
  'LECTURE_GROUP.ERROR.LECTURE_GROUP_ALREADY_EXISTS': 'Grupa lekcije s istim nazivom već postoji. Odaberite drugi naziv.',
  'LECTURE_GROUP.ERROR.LECTURE_ALREADY_EXISTS': 'Lekcija s istim nazivom već postoji. Odaberite drugi naziv.',

  'LECTURE_GROUP.ERROR.COURSE_NOT_IN_CREATION_PROCESS': 'Tečaj nije u procesu kreiranja!',
  'LECTURE_GROUP.ERROR.LECTURE_GROUP_IN_OTHER_COURSE': 'Tečaj nije u procesu kreiranja!',
  'LECTURE_GROUP.ERROR.NON_EXISTING_INTEGRATION_OBJECT': 'Traženi video ne postoji',
  'LECTURE_GROUP.ERROR.LECTURE_LOCKED': 'Lekcija je zaključana!',

  // ----------- Location
  'LOCATION.ERROR.NON_EXISTING_LOCATION': 'Lokacija s navedenim ID-em ne postoji!',
  'LOCATION.ERROR.NON_EXISTING_LOCATION_TYPE': 'Tip lokacije s navedenim ID-em ne postoji!',

  // ----------- Note
  'USER_NOTES.ERROR.NON_EXISTING_NOTE': 'Bilješka ne postoji!',
  'USER_NOTES.ERROR.USER_HAS_NO_NOTES': 'Korisnik nema bilješki!',
  'USER_NOTES.ERROR.ERROR_GENERATING_PDF': 'Nije moguće generirati PDF!',

  // ----------- Notification
  'NOTIFICATION.ERROR.NON_EXISTING_NOTIFICATION': 'Obavijest s navedenim ID-em ne postoji!',
  'NOTIFICATION.ERROR.NON_EXISTING_NOTIFICATION_TYPE': 'Nepostojeći tip obavijesti!',

  // ----------- Organization configuration
  'ORGANIZATION.ERROR.NON_EXISTING_CONFIGURATION': 'Konfiguracija ne postoji za trenutnog tenant-a!',
  'ORGANIZATION.ERROR.NON_EXISTING_CONFIGURATION_TYPE': 'Tip konfiguracije ne postoji!',
  'ORGANIZATION.ERROR.CONFIGURATION_ALREADY_EXISTS': 'Konfiguracija već postoji!',

  // ----------- Organization profiles
  'ORGANIZATION.ERROR.NON_EXISTING_COMPANY': 'Tvrtka s navedenim ID-em ne postoji!',
  'ORGANIZATION.ERROR.COMPANY_ALREADY_EXISTS': 'Tvrtka već postoji!',
  'ORGANIZATION.ERROR.ORGANIZATION_PROFILE_ALREADY_EXISTS': 'Profil organizacije već postoji!',
  'ORGANIZATION.ERROR.ROLE_NOT_FOUND': 'Uloga s navedenim ID-em ne postoji!',
  'ORGANIZATION.ERROR.USER_ALREADY_ORGANIZATION_PROFILE_MEMBER': 'Korisnik je već dio organizacije.',
  'ORGANIZATION.ERROR.NON_EXISTING_ORGANIZATION_PROFILE': 'Šifra ne odgovara niti jednoj organizaciji u sustavu',

  // ----------- Progress tracker
  'PROGRESS_TRACKER.ERROR.NON_EXISTING_PROGRESS_TRACKER': 'Praćenje napretka ne postoji!',

  // ----------- Reminder
  'REMINDER.ERROR.NON_EXISTING_REMINDER': 'Podsjetnik s navedenim ID-em ne postoji!',
  'REMINDER.ERROR.NON_EXISTING_REMINDER_TYPE': 'Nepostojeći tip podsjetnika!',

  // ----------- Report
  'REPORT.ERROR.REPORT_IS_BEING_CREATED': 'Izvješće s navedenim tipom je već u izradi ili u redu čekanja!',
  'REPORT.ERROR.QUEUE_OVERFLOW': 'Prekoračenje broja radnji! Pričekajte da radnje završe.',
  'REPORT.ERROR.NON_EXISTING_REPORT_TYPE': 'Tip izvješća s navedenim ID-em ne postoji!',
  'REPORT.ERROR.NON_EXISTING_REPORT': 'Izvješće s navedenim ID-em ne postoji!',
  'REPORT.ERROR.REPORT_NOT_CREATED': 'Izvješće s navedenim ID-em se kreira!',

  // ---------- Create user error
  'CREATE_USER.ERROR.USER_WITHOUT_EMAIL': 'Korisnik bez email-a',
  'CREATE_USER.ERROR.KEYCLOAK_EMAIL_EXISTS': 'Korisnik s navedenom e-mail adresom već postoji',
  'CREATE_USER.ERROR.KEYCLOAK_USERNAME_EXISTS': 'Korisnik s navedenim korisničkim imenom već postoji',

  // ---------- User group
  'USER_GROUP.ERROR.NON_EXISTING_USER_GROUP': 'Pristupni kod ne odgovara nijednoj dostupnoj grupi u sustavu!',
  'USER_GROUP.ERROR.USER_ALREADY_GROUP_MEMBER': 'Korisnik je već član grupe.',
  'USER_GROUP.ERROR.MEMBER_NOT_FOUND': 'Korisnik nije član grupe s navedenim ID-em!',
  'USER_GROUP.ERROR.OBJECT_ALREADY_IN_GROUP': 'Objekt s navedenim ID-em i tipom već postoji u grupi.',
  'USER_GROUP.ERROR.LAST_GROUP_OWNER': 'Dodijelite ulogu vlasnika drugom korisniku pa pokušajte ponovo!',
  'USER_GROUP.ERROR.ROLE_NOT_FOUND': 'Uloga s navedenim ID-em ne postoji!',
  'USER_GROUP.ERROR.NON_EXISTING_USER_GROUP_TYPE': 'Tip korisničke grupe s navedenim ID-em ne postoji!',
  'USER_GROUP.ERROR.INVALID_GROUP_PARENT': 'Neispravna nadređena grupa!',
  'USER_GROUP.ERROR.USER_ALREADY_MEMBER_OF_ORGANIZATION_GROUP': 'Korisnik je već član organizacijske grupe!',
  'USER_GROUP.ERROR.NO_ORGANIZATION_HIERARCHY': 'Hierarhija organizacije nije definirana- nedostaje korijenska grupa.',

  // ----------- Webinar
  'WEBINAR.ERROR.NON_EXISTING_WEBINAR': 'Webinar sa navedenim ID-em ne postoji!',
  'WEBINAR.ERROR.WEBINAR_ALREADY_EXISTS': 'Webinar s istim nazivom već postoji. Odaberite drugi naziv.',
  'WEBINAR.ERROR.NON_EXISTING_WEBINAR_STATUS': 'Ne postojeći status webinara',

  // ----------- Workposition
  'WORKPOSITION.ERROR.NON_EXISTING_WORK_POSITION': 'Radno mjesto s navedenim ID-em ne postoji!',
  'WORKPOSITION.ERROR.WORK_POSITION_ALREADY_EXIST': 'Radno mjesto s istim nazivom već postoji. Odaberite drugi naziv.',

  // ----------- LDAP sync
  'LDAP.ERROR.LDAP_SYNC_IN_PROCESS': 'LDAP sinkronizacija je u tijeku',

  // ----------- User category
  'USER_CATEGORY_CREATE.ERROR.USER_CATEGORY_ALREADY_EXISTS': 'Kategorija korisnika s istim nazivom već postoji. Odaberite drugi naziv.',
};
export default hr;
